import React, { Component } from "react";
import {
  Button,
  Container,
  Row,
  Form,
  Col,
  Offcanvas,
  Table,
  Modal,
} from "react-bootstrap";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import configData from "../config.json";
import CreatableSelect from "react-select/creatable";
import LoadingOverlay from "./LoadingOverlay";
export default class RulePage extends Component {
  constructor(props) {
    super(props);
    this.inputFileRef = React.createRef();
    this.state = {
      loading: false,
      loadingMessage: "Processing your request...",
      show: false,
      showOne: false,
      showTwo: false,
      message: "",
      sId: sessionStorage.getItem("sessionId"),
      uId: sessionStorage.getItem("uId"),
      apis: [],
      templates: [],
      rules: [],
      tables: [],
      columns: [],
      rcolumns: [],
      columnsWT: [],
      conditions: [],
      actions: [],
      updateactions: [],
      apiactions: [],
      rulegroup: [],
      options: [],
      optionsoutput: [],
      integrationtype: [],
      Emailtemplate: [],
      Smstemplates: [],
      triggerEvents: ["insert", "update", "delete"],
      outputparams: "",
      rConditions: {
        tableName: "",
        outputparams: "",
        cOperator: "",
        cdate: "",
        ctime: "",
        cValue: "",
        cGate: "",
        currentPage: 1,
      },
      rulescondition: [
        {
          //   id: Date.now(),
          //   // rtTableName: "--",
          //   // rtColumnName: "--",
          //   // rtTemplate: "--",
          //   // rtType: "--",
          //   // rtGate: "--",
          //   // visibletype: "",
          //   actions: [],
          //   updateactions: [],
          //   apiactions: [],
          //   //currentPage: 1,
        },
      ],
      updateRows: [
        {
          id: 0,
          [`rtUpdateColumnName`]: "",
          [`rtUpdateOperator`]: "",
          [`rtUpdateValue`]: "",
        },
      ],
      updateSetRows: [
        {
          id: 0,
          [`rtUpdatesetcolumn`]: "",
          [`rtUpdateSetOperator`]: "",
          [`rtUpdateGate`]: "",
          [`rtUpdateValuetwo`]: "",
        },
      ],
      visibletype: "",
      disabledTables: {},
      rActions: {
        tableName: "",
        columnName: "",
        rtTableName: "--",
        rtColumnName: "--",
        rtValue: "",
        rtGate: "--",
        rtUpdateTableName: "--",
        rtUpdateColumnName: "--",
        rtUpdateOperator: "--",
        rtUpdateValue: "",
        rtUpdateGate: "--",
        rtUpdatesetTable: "",
        rtUpdatesetcolumn: "",
        rtUpdateSetOperator: "",
        rtUpdateValuetwo: "",
        rtApiTemplate: "--",
        rtApiName: "--",
        rtApiReqId: "",
        rtApiValue: "--",
        rtTemplate: "--",
        rtType: "--",
        rtEmailTemplates: "",
        rtemailParams: "",
        rtSmsTemplates: "",
        rtsmsparams: "",
        rtsmsName: "",
        currentPage: 1,
      },
      rDate: {
        rDateTableName: "--",
        rDateColumnName: "--",
        rDateTemplate: "--",
        rDateType: "--",
        rDateGate: "--",
        currentPage: 1,
      },
      receive_parameters: [],
      send_parameters: [],
      // offcanvas form control data
      ruleData: {
        rulegroup: "",
        rulesdef_Id: "",
        rulegroupId: "",
        name: "",
        description: "",
        isActive: "",
        priority: "",
        executionOrder: "",
        conditionlogicId: "",
        version: "",
        ruleinputparameters: "",
        ruleoutputparameters: "",
        currentPage: 1,
      },
      errors: {},
      editingIndex: -1,
      filteredData: null,
      rulesdef_Id: "",
      rulegroupId: "",
      name: "",
      description: "",
      isActive: "",
      priority: "",
      executionOrder: "",
      conditionlogicId: "",
      version: "",
      ruleinputparameters: "",
      ruleoutputparameters: "",
      tableClms: [
        {
          name: "S.NO",
          selector: (row, i) => row.rulesdef_Id,
          sortable: true,
          cell: (row) => <span>{row.rulesdef_Id}</span>,
        },
        {
          name: "Rule Group Id",
          selector: (row, i) => row.rulegroupId,
          sortable: true,
          cell: (row) => <span>{row.rulegroupId}</span>,
        },
        {
          name: "Name",
          selector: (row, i) => row.name,
          sortable: true,
          cell: (row) => <span>{row.name}</span>,
        },
        {
          name: "Description",
          selector: (row, i) => row.description,
          sortable: true,
          cell: (row) => <span>{row.description}</span>,
        },
        {
          name: "Version",
          selector: (row, i) => row.version,
          sortable: true,
          cell: (row) => <span>{row.version}</span>,
        },
        {
          name: "rule inputparameters",
          selector: (row, i) => row.ruleinputparameters,
          sortable: true,
          cell: (row) => <span>{row.ruleinputparameters}</span>,
        },
        {
          name: "ruleoutputparameters",
          selector: (row, i) => row.ruleoutputparameters,
          sortable: true,
          cell: (row) => <span>{row.ruleoutputparameters}</span>,
        },

        //***tableClms
        {
          name: "Actions",
          sortable: false,
          cell: (row) => (
            <div>
              {/* edit button and delete button */}
              <Button
                style={{ marginRight: "10px" }}
                variant="primary"
                onClick={() => this.handleEnterEditMode(row)}
                className="bi bi-pen"
              ></Button>
              <Button
                variant="danger"
                onClick={() => this.handleDelete(row)}
                className="bi bi-trash danger"
              ></Button>
            </div>
          ),
        },
      ],
      currentPage: 1,
      itemsPerPage: 10,
      isEditing: false,
      isNewEntry: false,
      selectedTableColumns: [],
      inputParamsArray: [],
      testcases: [],
      whereByIndex: {},
      editingByIndex: {},
      inputByIndex: {}, // Individual input fields per table
      rConditionsNew: {
        tableNameNew: "",
        columnNew: "",
        cOperatorNew: "",
        cValueNew: "",
        cGateNew: "",
      },
      sendingData: {
        tableName: "",
        columnName: "",
        currentStep: 1,
      },
      rcolumnsWhereone: [],
      rcolumnsWhereonesms: [],
      newWhereColumns: [],
      newWhereColumnsone: [],
      newWhereColumnsonesms: [],
      rcolumnsWhere: [],
      columnNamewhere: "",
      columnsmswhere: "",
      sendingDataone: {
        tableName: "",
        columnName: "",
        currentStep: 1,
      },
      whereByIndexSms: {},
      editingByIndexSms: {},
      inputByIndexSms: {}, // Individual input fields per SMS table
      rConditionsNewone: {
        tableNameNewone: "",
        columnNewone: "",
        cOperatorNewone: "",
        cValueNewone: "",
        cGateNewone: "",
      },
      whereState: {},
      whereStateSms: {}, // Individual state for SMS WHERE dropdowns per table
    };
  }
  //edit
  handleEnterEditMode = (row) => {
    // this.setState({ cData: { ...row }, isEditing: true });
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    this.setState({
      // rId: row.rId,
      rulesdef_Id: row.rulesdef_Id,
      rulegroupId: row.rulegroupId,
      name: row.name,
      description: row.description,
      isActive: row.isActive,
      priority: row.priority,
      executionOrder: row.executionOrder,
      conditionlogicId: row.conditionlogicId,
      version: row.version,
      ruleinputparameters: row.ruleinputparameters,
      ruleoutputparameters: row.ruleoutputparameters,
      receive_parameters: row.receive_parameters,
      send_parameters: row.send_parameters,
      // rConditions: {
      //   tableName: row.send_parameters[0].tableName,
      //   columnName: row.send_parameters[0].columnName,
      //   cOperator: row.send_parameters[0].cOperator,
      //   cdate: row.send_parameters[0].cdate,
      //   ctime: row.send_parameters[0].ctime,
      //   cValue: row.send_parameters[0].cValue,
      //   cGate: row.send_parameters[0].cGate,
      // },
      // rActions: {
      //   rtTableName: "row.rtTableName",
      //   rtColumnName: "row.rtColumnName",
      //   rtTemplate: "row.rtTemplate",
      //   rtType: "row.rtType",
      //   rtGate: "row.rtGate",
      //   currentPage: 1,
      // },
      // rDate: {
      //   rDateTableName: "row.rDateTableName",
      //   rDateColumnName: "row.rDateColumnName",
      //   rDateTemplate: "row.rDateTemplate",
      //   rDateType: "row.rDateType",
      //   rDateGate: "row.rDateGate",
      //   currentPage: 1,
      // },
      isEditing: true,
    });
  };
  //modal
  handleButtonClick = () => {
    this.inputFileRef.current.click();
  };
  handleCloseOne = () => {
    this.setState({ showOne: false });
  };

  handleShowOne = () => {
    this.setState({ showOne: true });
  };
  // offcanvas Open
  handleShow = () => {
    this.setState({
      show: true,
      rId: "",
      rConditions: {
        tableName: "",
        columnName: "",
        cOperator: "",
        cdate: "",
        ctime: "",
        cValue: "",
        cGate: "",
        currentPage: 1,
      },
      rActions: [
        {
          rtTableName: "--",
          rtColumnName: "--",
          rtTemplate: "--",
          rtType: "--",
          rtGate: "--",
          currentPage: 1,
        },
      ],
      rDate: {
        rDateTableName: "--",
        rDateColumnName: "--",
        rDateTemplate: "--",
        rDateType: "--",
        rDateGate: "--",
        currentPage: 1,
      },
      receive_parameters: [],
      send_parameters: [],
      ruleData: {
        rulegroup: "",
        rulesdef_Id: "",
        rulegroupId: "",
        name: "",
        description: "",
        isActive: "",
        priority: "",
        executionOrder: "",
        conditionlogicId: "",
        version: "",
        ruleinputparameters: "",
        ruleoutputparameters: "",
        currentPage: 1,
      },
      actions: [],
      showCustomEmailInput: {},
      showCustomSmsInput: {},
    });
  };
  // Offcanvas close button
  handleClose = () => {
    this.setState({ show: false });
  };
  handleEditInputChangeParamz(index, field, value) {
    const updatedParamz = [...this.state.conditions];
    updatedParamz[index][field] = value;
    this.getColumns(value, "rcolumns");
    this.setState({ conditions: updatedParamz });
  }
  handleEditInputChangeParamzs(index, field, value) {
    const updatedParamz = [...this.state.conditions];
    updatedParamz[index][field] = value;
    this.getColumns(value, "rcolumns");
    this.setState({ conditions: updatedParamz });
  }
  handleEditTableRowParamz(index) {
    this.setState({ editingIndex: index });
  }
  addSendRow = (e) => {
    e.preventDefault();

    if (this.keyvalidate()) {
      this.setState((prevState) => ({
        conditions: [...prevState.conditions, this.state.rConditions],
      }));

      this.setState(
        (prevState) => ({
          rConditions: {
            ...prevState.rConditions,
            tableName: "",
            cOperator: "",
            cdate: "",
            ctime: "",
            cValue: "",
            cGate: "",
          },
        }),
        () => {
          ////console.log(this.state.rConditions);
        }
      );
    }
  };
  updateSendParamz = (e) => {
    e.preventDefault();
    this.setState({ editingIndex: -1 });
    this.setState(
      (prevState) => ({
        testcases: Array.isArray(prevState.testcases)
          ? [...prevState.testcases]
          : [],
      }),
      () => {
        this.setState({
          ittasks_Id: "",
          testcase_title: "",
          testcase_description: "",
          testcasetypemaster: [],
          testcase_type: "Functional",
          testcaseprioritymaster: [],
          priority: "Medium",
          expected_result: "",
          test_steps: "",
          assigned_to: "",
          testcasestatusmaster: [],
          status: "",
          execution_notes: "",
          failurereason: "",
          executed_by: "",
          executed_on: "",
          estimated_hours: "",
          actual_hours: "",
          environmentmaster: [],
          environment: "Development",
        });
      }
    );
  };
  keyvalidate() {
    const { currentStep, rConditions } = this.state;
    let formIsValid = true;
    if (!rConditions["tableName"]) {
      formIsValid = false;
      toast.info("*Enter Input params.");
    } else if (!rConditions["cOperator"]) {
      formIsValid = false;
      toast.info("* Select Operator.");
    } else if (!rConditions["cValue"]) {
      formIsValid = false;
      toast.info("* Enter Operator.");
    } else if (!rConditions["cGate"]) {
      formIsValid = false;
      toast.info("* Select Gate.");
    } else {
      this.setState({ currentStep: currentStep + 1 });
    }
    return formIsValid;
  }

  handleColumnChange = (e) => {
    e.preventDefault();
    const fieldName = e.target.getAttribute("name");
    const fieldValue = e.target.value;
    const inputData = this.state.rConditions;
    const selectedLabel = e.target.options[e.target.selectedIndex].text;
    inputData[fieldName] = selectedLabel;
    this.setState({ columnValue: fieldValue });
    ////console.log(fieldValue);
  };

  inputSChange = (e) => {
    e.preventDefault();
    const fieldName = e.target.getAttribute("name");
    const fieldValue = e.target.value;
    const inputData = this.state.rConditions;
    inputData[fieldName] = fieldValue;
    this.setState({ rConditions: inputData });
    //this.setState({visibletype: e.target.value})
  };
  inputtableSChange = (e) => {
    e.preventDefault();
    const fieldName = e.target.getAttribute("name");
    const fieldValue = e.target.value;
    const inputData = this.state.rConditions;
    inputData[fieldName] = fieldValue;
    this.setState({ rConditions: inputData });
    //this.getColumnsWT(fieldValue, "columns");
  };

  inputtableSChangewheresms = (e) => {
    e.preventDefault();

    const fieldName = e.target.name; // tableName
    const fieldValue = e.target.value;

    // Correctly update UI value
    this.setState((prev) => ({
      tableName: fieldValue,
      sendingDataone: {
        ...prev.sendingDataone,
        [fieldName]: fieldValue,
      },
    }));

    // Fetch columns
    this.getColumns(fieldValue, "rcolumnsWhereone");
  };
  inputSChangewhere = (e) => {
    // e.preventDefault();
    // const fieldName = e.target.getAttribute("name");
    // const fieldValue = e.target.value;
    // const inputData = this.state.sendingData;
    // inputData[fieldName] = fieldValue;
    // this.setState({ sendingData: inputData });
    const { name, value } = e.target;
    this.setState((prev) => ({
      sendingData: {
        ...prev.sendingData,
        [name]: value,
      },
      columnNamewhere: value, // Important: update value bound to <select>
    }));
  };
  inputSChangesmswheresms = (e) => {
    e.preventDefault();
    const fieldName = e.target.getAttribute("name");
    const fieldValue = e.target.value;
    const inputData = this.state.sendingDataone;
    inputData[fieldName] = fieldValue;
    this.setState({ sendingDataone: inputData });
  };

  inputSChangesmswhere = (e) => {
    const { name, value } = e.target;

    this.setState((prev) => ({
      sendingDataone: {
        ...prev.sendingDataone,
        [name]: value,
      },
      columnsmswhere: value, // Important: update value bound to <select>
    }));
  };

  inputtableSEmailChange = (e) => {
    e.preventDefault();
    const fieldName = e.target.getAttribute("name");
    const fieldValue = e.target.value;
    const inputData = this.state.rulesConditions;
    inputData[fieldName] = fieldValue;
    this.setState({ rulesConditions: inputData });
    //this.getColumnsWT(fieldValue, "columns");
  };
  inputSParmsChange = (e) => {
    e.preventDefault();
    const fieldName = e.target.getAttribute("name");
    const fieldValue = e.target.value;
    const inputData = this.state.rulesConditions;
    inputData[fieldName] = fieldValue;
    this.setState({ rulesConditions: inputData });
  };
  handleRemoveSpecificRowS = (idx) => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    const tempRows = this.state.conditions; // Create a copy of the array
    tempRows.splice(idx, 1); // Remove the row at the specified index
    this.setState({ conditions: tempRows });
  };
  // Offcanvas Formchange
  inputChange = (e) => {
    e.preventDefault();
    const fieldName = e.target.getAttribute("name");
    const fieldValue = e.target.value;
    const newFormData = this.state.ruleData;
    newFormData[fieldName] = fieldValue;
    this.setState({ ruleData: newFormData });
  };
  inputChangeemail = (e, index) => {
    e.preventDefault();
    const fieldName = e.target.getAttribute("name");
    const fieldValue = e.target.value;
    this.setState((prevState) => {
      const updatedRows = Array.isArray(prevState.rActions)
        ? [...prevState.rActions]
        : [];
      if (!updatedRows[index]) {
        updatedRows[index] = {};
      }
      updatedRows[index] = {
        ...updatedRows[index],
        [fieldName]: fieldValue,
      };
      return { rActions: updatedRows };
    });
  };
  handleversionChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ version: fieldValue });
  };
  handleruleinpurChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ ruleinputparameters: fieldValue });
  };
  handleruleoutputChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ ruleoutputparameters: fieldValue });
  };
  handleinputparamsChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;

    // Split input parameters by comma and trim spaces
    const inputParamsArray = fieldValue
      .split(",")
      .map((param) => param.trim())
      .filter((param) => param !== "");

    // Merge with existing table columns (if any)
    const mergedOptions = [
      ...inputParamsArray,
      ...(this.state.selectedTableColumns || []),
    ];

    this.setState({
      tableName: fieldValue,
      inputParamsArray: inputParamsArray,
      options: mergedOptions, // Update options immediately
    });
  };
  handleinputSelect = (e) => {
    const fieldValue = e.target.value;

    // Split input parameters by comma and trim spaces
    const inputParamsArray = fieldValue
      .split(",")
      .map((param) => param.trim())
      .filter((param) => param !== "");

    // Merge with existing table columns (if any)
    const mergedOptions = [
      ...inputParamsArray,
      ...(this.state.selectedTableColumns || []),
    ];

    this.setState({
      inputParamsArray: inputParamsArray,
      options: mergedOptions, // Merge with existing columns
    });
  };

  handleoutputparamsChange = (e) => {
    const fieldValue = e.target.value;

    // Split output parameters by comma
    const outputParamsArray = fieldValue
      .split(",")
      .map((param) => param.trim())
      .filter((param) => param !== "");

    this.setState({ outputParamsArray });
  };

  handleoutputSelect = (e) => {
    const { outputparams } = this.state;
    if (!outputparams || outputparams.trim() === "") {
      this.setState({ optionsoutput: [] });
      return;
    }
    const outputparameters = outputparams.split(",");
    this.setState({
      optionsoutput: [...outputparameters],
      outputparams: "",
    });
  };

  handleinputSelects = (e) => {
    const { ruleinputparameters } = this.state;
    if (!ruleinputparameters || ruleinputparameters.trim() === "") {
      this.setState({ options: [] });
    }
    const inputparameters = ruleinputparameters.split(",");
    this.setState({
      options: [...inputparameters],
      tableruleinputparametersName: "",
    });
  };
  handleoutputparamsChanges = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ ruleoutputparameters: fieldValue });
  };
  handleoutputSelects = (e) => {
    const { ruleoutputparameters } = this.state;
    if (!ruleoutputparameters || ruleoutputparameters.trim() === "") {
      this.setState({ optionsoutput: [] });
      return;
    }
    const outputparameters = ruleoutputparameters.split(",");
    this.setState({
      optionsoutput: [...outputparameters],
      ruleoutputparameters: "",
    });
  };
  handleRemoveSpecificRowSAction = (idx) => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    const tempRows = this.state.actions;
    tempRows.splice(idx, 1);
    this.setState({ actions: tempRows });
  };
  // handleUpdateRemoveSpecific = (idx) => {
  //   var formData = new FormData();
  //   formData.append("sId", this.state.sId);
  //   formData.append("uId", this.state.uId);
  //   const tempRows = this.state.updateactions;
  //   tempRows.splice(idx, 1);
  //   this.setState({ updateactions: tempRows });
  // };
  handleApiRemoveSpecificRowSAction = (idx) => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    const tempRows = this.state.apiactions;
    tempRows.splice(idx, 1);
    this.setState({ apiactions: tempRows });
  };
  inputRChange = (e, index) => {
    e.preventDefault();
    const fieldName = e.target.getAttribute("name");
    const fieldValue = e.target.value;
    // this.setState((prevState) => ({
    //   rActions: {
    //     ...prevState.rActions,
    //     [fieldName]: fieldValue,
    //   },
    //   visibletype: fieldValue,
    // }));
    // this.setState((prevState) => {
    //   const updatedRows = [...prevState.rActions];
    //   updatedRows[index] = {
    //     ...updatedRows[index],
    //     [fieldName]: fieldValue, // Update the specific field
    //   };
    //   return { rActions: updatedRows, visibletype: fieldValue };
    // });
    this.setState((prevState) => {
      const updatedRows = [...prevState.rulescondition];
      updatedRows[index] = {
        ...updatedRows[index],
        [fieldName]: fieldValue,
        visibletype:
          fieldName === "rtType" ? fieldValue : updatedRows[index].visibletype,
      };
      return { rulescondition: updatedRows };
    });
  };
  inputChangeupdate = (e) => {
    e.preventDefault();
    const fieldName = e.target.getAttribute("name");
    const fieldValue = e.target.value;
    const newFormData = this.state.rActions;
    newFormData[fieldName] = fieldValue;
    this.setState({ rActions: newFormData });
  };
  inputtableRChange = (e, index) => {
    e.preventDefault();
    const fieldName = e.target.getAttribute("name");
    const fieldValue = e.target.value;
    this.setState((prevState) => ({
      rActions: {
        ...prevState.rActions,
        [fieldName]: fieldValue,
      },
      selectedTemplateName: fieldValue,
    }));
    this.getColumns(fieldValue, "rcolumns");
  };

  inputtablecreateRChange = (e, rowIndex) => {
    e.preventDefault();
    const fieldName = e.target.getAttribute("name");
    const fieldValue = e.target.value;

    // First update the selected table name in the state
    this.setState((prevState) => {
      const updatedRowData = { ...prevState.rowData };

      // Initialize row data if it doesn't exist
      if (!updatedRowData[rowIndex]) {
        updatedRowData[rowIndex] = {
          rtTableName: "--",
          rtColumnName: "--",
          rtValue: "--",
          rtGate: "--",
          rcolumns: [],
        };
      }

      // Update the table name for this specific row
      updatedRowData[rowIndex] = {
        ...updatedRowData[rowIndex],
        rtTableName: fieldValue,
        rtColumnName: "--", // Reset column selection when table changes
        rtValue: "--", // Reset value when table changes
      };

      return {
        rowData: updatedRowData,
        rActions: {
          ...prevState.rActions,
          [fieldName]: fieldValue,
        },
      };
    });

    // Then fetch columns and automatically populate the table
    this.getColumnsAndPopulateTable(fieldValue, rowIndex);
  };

  // New method to get columns and automatically populate the table
  getColumnsAndPopulateTable = (tableName, rowIndex) => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("tableName", tableName);

    fetch(configData.api_url + "/masters/getcolumns", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          // Store columns in row state
          this.setState((prevState) => {
            const updatedRowData = { ...prevState.rowData };

            updatedRowData[rowIndex] = {
              ...updatedRowData[rowIndex],
              rcolumns: data.columns,
            };

            // Create an updated rulescondition array
            const updatedRulescondition = [...prevState.rulescondition];

            // Create or update the row
            if (!updatedRulescondition[rowIndex]) {
              updatedRulescondition[rowIndex] = {
                id: Date.now(),
                visibletype: "Createtablerow",
                rtType: "Createtablerow",
                actions: [],
              };
            }

            // Clear existing actions for this row
            updatedRulescondition[rowIndex].actions = [];

            // Add an action for each column
            data.columns.forEach((column, columnIndex) => {
              const tableId = `table-${rowIndex}-${columnIndex}-${Date.now()}`;
              // Set initial values for I/O parameters, could be empty strings or default values
              const defaultValue = ""; // Or any default value you want

              const newAction = {
                id: Date.now() + columnIndex,
                tableId: tableId,
                rtTableName: tableName,
                rtColumnName: column,
                rtValue: defaultValue,
                rtGate: "--",
              };

              updatedRulescondition[rowIndex].actions.push(newAction);
            });

            return {
              rowData: updatedRowData,
              rulescondition: updatedRulescondition,
            };
          });
        }
      });
  };
  inputtableRsetChange = (e, index) => {
    e.preventDefault();
    const fieldName = e.target.getAttribute("name");
    const fieldValue = e.target.value;
    this.setState((prevState) => ({
      rActions: {
        ...prevState.rActions,
        [fieldName]: fieldValue,
      },
    }));
    this.getColumns(fieldValue, "rcolumns");
  };
  inputtableRsmsChange = (e, index) => {
    e.preventDefault();
    const fieldName = e.target.getAttribute("name");
    const fieldValue = e.target.value;
    this.setState((prevState) => ({
      rActions: {
        ...prevState.rActions,
        [fieldName]: fieldValue,
      },
      selectedTemplateName: fieldValue,
    }));
    this.getColumns(fieldValue, "rcolumns");
  };
  inputRColumnChange = (e) => {
    e.preventDefault();
    const fieldName = e.target.getAttribute("name");
    const fieldValue = e.target.value;
    const inputData = this.state.rActions;
    inputData[fieldName] = fieldValue;
    this.setState({ rActions: inputData });
  };
  inputRColumncreateChange = (value) => {
    this.setState((prevState) => ({
      rActions: {
        ...prevState.rActions,
        rtValue: value,
      },
    }));
  };
  inputupdateRColumnChange = (e, index) => {
    const fieldValue = e.target.value;
    const updateRows = [...this.state.updateRows];
    const keyName = `rtUpdateColumnName${index > 0 ? index : ""}`;
    updateRows[index][keyName] = fieldValue;
    this.setState({ updateRows });
  };
  inputsetRColumnChange = (e, index) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    const updateSetRows = [...this.state.updateSetRows];
    const keyName = `rtUpdatesetcolumn${index > 0 ? index : ""}`;
    updateSetRows[index][keyName] = fieldValue;
    this.setState({ updateSetRows });
  };
  inputupdateRoperatorChange = (e, index) => {
    const fieldValue = e.target.value;
    const updateRows = [...this.state.updateRows];
    const keyName = `rtUpdateOperator${index > 0 ? index : ""}`;
    updateRows[index][keyName] = fieldValue;
    this.setState({ updateRows });
  };
  inputsetRoperatorChange = (e, index) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    const updateSetRows = [...this.state.updateSetRows];
    const keyName = `rtUpdateSetOperator${index > 0 ? index : ""}`;
    updateSetRows[index][keyName] = fieldValue;
    this.setState({ updateSetRows });
  };
  inputRColumnupdateChange = (value, index) => {
    const updateRows = [...this.state.updateRows];
    const keyValue = `rtUpdateValue${index > 0 ? index : ""}`;
    updateRows[index][keyValue] = value;
    this.setState({ updateRows });
  };
  inputsetRColumnupdateChange = (value, index) => {
    const updateSetRows = [...this.state.updateSetRows];
    const keyValue = `rtUpdateValuetwo${index > 0 ? index : ""}`;
    updateSetRows[index][keyValue] = value;
    this.setState({ updateSetRows });
  };
  inputsetRGateupdateChange = (event, index) => {
    const value = event.target.value;
    const updateSetRows = [...this.state.updateSetRows];
    const keyValue = `rtUpdateGate${index > 0 ? index : ""}`;
    updateSetRows[index][keyValue] = value;
    this.setState({ updateSetRows });
  };

  addRow = () => {
    this.setState(
      (prevState) => {
        const newId = prevState.updateRows.length;
        const newRow = {
          id: newId,
          [`rtUpdateColumnName${newId > 0 ? newId : ""}`]: "",
          [`rtUpdateOperator${newId > 0 ? newId : ""}`]: "",
          [`rtUpdateValue${newId > 0 ? newId : ""}`]: "",
        };
        return { updateRows: [...prevState.updateRows, newRow] };
      },
      () => console.log("Updated Rows:", this.state.updateRows)
    );
  };

  addSetRow = () => {
    this.setState(
      (prevState) => {
        const newId = prevState.updateSetRows.length;
        const newRow = {
          id: newId,
          [`rtUpdatesetcolumn${newId > 0 ? newId : ""}`]: "",
          [`rtUpdateSetOperator${newId > 0 ? newId : ""}`]: "",
          [`rtUpdateValuetwo${newId > 0 ? newId : ""}`]: "",
          [`rtUpdateGate${newId > 0 ? newId : ""}`]: "",
        };
        return { updateSetRows: [...prevState.updateSetRows, newRow] };
      },
      () => console.log("Updated Rows:", this.state.updateSetRows)
    );
  };

  deleteRow = (index) => {
    const updateRows = [...this.state.updateRows];
    updateRows.splice(index, 1);
    this.setState({ updateRows });
  };
  deleteSetRow = (index) => {
    const updateSetRows = [...this.state.updateSetRows];
    updateSetRows.splice(index, 1);
    this.setState({ updateSetRows });
  };

  // inputRColumnupdateChange = (value) => {
  //   this.setState((prevState) => ({
  //     rActions: {
  //       ...prevState.rActions,
  //       rtUpdateValue: value,
  //     },
  //   }));
  // };
  // inputRColumnsetupdateChange = (value) => {
  //   this.setState((prevState) => ({
  //     rActions: {
  //       ...prevState.rActions,
  //       rtUpdateValuetwo: value,
  //     },
  //   }));
  // };
  inputRColumnapiChange = (value) => {
    this.setState((prevState) => ({
      rActions: {
        ...prevState.rActions,
        rtApiReqId: value,
      },
    }));
  };
  inputtableREmailselectChange = (e, index) => {
    e.preventDefault();
    const fieldName = e.target.getAttribute("name");
    const fieldValue = e.target.value;
    const selectedTemplate = this.state.Emailtemplate.find(
      (template) => template.name === fieldValue
    );
    const variablesList = selectedTemplate?.variablesJSON
      ? selectedTemplate.variablesJSON.split(",").filter(Boolean) // Convert CSV to array
      : [];
    this.setState((prevState) => {
      const updatedRows = [...prevState.rulescondition];
      updatedRows[index] = {
        ...updatedRows[index],
        [fieldName]: fieldValue,
        selectedTemplateName: fieldValue,
        selectedVariables: variablesList, // Store extracted variables
      };
      return {
        rulescondition: updatedRows,
      };
    });
  };
  inputtableRSmsselectChange = (e, index) => {
    e.preventDefault();
    const fieldName = e.target.getAttribute("name");
    const fieldValue = e.target.value;
    const selectedSmsTemplate = this.state.Smstemplates.find(
      (template) => template.name === fieldValue
    );
    const variablesList = selectedSmsTemplate?.variableJSON
      ? selectedSmsTemplate.variableJSON.split(",").filter(Boolean)
      : [];
    this.setState((prevState) => {
      const updatedRows = [...prevState.rulescondition];
      if (!updatedRows[index]) {
        updatedRows[index] = {};
      }
      updatedRows[index] = {
        ...updatedRows[index],
        [fieldName]: fieldValue,
        selectedSmsTemplateName: fieldValue,
        selectedSmsVariables: variablesList,
      };
      return { rulescondition: updatedRows };
    });
  };
  inputtableRChangeEmail = (e, rowIndex, variable) => {
    const fieldValue = e.target.value;

    this.setState((prevState) => {
      const updatedRulesCondition = [...prevState.rulescondition];
      if (!updatedRulesCondition[rowIndex]) {
        updatedRulesCondition[rowIndex] = {
          selectedTemplateName: "",
          rtemailParams: {},
        };
      }
      updatedRulesCondition[rowIndex].rtemailParams = {
        ...updatedRulesCondition[rowIndex].rtemailParams,
        [variable]: fieldValue,
      };
      return { rulescondition: updatedRulesCondition };
    });
  };
  inputtableRChangeEmailCustom = (e, rowIndex, variable) => {
    const value = e.target.value;

    this.setState((prevState) => {
      const updated = [...prevState.rulescondition];

      if (!updated[rowIndex]) {
        updated[rowIndex] = {};
      }
      if (!updated[rowIndex].rtemailParams) {
        updated[rowIndex].rtemailParams = {};
      }

      updated[rowIndex].rtemailParams[variable] = value;

      return { rulescondition: updated };
    });
  };

  inputtableRChangeSms = (e, rowIndex, variable) => {
    const fieldValue = e.target.value;
    this.setState((prevState) => {
      const updatedRulesCondition = [...prevState.rulescondition];
      if (!updatedRulesCondition[rowIndex]) {
        updatedRulesCondition[rowIndex] = {
          selectedSmsTemplateName: "",
          rtsmsparams: {},
        };
      }
      updatedRulesCondition[rowIndex].rtsmsparams = {
        ...updatedRulesCondition[rowIndex].rtsmsparams,
        [variable]: fieldValue,
      };
      return { rulescondition: updatedRulesCondition };
    });
  };
  inputtableRChangeSmsCustom = (e, rowIndex, variable) => {
    const value = e.target.value;

    this.setState((prevState) => {
      const updated = [...prevState.rulescondition];

      if (!updated[rowIndex]) {
        updated[rowIndex] = {};
      }
      if (!updated[rowIndex].rtsmsparams) {
        updated[rowIndex].rtsmsparams = {};
      }

      updated[rowIndex].rtsmsparams[variable] = value;

      return { rulescondition: updated };
    });
  };
  handleRemoveSpecificcreatetableSAction = (rowIndex, tableId) => {
    this.setState((prevState) => {
      const updatedRulescondition = [...prevState.rulescondition];
      const currentRule = updatedRulescondition[rowIndex];
      if (currentRule && currentRule.actions) {
        const updatedActions = currentRule.actions.filter(
          (action) => action.tableId !== tableId
        );
        updatedRulescondition[rowIndex] = {
          ...currentRule,
          actions: updatedActions,
        };
        if (updatedActions.length === 0) {
          return {
            rulescondition: updatedRulescondition,
            disabledTables: {
              ...prevState.disabledTables,
              [rowIndex]: false,
            },
          };
        }

        return { rulescondition: updatedRulescondition };
      }
      return prevState;
    });
  };
  handleUpdateRemoveSpecific = (rowIndex, tableId) => {
    this.setState((prevState) => {
      const updatedRulescondition = [...prevState.rulescondition];
      const currentRule = updatedRulescondition[rowIndex];

      if (currentRule && currentRule.updateactions) {
        const updatedActions = currentRule.updateactions.filter(
          (action) => action.tableId !== tableId
        );
        updatedRulescondition[rowIndex] = {
          ...currentRule,
          updateactions: updatedActions,
        };
        if (updatedActions.length === 0) {
          return {
            rulescondition: updatedRulescondition,
          };
        }

        return { rulescondition: updatedRulescondition };
      }
      return prevState;
    });
  };
  handleCallapiRemoveSpecific = (rowIndex, tableId) => {
    this.setState((prevState) => {
      const updatedRulescondition = [...prevState.rulescondition];
      const currentRule = updatedRulescondition[rowIndex];

      if (currentRule && currentRule.apiactions) {
        const updatedActions = currentRule.apiactions.filter(
          (action) => action.tableId !== tableId
        );
        updatedRulescondition[rowIndex] = {
          ...currentRule,
          apiactions: updatedActions,
        };
        if (updatedActions.length === 0) {
          return {
            rulescondition: updatedRulescondition,
          };
        }
        return { rulescondition: updatedRulescondition };
      }
      return prevState;
    });
  };
  addFormsubmitdata = (e, rowIndex) => {
    e.preventDefault();
    const tableId = `table-${rowIndex}-${Date.now()}`;
    const newAction = {
      id: Date.now(),
      tableId: tableId,
      rtTableName: this.state.rActions.rtTableName,
      rtColumnName: this.state.rActions.rtColumnName,
      rtValue: "",
      rtGate: this.state.rActions.rtGate,
    };

    this.setState((prevState) => {
      const updatedRulescondition = [...prevState.rulescondition];
      if (!updatedRulescondition[rowIndex]) {
        updatedRulescondition[rowIndex] = {
          id: Date.now(),
          visibletype: "Createtablerow",
          rtType: "Createtablerow",
          actions: [],
        };
      }
      updatedRulescondition[rowIndex] = {
        ...updatedRulescondition[rowIndex],
        actions: [
          ...(updatedRulescondition[rowIndex].actions || []),
          newAction,
        ],
        visibletype: "Createtablerow",
        rtType: "Createtablerow",
      };

      return {
        rulescondition: updatedRulescondition,
        //actions: updatedRulescondition,
        rActions: {
          rtTableName: "--",
          rtColumnName: "--",
          rtValue: "--",
          rtGate: "--",
        },
        disabledTables: {
          ...prevState.disabledTables,
          [rowIndex]: true,
        },
      };
    });
  };
  addUpdateFormsubmitdata = (e, rowIndex) => {
    e.preventDefault();
    const tableId = `table-${rowIndex}-${Date.now()}`;

    const updatedRowsData = this.state.updateRows.map((row) => ({
      id: Date.now(),
      tableId: tableId,
      rtUpdateTableName: this.state.rActions.rtUpdateTableName,
      rtUpdateColumnName:
        row[`rtUpdateColumnName${row.id > 0 ? row.id : ""}`] || "",
      rtUpdateOperator:
        row[`rtUpdateOperator${row.id > 0 ? row.id : ""}`] || "",
      rtUpdateValue: row[`rtUpdateValue${row.id > 0 ? row.id : ""}`] || "",
      rtUpdatesetcolumn: "",
      rtUpdateSetOperator: "",
      rtUpdateValuetwo: "",
      rtUpdateGate: "",
      rtType: "UpdateTable",
    }));

    const updatedSetRowsData = this.state.updateSetRows.map((row) => ({
      id: Date.now(),
      tableId: tableId,
      rtUpdateTableName: this.state.rActions.rtUpdateTableName,
      rtUpdateColumnName: "",
      rtUpdateOperator: "",
      rtUpdateValue: "",
      rtUpdatesetcolumn:
        row[`rtUpdatesetcolumn${row.id > 0 ? row.id : ""}`] || "",
      rtUpdateSetOperator:
        row[`rtUpdateSetOperator${row.id > 0 ? row.id : ""}`] || "",
      rtUpdateValuetwo:
        row[`rtUpdateValuetwo${row.id > 0 ? row.id : ""}`] || "",
      rtUpdateGate: row[`rtUpdateGate${row.id > 0 ? row.id : ""}`] || "",
      rtType: "UpdateTable",
    }));

    const newActions = [...updatedRowsData, ...updatedSetRowsData];

    this.setState((prevState) => {
      const updatedRulescondition = [...prevState.rulescondition];
      if (!updatedRulescondition[rowIndex]) {
        updatedRulescondition[rowIndex] = {
          id: Date.now(),
          visibletype: "UpdateTable",
          rtType: "UpdateTable",
          updateactions: [],
        };
      }

      updatedRulescondition[rowIndex] = {
        ...updatedRulescondition[rowIndex],
        updateactions: [
          ...(updatedRulescondition[rowIndex].updateactions || []),
          ...newActions,
        ],
        visibletype: "UpdateTable",
        rtType: "UpdateTable",
      };

      return {
        rulescondition: updatedRulescondition,
        rActions: {
          ...prevState.rActions,
          rtUpdateTableName: "--",
          rtUpdateColumnName: "--",
          rtUpdateValue: "",
          rtUpdateOperator: "",
          rtUpdatesetcolumn: "",
          rtUpdateSetOperator: "",
          rtUpdateValuetwo: "",
          rtUpdateGate: "",
        },
        // Reset these arrays after submission to ensure clean state for next submission
        updateRows: [{ id: 0 }],
        updateSetRows: [{ id: 0 }],
      };
    });
  };
  // addUpdateFormsubmitdata = (e, rowIndex) => {
  //   e.preventDefault();
  //   const tableId = `table-${rowIndex}-${Date.now()}`;
  //   const newAction = {
  //     id: Date.now(),
  //     tableId: tableId,
  //     rtUpdateTableName: this.state.rActions.rtUpdateTableName,
  //     rtUpdateColumnName: this.state.rActions.rtUpdateColumnName,
  //     rtUpdateValue: this.state.rActions.rtUpdateValue,
  //     //rtType: this.state.rActions.rtType,
  //     rtUpdateGate: this.state.rActions.rtUpdateGate,
  //     //rtUpdatesetTable: this.state.rActions.rtUpdatesetTable,
  //     rtUpdatesetcolumn: this.state.rActions.rtUpdatesetcolumn,
  //     rtUpdateValuetwo: this.state.rActions.rtUpdateValuetwo,
  //   };
  //   this.setState((prevState) => {
  //     const updatedRulescondition = [...prevState.rulescondition];
  //     if (!updatedRulescondition[rowIndex]) {
  //       updatedRulescondition[rowIndex] = {
  //         id: Date.now(),
  //         visibletype: "UpdateTable",
  //         rtType: "UpdateTable",
  //         updateactions: [],
  //       };
  //     }

  //     updatedRulescondition[rowIndex] = {
  //       ...updatedRulescondition[rowIndex],
  //       updateactions: [
  //         ...(updatedRulescondition[rowIndex].updateactions || []),
  //         newAction,
  //       ],
  //       visibletype: "UpdateTable",
  //       rtType: "UpdateTable",
  //     };
  //     return {
  //       rulescondition: updatedRulescondition,
  //       //updateactions: updatedRulescondition,
  //       rActions: {
  //         rtUpdateTableName: "--",
  //         rtUpdateColumnName: "--",
  //         rtUpdateValue: "--",
  //         rtUpdatedValuetwo: "--",
  //         rtUpdateGate: "--",
  //         rtUpdatesetTable: "",
  //         rtUpdatesetcolumn: "",
  //         rtUpdateValuetwo: "",
  //       },
  //     };
  //   });
  // };
  addFormsubmitApidata = (e, rowIndex) => {
    e.preventDefault();
    const tableId = `table-${rowIndex}-${Date.now()}`;
    const newAction = {
      id: Date.now(),
      tableId: tableId,
      rtApiTemplate: this.state.rActions.rtApiTemplate,
      rtApiName: this.state.rActions.rtApiName,
      rtApiReqId: this.state.rActions.rtApiReqId,
      // rtType: this.state.rActions.rtType,
      rtApiValue: this.state.rActions.rtApiValue,
    };
    this.setState((prevState) => {
      const updatedRulescondition = [...prevState.rulescondition];
      if (!updatedRulescondition[rowIndex]) {
        updatedRulescondition[rowIndex] = {
          id: Date.now(),
          visibletype: "CallAPI",
          rtType: "CallAPI",
          apiactions: [],
        };
      }

      updatedRulescondition[rowIndex] = {
        ...updatedRulescondition[rowIndex],
        apiactions: [
          ...(updatedRulescondition[rowIndex].apiactions || []),
          newAction,
        ],
        visibletype: "CallAPI",
        rtType: "CallAPI",
      };
      return {
        rulescondition: updatedRulescondition,
        //apiactions: updatedRulescondition,
        rActions: {
          rtApiTemplate: "--",
          rtApiName: "--",
          rtApiReqId: "--",
          // rtType: "--",
          rtApiValue: "--",
        },
      };
    });
  };
  addSmsFormsubmitdata = (e, rowIndex) => {
    e.preventDefault();
    this.setState((prevState) => {
      const row = prevState.rulescondition[rowIndex] || {};
      const selectedTemplate = prevState.Smstemplates.find(
        (template) => template.name === row.selectedSmsTemplateName
      );

      if (!selectedTemplate) {
        alert("Selected template not found!");
        return null;
      }
      const templateId = selectedTemplate.smstemplates_Id || "N/A";
      const parameters =
        selectedTemplate.variableJSON &&
          typeof selectedTemplate.variableJSON === "string"
          ? selectedTemplate.variableJSON
            .split(",")
            .filter(Boolean)
            .map((variable) => ({
              smsparams: variable,
              ruleparams: row.rtsmsparams?.[variable] || "selectedvalue",
            }))
          : [];
      // Collect WHERE conditions from all output parameter tables
      const tableNameMain = this.state.rActions.rtsmsName || "";
      const Outputparams = (prevState.outputParamsArray || []).map(
        (outputParamName, i) => ({
          outputParam: outputParamName,

          table: prevState.whereStateSms?.[i]?.tableName || "",
          column: prevState.whereStateSms?.[i]?.columnName || "",

          conditions: (prevState.whereByIndexSms[i] || []).map((c, idx) => ({
            sno: idx + 1,
            column: c.tableNameNewone || "",
            operator: c.cOperatorNewone || "",
            value: c.cValueNewone || "",
            operatorGate: c.cGateNewone || "",
          })),
        })
      );

      const newJsonsmsData = {
        ruleid: rowIndex + 1,
        tempid: templateId,
        tableName: tableNameMain || "",
        parameters: parameters,
        Outputparams: Outputparams,
      };
      return {
        rulesJsonsmsData: [
          ...(prevState.rulesJsonsmsData || []),
          newJsonsmsData,
        ],
      };
    });
  };

  addEmailFormsubmitdata = (e, rowIndex) => {
    e.preventDefault();
    this.setState((prevState) => {
      const row = prevState.rulescondition[rowIndex] || {};

      const selectedTemplate = prevState.Emailtemplate.find(
        (template) => template.name === row.selectedTemplateName
      );
      if (!selectedTemplate) {
        alert("Selected template not found!");
        return null;
      }

      const templateId = selectedTemplate.emailtemplates_Id || "N/A";

      const parameters = selectedTemplate.variablesJSON
        .split(",")
        .filter(Boolean)
        .map((variable) => ({
          emailparams: variable,
          ruleparams: row.rtemailParams?.[variable] || "selectedvalue",
        }));
      const tableNameMain = this.state.rActions.tableName || "";
      const Outputparams = (prevState.outputParamsArray || []).map(
        (outputParamName, i) => ({
          outputParam: outputParamName,
          // table for each output param (you already stored this)
          table: prevState.sendingData[`tableName_${i}`] || "",
          // FIX: column for each output param
          column: prevState.sendingData[`columnName_${i}`] || "",
          // conditions for each output param
          conditions: (prevState.whereByIndex[i] || []).map((c, idx) => ({
            sno: idx + 1,
            column: c.tableNameNew || "",
            operator: c.cOperatorNew || "",
            value: c.cValueNew || "",
            operatorGate: c.cGateNew || "",
          })),
        })
      );
      const newJsonData = {
        ruleid: rowIndex + 1,
        tempid: templateId,
        tableName: tableNameMain || "",
        // whereTable: prevState.tableName || "",
        // whereColumn: prevState.columnName || "",
        parameters: parameters,
        Outputparams: Outputparams,
      };
      return {
        rulesJsonData: [...(prevState.rulesJsonData || []), newJsonData],
      };
    });
  };
  handlerulesSubmitClick = (e) => {
    e.preventDefault();
    //if (this.validateForm()) {
    this.addEmailFormsubmitdata();
    this.addTestEmailFormsubmitdata();
    this.addPreviewEmailFormsubmitdata();
    this.addgetEmailFormsubmitdata();
    //}
  };
  // addEmailFormsubmitdata = (e, rowIndex) => {
  //   e.preventDefault();

  //   const row = this.state.rulescondition[rowIndex] || {};
  //   const selectedTemplate = this.state.Emailtemplate.find(
  //     (template) => template.name === row.selectedTemplateName
  //   );

  //   if (!selectedTemplate) {
  //     alert("Selected template not found!");
  //     return;
  //   }

  //   const templateId = selectedTemplate.emailtemplates_Id || "N/A";

  //   const parameters = selectedTemplate.variablesJSON
  //     .split(",")
  //     .filter(Boolean)
  //     .map((variable) => ({
  //       emailparams: variable,
  //       ruleparams: row.rtemailParams?.[variable] || "selectedvalue",
  //     }));

  //   const newJsonData = {
  //     ruleid: rowIndex + 1,
  //     tempid: templateId,
  //     parameters: parameters,
  //   };

  //   // Now build the form data using newJsonData (not from state)
  //   const variables = {};
  //   let to = [],
  //     cc = [],
  //     bcc = [];
  //   let customSubject = "";

  //   newJsonData.parameters.forEach((param) => {
  //     const key = param.emailparams.trim().toLowerCase();
  //     const value = param.ruleparams;

  //     if (key === "to") {
  //       to = value.split(",").map((email) => email.trim());
  //     } else if (key === "cc") {
  //       cc = value.split(",").map((email) => email.trim());
  //     } else if (key === "bcc") {
  //       bcc = value.split(",").map((email) => email.trim());
  //     } else if (key === "subject") {
  //       customSubject = value;
  //     } else {
  //       const varKey = key.replace(/\s+/g, "_");
  //       variables[varKey] = value;
  //     }
  //   });

  //   const formData = new FormData();
  //   formData.append("sId", this.state.sId);
  //   formData.append("uId", this.state.uId);
  //   formData.append("templateId", newJsonData.tempid);
  //   formData.append("variables", JSON.stringify(variables));
  //   formData.append("recipients", JSON.stringify({ to, cc, bcc }));
  //   formData.append("customSubject", customSubject);
  //   //formData.append("customSender", "Optional custom sender");

  //   fetch(configData.api_url + "/EmailSender/sendByTemplate", {
  //     method: "POST",
  //     mode: "cors",
  //     body: formData,
  //   })
  //     .then((response) => response.json())
  //     .then((data) => {
  //       this.showToast(data.message, data.status);
  //       if (data.status === "success") {
  //         this.TasknotesfetchHandler();
  //         this.handleOffcanvasClose();
  //       }
  //     })
  //     .catch((error) => {
  //       console.error("Email sending failed:", error);
  //     });
  // };
  addTestEmailFormsubmitdata = (e, rowIndex) => {
    e.preventDefault();
    const row = this.state.rulescondition[rowIndex] || {};
    const selectedTemplate = this.state.Emailtemplate.find(
      (template) => template.name === row.selectedTemplateName
    );
    if (!selectedTemplate) {
      alert("Selected template not found!");
      return;
    }
    const templateId = selectedTemplate.emailtemplates_Id || "N/A";
    const parameters = selectedTemplate.variablesJSON
      .split(",")
      .filter(Boolean)
      .map((variable) => ({
        emailparams: variable,
        ruleparams: row.rtemailParams?.[variable] || "selectedvalue",
      }));
    const newJsonData = {
      ruleid: rowIndex + 1,
      tempid: templateId,
      parameters: parameters,
    };
    // Now build the form data using newJsonData (not from state)
    const variables = {};
    let to = [],
      cc = [],
      bcc = [];
    let customSubject = "";

    newJsonData.parameters.forEach((param) => {
      const key = param.emailparams.trim().toLowerCase();
      const value = param.ruleparams;

      if (key === "to") {
        to = value.split(",").map((email) => email.trim());
      } else if (key === "cc") {
        cc = value.split(",").map((email) => email.trim());
      } else if (key === "bcc") {
        bcc = value.split(",").map((email) => email.trim());
      } else if (key === "subject") {
        customSubject = value;
      } else {
        const varKey = key.replace(/\s+/g, "_");
        variables[varKey] = value;
      }
    });
    const formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("templateId", newJsonData.tempid);
    formData.append("testEmail", "test@example.com");
    formData.append("variables", JSON.stringify(variables));
    formData.append("recipients", JSON.stringify({ to, cc, bcc }));
    fetch(configData.api_url + "/EmailSender/testTemplate", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.handleOffcanvasClose();
        }
      })
      .catch((error) => {
        console.error("Email sending failed:", error);
      });
  };
  addPreviewEmailFormsubmitdata = (e, rowIndex) => {
    e.preventDefault();

    const row = this.state.rulescondition[rowIndex] || {};
    const selectedTemplate = this.state.Emailtemplate.find(
      (template) => template.name === row.selectedTemplateName
    );

    if (!selectedTemplate) {
      alert("Selected template not found!");
      return;
    }

    const templateId = selectedTemplate.emailtemplates_Id || "N/A";

    const parameters = selectedTemplate.variablesJSON
      .split(",")
      .filter(Boolean)
      .map((variable) => ({
        emailparams: variable,
        ruleparams: row.rtemailParams?.[variable] || "selectedvalue",
      }));

    const newJsonData = {
      ruleid: rowIndex + 1,
      tempid: templateId,
      parameters: parameters,
    };
    // Now build the form data using newJsonData (not from state)
    const variables = {};
    let to = [],
      cc = [],
      bcc = [];

    newJsonData.parameters.forEach((param) => {
      const key = param.emailparams.trim().toLowerCase();
      const value = param.ruleparams;

      if (key === "to") {
        to = value.split(",").map((email) => email.trim());
      } else if (key === "cc") {
        cc = value.split(",").map((email) => email.trim());
      } else if (key === "bcc") {
        bcc = value.split(",").map((email) => email.trim());
      }
    });
    const formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("templateId", newJsonData.tempid);
    formData.append("variables", JSON.stringify(variables));
    formData.append("recipients", JSON.stringify({ to, cc, bcc }));
    fetch(configData.api_url + "/EmailSender/previewTemplate", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.handleOffcanvasClose();
        }
      })
      .catch((error) => {
        console.error("Email sending failed:", error);
      });
  };
  addgetEmailFormsubmitdata = (e, rowIndex) => {
    e.preventDefault();

    const row = this.state.rulescondition[rowIndex] || {};
    const selectedTemplate = this.state.Emailtemplate.find(
      (template) => template.name === row.selectedTemplateName
    );

    if (!selectedTemplate) {
      alert("Selected template not found!");
      return;
    }

    const templateId = selectedTemplate.emailtemplates_Id || "N/A";

    const parameters = selectedTemplate.variablesJSON
      .split(",")
      .filter(Boolean)
      .map((variable) => ({
        emailparams: variable,
        ruleparams: row.rtemailParams?.[variable] || "selectedvalue",
      }));

    const newJsonData = {
      ruleid: rowIndex + 1,
      tempid: templateId,
      parameters: parameters,
    };
    const formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("templateId", newJsonData.tempid);
    fetch(configData.api_url + "/EmailSender/getTemplateVariables", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.handleOffcanvasClose();
        }
      })
      .catch((error) => {
        console.error("Email sending failed:", error);
      });
  };
  handleSubmitClick = (e) => {
    e.preventDefault();
    //this.onSubmitAPI();
    this.RuleactionsupdateHandler();
    // this.RuleconditionssubmitHandler();
    //this.RulesdefsubmitHandler();
  };
  RulesdefsubmitHandler = (e) => {
    //e.preventDefault();
    //   setButtons(contacts);
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("rulegroupId", this.state.rulegroupId);
    formData.append("name", this.state.name);
    formData.append("description", this.state.description);
    formData.append("isActive", "");
    formData.append("priority", "");
    formData.append("executionOrder", "");
    formData.append("conditionlogicId", "");
    formData.append("ruleinputparameters", this.state.options || "");
    formData.append("ruleoutputparameters", this.state.optionsoutput || "");
    formData.append("version", this.state.version);
    formData.append("dummyOne", "");
    formData.append("dummyTwo", "");
    formData.append("dummyThree", "");
    formData.append("dummyFour", "");
    formData.append("dummyFive", "");
    //***tableData*
    this.setState({ loading: true, loadingMessage: "Saving..." });
    fetch(configData.api_url + "C_Rulesdef/add", {
      // Enter your IP address here
      method: "POST",
      //headers :{ 'Content-Type' : 'application/json'},
      mode: "cors",
      body: formData, // body data type must match "Content-Type" header
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.handleClose();
          this.apisfetchHandler();
          this.setState(
            {
              ruleId: data.ruleId, // Store the ruleId in state
              rulegroupId: "",
              name: "",
              description: "",
              isActive: "",
              priority: "",
              executionOrder: "",
              conditionlogicId: "",
              version: "",
            },
            () => {
              this.RuleconditionssubmitHandler();
              this.RuleactionsupdateHandler();
            }
          );
        }
      
        this.setState({ loading: false });})
    .catch(() => { this.setState({ loading: false }); });
  };
  RuleactionsupdateHandler = (e) => {
    //e.preventDefault();
    // const createTableActions = [];
    // this.state.rulescondition.forEach((row) => {
    //   if (row.visibletype === "Createtablerow" && row.actions) {
    //     row.actions.forEach((action) => {
    //       createTableActions.push({
    //         ...action,
    //         rtType: row.rtType,
    //       });
    //     });
    //   }
    // });
    const createTableActions = [];
    this.state.rulescondition.forEach((row) => {
      if (row.visibletype === "Createtablerow" && row.actions) {
        const columnNames = row.actions
          .map((action) => action.rtColumnName)
          .join(",");

        const rtValue = row.actions.reduce((acc, action) => {
          acc[action.rtColumnName] = action.rtValue || "";
          return acc;
        }, {});
        createTableActions.push({
          id: row.actions[0]?.id || Date.now(),
          tableId: row.actions[0]?.tableId || `table-${Date.now()}`,
          rtTableName: row.actions[0]?.rtTableName || "",
          rtColumnName: columnNames,
          rtValue: rtValue,
          rtType: row.rtType,
        });
      }
    });
    // Extract only the UPDATE TABLE actions
    const updateTableActions = [];

    this.state.rulescondition.forEach((row) => {
      if (row.visibletype === "UpdateTable" && row.updateactions) {
        const rtUpdateColumnNames = [];
        const rtUpdateValue = {};
        const rtUpdateOperator = {};
        const rtUpdateGate = {};

        const columnCount = {}; // Track duplicate column names

        row.updateactions.forEach((action) => {
          // Process update columns
          if (action.rtUpdateColumnName) {
            const columnNames = action.rtUpdateColumnName.split(",");
            columnNames.forEach((colName) => {
              rtUpdateColumnNames.push(colName);

              // Handle duplicates by appending "_2", "_3", etc.
              if (columnCount[colName]) {
                columnCount[colName]++;
                colName = `${colName}_${columnCount[colName]}`;
              } else {
                columnCount[colName] = 1;
              }

              rtUpdateValue[colName] = action.rtUpdateValue || "";
              rtUpdateOperator[colName] = action.rtUpdateOperator || "";
              rtUpdateGate[colName] = action.rtUpdateGate || "";
            });
          }

          // Process set columns (preserving duplicates)
          if (action.rtUpdatesetcolumn) {
            const setColumnNames = action.rtUpdatesetcolumn.split(",");
            setColumnNames.forEach((colName) => {
              rtUpdateColumnNames.push(colName);

              if (columnCount[colName]) {
                columnCount[colName]++;
                colName = `${colName}_${columnCount[colName]}`;
              } else {
                columnCount[colName] = 1;
              }

              rtUpdateValue[colName] = action.rtUpdateValuetwo || "";
              rtUpdateOperator[colName] = action.rtUpdateSetOperator || "";
              rtUpdateGate[colName] = action.rtUpdateGate || "";
            });
          }
        });

        updateTableActions.push({
          id: row.updateactions[0]?.id || Date.now(),
          tableId: row.updateactions[0]?.tableId || `table-${Date.now()}`,
          rtUpdateTableName: row.updateactions[0]?.rtUpdateTableName || "",
          rtUpdateColumnName: rtUpdateColumnNames.join(","), // Preserve duplicates
          rtUpdateValue: rtUpdateValue, // Use direct column names
          rtUpdateOperator: rtUpdateOperator, // Use direct column names
          rtUpdateGate: rtUpdateGate, // Use direct column names
          rtType: row.rtType,
        });
      }
    });

    // Extract only the API actions
    const apiActions = [];
    this.state.rulescondition.forEach((row) => {
      if (row.visibletype === "CallAPI" && row.apiactions) {
        row.apiactions.forEach((action) => {
          apiActions.push({
            ...action,
            rtType: row.rtType,
          });
        });
      }
    });
    const jsonactionData = {
      ractions: createTableActions,
      rupdateactions: updateTableActions,
      rapiactions: apiActions,
      remail: this.state.rulesJsonData,
      rsms: this.state.rulesJsonsmsData,
    };
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("ruleactions_Id", "");
    formData.append("ruleId", this.state.ruleId);
    formData.append("actiontypeId", "");
    formData.append("actionconfigJSON", "");
    formData.append("executionOrder", "");
    formData.append("isActive", "");
    formData.append("actionType", this.state.rActions.rtType);
    formData.append("jsonData", JSON.stringify(jsonactionData));
    formData.append("dummyOne", "");
    formData.append("dummyTwo", "");
    formData.append("dummyThree", "");
    formData.append("dummyFour", "");
    formData.append("dummyFive", "");
    fetch(configData.api_url + "C_Ruleactions/add1", {
      // Enter your IP address here

      method: "POST",
      //headers :{ 'Content-Type' : 'application/json'},
      mode: "cors",
      body: formData, // body data type must match "Content-Type" header
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.setState({
            ruleId: "",
            actiontypeId: "",
            actionconfigJSON: "",
            executionOrder: "",
            isActive: "",
            dummyOne: "",
            dummyTwo: "",
            dummyThree: "",
            dummyFour: "",
            dummyFive: "",
          });
        }
      });
  };
  RuleconditionssubmitHandler = (e) => {
    // e.preventDefault();
    //   setButtons(contacts)
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("ruleId", this.state.ruleId);
    formData.append("tablename", "");
    formData.append("columnname", "");
    formData.append("columndatatype", "");
    formData.append("arthematicoperator", "");
    formData.append("value", "");
    formData.append("logicaloperator", this.state.logicaloperator);
    formData.append("actionType", this.state.rActions.actionType);
    formData.append("jsonData", JSON.stringify(this.state.conditions));
    formData.append("dummyOne", "");
    formData.append("dummyTwo", "");
    formData.append("dummyThree", "");
    formData.append("dummyFour", "");
    formData.append("dummyFive", "");

    //***tableData*
    this.setState({ loading: true, loadingMessage: "Saving..." });
    fetch(configData.api_url + "C_Ruleconditions/add", {
      // Enter your IP address here

      method: "POST",
      //headers :{ 'Content-Type' : 'application/json'},
      mode: "cors",
      body: formData, // body data type must match "Content-Type" header
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          //  this.RuleconditionsfetchHandler();
          //  this.handleOffcanvasClose();
          this.setState({
            ruleId: "",
            tablename: "",
            columnname: "",
            columndatatype: "",
            arthematicoperator: "",
            value: "",
            logicaloperator: "",
            dummyOne: "",
            dummyTwo: "",
            dummyThree: "",
            dummyFour: "",
            dummyFive: "",
          });
        }
      
        this.setState({ loading: false });})
    .catch(() => { this.setState({ loading: false }); });
  };
  // offcanvas events//
  //rules def update event
  RulesdefupdateHandler = (e) => {
    e.preventDefault();
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("rulesdef_Id", this.state.rulesdef_Id);
    formData.append("rulegroupId", this.state.rulegroupId);
    formData.append("name", this.state.name);
    formData.append("description", this.state.description);
    formData.append("isActive", "");
    formData.append("priority", "");
    formData.append("executionOrder", "");
    formData.append("conditionlogicId", "");
    formData.append("ruleinputparameters", this.state.options || "");
    formData.append("ruleoutputparameters", this.state.optionsoutput || "");
    formData.append("version", this.state.version);
    formData.append("dummyOne", "");
    formData.append("dummyTwo", "");
    formData.append("dummyThree", "");
    formData.append("dummyFour", "");
    formData.append("dummyFive", "");

    //***tableData1
    this.setState({ loading: true, loadingMessage: "Updating..." });
    fetch(configData.api_url + "C_Rulesdef/update", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          //this.RulesdeffetchHandler();

          this.setState(() => {
            this.RuleconditionsupdateHandler();
            this.RuleactionsnewupdateHandler();
          });
        }
      
        this.setState({ loading: false });})
    .catch(() => { this.setState({ loading: false }); });
  };
  RuleactionsnewupdateHandler = (e) => {
    //e.preventDefault();
    // const createTableActions = [];
    // this.state.rulescondition.forEach((row) => {
    //   if (row.visibletype === "Createtablerow" && row.actions) {
    //     row.actions.forEach((action) => {
    //       createTableActions.push({
    //         ...action,
    //         rtType: row.rtType,
    //       });
    //     });
    //   }
    // });
    const createTableActions = [];
    this.state.rulescondition.forEach((row) => {
      if (row.visibletype === "Createtablerow" && row.actions) {
        const columnNames = row.actions
          .map((action) => action.rtColumnName)
          .join(",");

        const rtValue = row.actions.reduce((acc, action) => {
          acc[action.rtColumnName] = action.rtValue || "";
          return acc;
        }, {});
        createTableActions.push({
          id: row.actions[0]?.id || Date.now(),
          tableId: row.actions[0]?.tableId || `table-${Date.now()}`,
          rtTableName: row.actions[0]?.rtTableName || "",
          rtColumnName: columnNames,
          rtValue: rtValue,
          rtType: row.rtType,
        });
      }
    });
    // Extract only the UPDATE TABLE actions
    const updateTableActions = [];

    this.state.rulescondition.forEach((row) => {
      if (row.visibletype === "UpdateTable" && row.updateactions) {
        const rtUpdateColumnNames = [];
        const rtUpdateValue = {};
        const rtUpdateOperator = {};
        const rtUpdateGate = {};

        const columnCount = {}; // Track duplicate column names

        row.updateactions.forEach((action) => {
          // Process update columns
          if (action.rtUpdateColumnName) {
            const columnNames = action.rtUpdateColumnName.split(",");
            columnNames.forEach((colName) => {
              rtUpdateColumnNames.push(colName);

              // Handle duplicates by appending "_2", "_3", etc.
              if (columnCount[colName]) {
                columnCount[colName]++;
                colName = `${colName}_${columnCount[colName]}`;
              } else {
                columnCount[colName] = 1;
              }

              rtUpdateValue[colName] = action.rtUpdateValue || "";
              rtUpdateOperator[colName] = action.rtUpdateOperator || "";
              rtUpdateGate[colName] = action.rtUpdateGate || "";
            });
          }

          // Process set columns (preserving duplicates)
          if (action.rtUpdatesetcolumn) {
            const setColumnNames = action.rtUpdatesetcolumn.split(",");
            setColumnNames.forEach((colName) => {
              rtUpdateColumnNames.push(colName);

              if (columnCount[colName]) {
                columnCount[colName]++;
                colName = `${colName}_${columnCount[colName]}`;
              } else {
                columnCount[colName] = 1;
              }

              rtUpdateValue[colName] = action.rtUpdateValuetwo || "";
              rtUpdateOperator[colName] = action.rtUpdateSetOperator || "";
              rtUpdateGate[colName] = action.rtUpdateGate || "";
            });
          }
        });

        updateTableActions.push({
          id: row.updateactions[0]?.id || Date.now(),
          tableId: row.updateactions[0]?.tableId || `table-${Date.now()}`,
          rtUpdateTableName: row.updateactions[0]?.rtUpdateTableName || "",
          rtUpdateColumnName: rtUpdateColumnNames.join(","), // Preserve duplicates
          rtUpdateValue: rtUpdateValue, // Use direct column names
          rtUpdateOperator: rtUpdateOperator, // Use direct column names
          rtUpdateGate: rtUpdateGate, // Use direct column names
          rtType: row.rtType,
        });
      }
    });

    // Extract only the API actions
    const apiActions = [];
    this.state.rulescondition.forEach((row) => {
      if (row.visibletype === "CallAPI" && row.apiactions) {
        row.apiactions.forEach((action) => {
          apiActions.push({
            ...action,
            rtType: row.rtType,
          });
        });
      }
    });
    const jsonactionData = {
      ractions: createTableActions,
      rupdateactions: updateTableActions,
      rapiactions: apiActions,
      remail: this.state.rulesJsonData,
      rsms: this.state.rulesJsonsmsData,
    };
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("ruleactions_Id", "");
    formData.append("ruleId", this.state.ruleId);
    formData.append("actiontypeId", "");
    formData.append("actionconfigJSON", "");
    formData.append("executionOrder", "");
    formData.append("isActive", "");
    formData.append("actionType", this.state.rActions.rtType);
    formData.append("jsonData", JSON.stringify(jsonactionData));
    formData.append("dummyOne", "");
    formData.append("dummyTwo", "");
    formData.append("dummyThree", "");
    formData.append("dummyFour", "");
    formData.append("dummyFive", "");
    this.setState({ loading: true, loadingMessage: "Updating..." });
    fetch(configData.api_url + "C_Ruleactions/update", {
      // Enter your IP address here

      method: "POST",
      //headers :{ 'Content-Type' : 'application/json'},
      mode: "cors",
      body: formData, // body data type must match "Content-Type" header
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.setState({
            ruleId: "",
            actiontypeId: "",
            actionconfigJSON: "",
            executionOrder: "",
            isActive: "",
            dummyOne: "",
            dummyTwo: "",
            dummyThree: "",
            dummyFour: "",
            dummyFive: "",
          });
        }
      
        this.setState({ loading: false });})
    .catch(() => { this.setState({ loading: false }); });
  };
  RuleconditionsupdateHandler = (e) => {
    // e.preventDefault();
    //   setButtons(contacts)
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("ruleId", this.state.ruleId);
    formData.append("tablename", "");
    formData.append("columnname", "");
    formData.append("columndatatype", "");
    formData.append("arthematicoperator", "");
    formData.append("value", "");
    formData.append("logicaloperator", this.state.logicaloperator);
    formData.append("actionType", this.state.rActions.rtType);
    formData.append("jsonData", JSON.stringify(this.state.conditions));
    formData.append("dummyOne", "");
    formData.append("dummyTwo", "");
    formData.append("dummyThree", "");
    formData.append("dummyFour", "");
    formData.append("dummyFive", "");

    //***tableData*
    this.setState({ loading: true, loadingMessage: "Updating..." });
    fetch(configData.api_url + "C_Ruleconditions/update", {
      // Enter your IP address here

      method: "POST",
      //headers :{ 'Content-Type' : 'application/json'},
      mode: "cors",
      body: formData, // body data type must match "Content-Type" header
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          //  this.RuleconditionsfetchHandler();
          //  this.handleOffcanvasClose();
          this.setState({
            ruleId: "",
            tablename: "",
            columnname: "",
            columndatatype: "",
            arthematicoperator: "",
            value: "",
            logicaloperator: "",
            dummyOne: "",
            dummyTwo: "",
            dummyThree: "",
            dummyFour: "",
            dummyFive: "",
          });
        }
      
        this.setState({ loading: false });})
    .catch(() => { this.setState({ loading: false }); });
  };
  apisfetchHandler = () => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    // fetch(configData.api_url + "/rules/list", {
    fetch(configData.api_url + "C_Rulesdef/list", {
      method: "POST",
      mode: "cors",
      body: {},
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ rules: data.list });
        }
      });
  };
  getTables = () => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    fetch(configData.api_url + "/masters/gettables", {
      method: "POST",
      mode: "cors",
      body: {},
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.setState({ tables: data.tables });
        }
      });
  };

  getColumns = (tableName, rcolumn, rcolumnsWhere, rcolumnsWhereone) => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("tableName", tableName);
    fetch(configData.api_url + "/masters/getcolumns", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.setState({
            [rcolumn]: data.columns,
            [rcolumnsWhere]: data.columns,
            [rcolumnsWhereone]: data.columns,
          });
        }
      });
  };
  getColumnsWT = (tableName, rcolumn) => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("tableName", tableName);
    fetch(configData.api_url + "/masters/getcolumns", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.setState({ [rcolumn]: data.columnsWT });
        }
      });
  };
  getColumnsAndMerge = (tableName) => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("tableName", tableName);

    fetch(configData.api_url + "/masters/getcolumns", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          // Merge input params with table columns
          const mergedOptions = [
            ...(this.state.inputParamsArray || []), // Keep existing input params
            ...(data.columns || []),
          ];

          this.setState({
            selectedTableColumns: data.columns,
            options: mergedOptions, // Merge
          });
        }
      });
  };
  apisfetchHandlerTemplate = () => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    fetch(configData.api_url + "/templates/list", {
      method: "POST",
      mode: "cors",
      body: {},
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ templates: data.list });
        }
      });
  };
  apisfetchHandlerdata = () => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    fetch(configData.api_url + "/apis/list", {
      method: "POST",
      mode: "cors",
      body: {},
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ apis: data.list });
          ////console.log(this.state.apis);
          ////console.log(this.state.tableClms);
        }
      });
  };
  RulegroupsfetchHandler = () => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    fetch(configData.api_url + "C_Rulegroups/list", {
      // Enter your IP address here

      method: "POST",
      //headers :{ 'Content-Type' : 'application/json'},
      mode: "cors",
      body: formData, // body data type must match "Content-Type" header
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ rulegroup: data.list });
        }
      });
  };
  IntegrationtypemastersfetchHandler = () => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    fetch(configData.api_url + "C_Integrationtypemasters/list", {
      // Enter your IP address here
      method: "POST",
      //headers :{ 'Content-Type' : 'application/json'},
      mode: "cors",
      body: formData, // body data type must match "Content-Type" header
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ integrationtype: data.list });
        }
      });
  };
  EmailtemplatesfetchHandler = () => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    fetch(configData.api_url + "C_Emailtemplates/list", {
      // Enter your IP address here

      method: "POST",
      //headers :{ 'Content-Type' : 'application/json'},
      mode: "cors",
      body: formData, // body data type must match "Content-Type" header
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ Emailtemplate: data.list });
        }
      });
  };
  SmstemplatesfetchHandler = () => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    fetch(configData.api_url + "C_Smstemplates/list", {
      // Enter your IP address here
      method: "POST",
      //headers :{ 'Content-Type' : 'application/json'},
      mode: "cors",
      body: formData, // body data type must match "Content-Type" header
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ Smstemplates: data.list });
        }
      });
  };
  componentDidMount() {
    this.apisfetchHandler();
    this.getTables();
    this.apisfetchHandlerTemplate();
    this.apisfetchHandlerdata();
    this.RulegroupsfetchHandler();
    this.IntegrationtypemastersfetchHandler();
    this.EmailtemplatesfetchHandler();
    this.SmstemplatesfetchHandler();
  }
  showToast = (msg, type) => {
    var tType = toast.TYPE.INFO;
    if (type === "success") tType = toast.TYPE.SUCCESS;
    if (type === "error") tType = toast.TYPE.ERROR;
    if (type === "warning") tType = toast.TYPE.WARNING;
    toast(msg, { type: tType });
  };
  handleRowSelect = (row) => {
    this.setState({
      selectedRow: row.index,
    });
  };
  handleRowUpdate = (newData, oldData) => {
    const data = [...this.state.data];
    const index = oldData.index;
    data[index] = newData;
    this.setState({ data });
  };

  handleEdit = (row) => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    // const rowid = row.id;
    //console.log(`Editing row with ID ${rowid}`);
    // implement your edit logic here
  };
  handleDelete = (row, index) => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("rId", row.rId);
    this.setState({ loading: true, loadingMessage: "Deleting..." });
    fetch(configData.api_url + "/rules/delete", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.apisfetchHandler();
        }
      
        this.setState({ loading: false });})
    .catch(() => { this.setState({ loading: false }); });
    ////console.log(row.rId);
  };

  handlePageChange = (page) => {
    this.setState({ currentPage: page });
  };

  handlePerRowsChange = (newPerPage, page) => {
    this.setState({ itemsPerPage: newPerPage, currentPage: page });
  };

  handleFilter = (e) => {
    const searchValue = e.target.value.toLowerCase();
    const filteredData = this.state.rules.filter((row) => {
      return Object.values(row).join(" ").toLowerCase().includes(searchValue);
    });
    this.setState({ filteredData });
  };

  inputDChange = (e) => {
    e.preventDefault();
    const fieldName = e.target.getAttribute("name");
    const fieldValue = e.target.value;
    const inputData = this.state.rDate;
    inputData[fieldName] = fieldValue;
    this.setState({ rDate: inputData });
    this.setState({ visibletype: e.target.value });
  };
  inputtableDChange = (e) => {
    e.preventDefault();
    const fieldName = e.target.getAttribute("name");
    const fieldValue = e.target.value;
    const inputData = this.state.rDate;
    inputData[fieldName] = fieldValue;
    this.setState({ rdate: inputData });
    // this.getColumns(fieldValue, "rcolumns");
  };
  handleDurationChange = (event) => {
    const { name, value } = event.target;
    const { ruleData } = this.state;
    const updatedDuration = { ...ruleData, [name]: parseInt(value) };

    if (updatedDuration.seconds >= 60) {
      updatedDuration.minutes += Math.floor(updatedDuration.seconds / 60);
      updatedDuration.seconds %= 60;
    }

    if (updatedDuration.minutes >= 60) {
      updatedDuration.hours += Math.floor(updatedDuration.minutes / 60);
      updatedDuration.minutes %= 60;
    }

    if (updatedDuration.rSeconds >= 60) {
      updatedDuration.rMinutes += Math.floor(updatedDuration.rSeconds / 60);
      updatedDuration.rSeconds %= 60;
    }

    if (updatedDuration.rMinutes >= 60) {
      updatedDuration.hours += Math.floor(updatedDuration.rMinutes / 60);
      updatedDuration.rMinutes %= 60;
    }

    this.setState({ ruleData: updatedDuration });
  };
  handleAddRowRules = () => {
    this.setState((prevState) => ({
      rulescondition: [
        ...prevState.rulescondition,
        {
          id: Date.now(),
          rtType: "--",
          rtTableName: "--",
          rtColumnName: "--",
          rtTemplate: "--",
          rtGate: "--",
          visibletype: "",
          actions: [],
          updateactions: [],
          apiactions: [],
          currentPage: 1,
        },
      ],
      rActions: {
        ...prevState.rActions,
        rtUpdateTableName: "--",
        rtUpdateColumnName: "--",
        rtUpdateValue: "",
        rtUpdateOperator: "",
        rtUpdatesetcolumn: "",
        rtUpdateSetOperator: "",
        rtUpdateValuetwo: "",
        rtUpdateGate: "",
      },
      updateRows: [{ id: 0 }],
      updateSetRows: [{ id: 0 }],
    }));
  };
  handleDeleteRowRules = (index) => {
    this.setState((prevState) => ({
      rulescondition: prevState.rulescondition.filter((_, i) => i !== index),
    }));
  };
  handleInputChange = (e, index) => {
    // Update the specific row with new values
    const { name, value } = e.target;
    const actions = [...this.state.actions];
    actions[index][name] = value;
    this.setState({ actions });
  };
  handlerulegroupIdChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ rulegroupId: fieldValue });
  };
  handlenameChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ name: fieldValue });
  };
  handledescriptionChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ description: fieldValue });
  };
  handleTableSelect = (e) => {
    const selectedTable = e.target.value;
    this.setState({
      selectedTable,
      errors: { ...this.state.errors, selectedTable: "" },
    });

    // Fetch columns when table is selected
    if (selectedTable) {
      this.getColumnsAndMerge(selectedTable);
    } else {
      // Reset to only input params when no table selected
      this.setState({ options: this.state.inputParamsArray || [] });
    }
  };

  handleEditInputChangeParamzNewsms(tableIndex, rowIndex, field, value) {
    this.setState((prev) => {
      const tableWhere = [...(prev.whereByIndexSms[tableIndex] || [])];
      if (tableWhere[rowIndex]) {
        tableWhere[rowIndex][field] = value;
      }
      return {
        whereByIndexSms: {
          ...prev.whereByIndexSms,
          [tableIndex]: tableWhere,
        },
      };
    });

    // Fetch columns when table field changes
    if (field === "tableNameNewone" && value) {
      this.getColumns(value, "rcolumnsNew");
      const combinedColumns = [
        ...(this.state.inputParamsArray || []),
        ...(this.state.outputParamsArray || []),
      ];
      this.setState({ newWhereColumnsonesms: combinedColumns });
    }
  }

  handleEditTableRowParamzNewone(tableIndex, rowIndex) {
    this.setState((prev) => ({
      editingByIndexSms: {
        ...prev.editingByIndexSms,
        [tableIndex]: rowIndex,
      },
    }));
  }

  updateSendParamzNewone = (e, tableIndex) => {
    e.preventDefault();
    this.setState((prev) => ({
      editingByIndexSms: {
        ...prev.editingByIndexSms,
        [tableIndex]: -1,
      },
    }));
  };

  inputtableSChangeNewsms = (e, tableIndex) => {
    e.preventDefault();
    const fieldName = e.target.name;
    const fieldValue = e.target.value;

    // Update specific SMS table's input fields
    this.setState((prev) => {
      const tableInput = { ...(prev.inputByIndexSms[tableIndex] || {}) };
      tableInput[fieldName] = fieldValue;
      return {
        inputByIndexSms: {
          ...prev.inputByIndexSms,
          [tableIndex]: tableInput,
        },
      };
    });

    // When tableNameNew changes → load combined columns
    if (fieldName === "tableNameNew") {
      const combinedColumns = [
        ...(this.state.inputParamsArray || []),
        ...(this.state.outputParamsArray || []),
        ...(this.state.rcolumns || []),
      ];
      this.setState({
        newWhereColumnsone: combinedColumns,
      });
    }
  };

  handleColumnChangeNewsms = (e, tableIndex) => {
    const fieldName = e.target.name;
    const fieldValue = e.target.value;
    const selectedLabel = e.target.options[e.target.selectedIndex].text;

    // Update specific SMS table's input fields
    this.setState((prev) => {
      const tableInput = { ...(prev.inputByIndexSms[tableIndex] || {}) };
      tableInput[fieldName] = selectedLabel;
      return {
        inputByIndexSms: {
          ...prev.inputByIndexSms,
          [tableIndex]: tableInput,
        },
        columnValueNewone: fieldValue,
      };
    });
  };

  inputSChangeNewsms = (e, tableIndex) => {
    const fieldName = e.target.name;
    const fieldValue = e.target.value;

    // Update specific SMS table's input fields
    this.setState((prev) => {
      const tableInput = { ...(prev.inputByIndexSms[tableIndex] || {}) };
      tableInput[fieldName] = fieldValue;
      return {
        inputByIndexSms: {
          ...prev.inputByIndexSms,
          [tableIndex]: tableInput,
        },
      };
    });
  };

  addSendRowNewsms = (e, tableIndex) => {
    e.preventDefault();

    // Get input values from specific SMS table's input state
    const temp = this.state.inputByIndexSms[tableIndex] || {};

    // Validate all fields are filled
    if (
      !temp.tableNameNewone ||
      !temp.cOperatorNewone ||
      !temp.cValueNewone ||
      !temp.cGateNewone
    ) {
      toast.warning("Please fill all WHERE fields");
      return;
    }

    // Add to specific SMS table only and reset that table's input fields
    this.setState((prev) => {
      const currentWhere = prev.whereByIndexSms[tableIndex] || [];
      return {
        whereByIndexSms: {
          ...prev.whereByIndexSms,
          [tableIndex]: [...currentWhere, { ...temp }],
        },
        inputByIndexSms: {
          ...prev.inputByIndexSms,
          [tableIndex]: {
            tableNameNewone: "",
            cOperatorNewone: "",
            cValueNewone: "",
            cGateNewone: "",
          },
        },
        showCustomInputSms: {
          ...prev.showCustomInputSms,
          [tableIndex]: false,
        },
      };
    });

    toast.success("WHERE condition added successfully");
  };
  inputWhereTableChange = (e) => {
    e.preventDefault();
    const selectedTable = e.target.value;

    this.setState({
      whereTable: selectedTable,
    });

    // Load table columns
    this.getColumns(selectedTable, "whereColumns");

    // ⭐ ALSO LOAD INPUT + OUTPUT + TABLE COLUMNS FOR WHERE SELECT
    // const combinedColumns = [
    //   ...(this.state.inputParamsArray || []),
    //   ...(this.state.outputParamsArray || []),
    //   ...(this.state.rcolumns || []),
    // ];

    // this.setState({
    //   newWhereColumns: combinedColumns,
    // });
    if (selectedTable) {
      this.getColumnsAndMergeone(selectedTable);
    } else {
      // Reset to only input params when no table selected
      this.setState({ options: this.state.inputParamsArray || [] });
    }
  };
  getColumnsAndMergeone = (tableName) => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("tableName", tableName);

    fetch(configData.api_url + "/masters/getcolumns", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          // Merge input params with table columns
          const mergedOptions = [
            ...(this.state.inputParamsArray || []),
            ...(this.state.outputParamsArray || []),
            ...(data.columns || []),
          ];

          this.setState({
            selectedTableColumns: data.columns,
            options: mergedOptions, // Merge
          });
        }
      });
  };
  //onchange email
  inputSChangewherecol = (e) => {
    e.preventDefault();
    const fieldName = e.target.getAttribute("name");
    const fieldValue = e.target.value;
    const inputData = this.state.sendingData;
    inputData[fieldName] = fieldValue;
    this.setState({ sendingData: inputData });
  };
  handleWhereChange = (rowIndex, field, value) => {
    this.setState((prev) => ({
      whereState: {
        ...prev.whereState,
        [rowIndex]: {
          ...prev.whereState[rowIndex],
          [field]: value,
        },
      },
    }));
  };

  handleWhereChangeSms = (rowIndex, field, value) => {
    this.setState((prev) => ({
      whereStateSms: {
        ...prev.whereStateSms,
        [rowIndex]: {
          ...prev.whereStateSms[rowIndex],
          [field]: value,
        },
      },
    }));

    // When table is selected, load columns
    if (field === "tableName" && value) {
      this.getColumns(value, "rcolumnsWhereone");
    }
  };
  inputtableSChangewhere = (e) => {
    e.preventDefault();

    const fieldName = e.target.name; // tableName
    const fieldValue = e.target.value;

    // Correctly update UI value
    this.setState((prev) => ({
      tableName: fieldValue,
      sendingData: {
        ...prev.sendingData,
        [fieldName]: fieldValue,
      },
    }));

    // Fetch columns
    this.getColumns(fieldValue, "rcolumnsWhere");
  };
  //edit adn update event
  handleEditInputChangeParamzNew(tableIndex, rowIndex, field, value) {
    this.setState((prev) => {
      const tableWhere = [...(prev.whereByIndex[tableIndex] || [])];
      if (tableWhere[rowIndex]) {
        tableWhere[rowIndex][field] = value;
      }
      return {
        whereByIndex: {
          ...prev.whereByIndex,
          [tableIndex]: tableWhere,
        },
      };
    });

    // Fetch columns if table changed
    if (field === "tableNameNew" && value) {
      this.getColumns(value, "rcolumnsNew");
      const combinedColumns = [
        ...(this.state.inputParamsArray || []),
        ...(this.state.outputParamsArray || []),
      ];
      this.setState({ newWhereColumnsone: combinedColumns });
    }
  }
  updateSendParamzNew = (e, tableIndex) => {
    e.preventDefault();
    this.setState((prev) => ({
      editingByIndex: {
        ...prev.editingByIndex,
        [tableIndex]: -1,
      },
    }));
  };
  handleEditTableRowParamzNew(tableIndex, rowIndex) {
    this.setState((prev) => ({
      editingByIndex: {
        ...prev.editingByIndex,
        [tableIndex]: rowIndex,
      },
    }));
  }
  //onchange
  inputtableSChangeNew = (e, tableIndex) => {
    e.preventDefault();
    const fieldName = e.target.name;
    const fieldValue = e.target.value;

    // Update specific table's input fields
    this.setState((prev) => {
      const tableInput = { ...(prev.inputByIndex[tableIndex] || {}) };
      tableInput[fieldName] = fieldValue;
      return {
        inputByIndex: {
          ...prev.inputByIndex,
          [tableIndex]: tableInput,
        },
      };
    });

    // When tableNameNew changes → load combined columns
    if (fieldName === "tableNameNew") {
      const combinedColumns = [
        ...(this.state.inputParamsArray || []),
        ...(this.state.outputParamsArray || []),
        ...(this.state.rcolumns || []),
      ];
      this.setState({
        newWhereColumns: combinedColumns,
      });
    }
  };
  handleColumnChangeNew = (e, tableIndex) => {
    const fieldName = e.target.name;
    const fieldValue = e.target.value;
    const selectedLabel = e.target.options[e.target.selectedIndex].text;

    // Update specific table's input fields
    this.setState((prev) => {
      const tableInput = { ...(prev.inputByIndex[tableIndex] || {}) };
      tableInput[fieldName] = selectedLabel;
      return {
        inputByIndex: {
          ...prev.inputByIndex,
          [tableIndex]: tableInput,
        },
        columnValueNew: fieldValue,
      };
    });
  };
  inputSChangeNew = (e, tableIndex) => {
    const fieldName = e.target.name;
    const fieldValue = e.target.value;

    // Update specific table's input fields
    this.setState((prev) => {
      const tableInput = { ...(prev.inputByIndex[tableIndex] || {}) };
      tableInput[fieldName] = fieldValue;
      return {
        inputByIndex: {
          ...prev.inputByIndex,
          [tableIndex]: tableInput,
        },
      };
    });
  };
  addSendRowNew = (e, tableIndex) => {
    e.preventDefault();

    // Get input values from specific table's input state
    const temp = this.state.inputByIndex[tableIndex] || {};

    // Validate
    if (
      !temp.tableNameNew ||
      !temp.cOperatorNew ||
      !temp.cValueNew ||
      !temp.cGateNew
    ) {
      toast.warning("Please fill all WHERE fields");
      return;
    }

    // Add to specific table only and reset that table's input fields
    this.setState((prev) => {
      const currentWhere = prev.whereByIndex[tableIndex] || [];
      return {
        whereByIndex: {
          ...prev.whereByIndex,
          [tableIndex]: [...currentWhere, { ...temp }],
        },
        inputByIndex: {
          ...prev.inputByIndex,
          [tableIndex]: {
            tableNameNew: "",
            cOperatorNew: "",
            cValueNew: "",
            cGateNew: "",
          },
        },
        showCustomInput: {
          ...prev.showCustomInput,
          [tableIndex]: false,
        },
      };
    });

    toast.success("WHERE condition added");
  };
  render() {
    const DefaultData = this.state.rConditions;
    const paginatedData = this.state.filteredData
      ? this.state.filteredData.slice(
        (this.state.currentPage - 1) * this.state.itemsPerPage,
        this.state.currentPage * this.state.itemsPerPage
      )
      : this.state.rules.slice(
        (this.state.currentPage - 1) * this.state.itemsPerPage,
        this.state.currentPage * this.state.itemsPerPage
      );
    return (
      <div>
        <LoadingOverlay show={this.state.loading} message={this.state.loadingMessage} />
        <Row>
          <Col lg="12" md="12" sm="12">
            <h2 style={{ float: "left" }}>RULES PAGE</h2>
          </Col>
        </Row>
        <div className="x_panel">
          <div>
            <Row>
              <Col
                className="d-flex justify-content-end"
                style={{ marginRight: "5px", marginTop: "20px" }}
              >
                <Button
                  variant="warning"
                  className="me-2 bi bi-upload"
                  onClick={this.handleShowOne}
                >
                  Upload *csv
                </Button>
                <Button variant="info" className="me-2 bi bi-download">
                  Download *csv
                </Button>
                <Button
                  variant="primary"
                  className="bi bi-plus "
                  value={DefaultData}
                  onClick={this.handleShow}
                >
                  New
                </Button>
                <div>
                  <Modal show={this.state.showOne} onHide={this.handleCloseOne}>
                    <Modal.Header closeButton>
                      <Modal.Title>Upload *csv file</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      <Button
                        variant="success"
                        className="bi bi-upload"
                        onClick={this.handleButtonClick}
                      >
                        {" "}
                        Upload
                      </Button>
                      <input
                        type="file"
                        ref={this.inputFileRef}
                        style={{ display: "none" }}
                        accept=".csv"
                        onChange={this.handleFileChange}
                      />
                    </Modal.Body>
                    <Modal.Footer>
                      <Button variant="secondary" onClick={this.handleCloseOne}>
                        Close
                      </Button>
                      <Button variant="primary" onClick={this.handleCloseOne}>
                        Save Changes
                      </Button>
                    </Modal.Footer>
                  </Modal>
                </div>
                <Offcanvas
                  show={this.state.show}
                  onHide={this.handleClose}
                  {...this.props}
                  style={{ width: "1120px" }}
                  placement="end"
                  backdrop="true"
                >
                  <Offcanvas.Header closeButton>
                    <Offcanvas.Title>New Rule page</Offcanvas.Title>
                  </Offcanvas.Header>
                  <Offcanvas.Body>
                    <Container style={{ overflowY: "auto", height: "auto" }}>
                      <Row className="divstyle">
                        <Row>
                          <Form>
                            <Row>
                              <Form.Group
                                className="mb-3"
                                controlId="formBasicPassword"
                              >
                                <Row>
                                  <Col lg="4" md="4">
                                    <Form.Label>Rule Group</Form.Label>
                                  </Col>
                                  <Col lg="4" md="4">
                                    <Form.Select
                                      name="rulegroup"
                                      value={this.state.rulegroupId}
                                      onChange={this.handlerulegroupIdChange}
                                      required="required"
                                      //type="select"
                                      placeholder="Select Old Entries"
                                      className="form-control"
                                      aria-label="Default select example"
                                    >
                                      <option>Select Group</option>
                                      {this.state.rulegroup.map(
                                        (api, index, idx) => (
                                          <option
                                            key={index}
                                            value={api.rulegroups_Id}
                                          >
                                            {api.name}
                                          </option>
                                        )
                                      )}
                                    </Form.Select>
                                  </Col>
                                </Row>
                              </Form.Group>
                            </Row>
                            <Row>
                              <Form.Group
                                className="mb-3"
                                controlId="formBasicPassword"
                              >
                                <Row>
                                  <Col lg="4" md="4">
                                    <Form.Label>Rule Name</Form.Label>
                                  </Col>
                                  <Col lg="4" md="4">
                                    <Form.Control
                                      name="name"
                                      value={this.state.name}
                                      onChange={this.handlenameChange}
                                      required="required"
                                      type="text"
                                      placeholder="Enter Rule Name"
                                      className="form-control"
                                    />
                                  </Col>
                                </Row>
                              </Form.Group>
                            </Row>
                            <Row>
                              <Form.Group
                                className="mb-3"
                                controlId="exampleForm.ControlTextarea1"
                              >
                                <Row>
                                  <Col lg="4" md="4">
                                    <Form.Label>Rule description</Form.Label>
                                  </Col>
                                  <Col lg="4" md="4">
                                    <Form.Control
                                      as="textarea"
                                      rows={3}
                                      name={"description"}
                                      value={this.state.description}
                                      onChange={this.handledescriptionChange}
                                      required="required"
                                      placeholder="Enter Rule Description"
                                      className="form-control"
                                    />
                                  </Col>
                                </Row>
                              </Form.Group>
                            </Row>
                            <Row className="mb-3">
                              <Form.Group>
                                <Row>
                                  <Col lg="4" md="4">
                                    <Form.Label>Select Table</Form.Label>
                                  </Col>
                                  <Col lg="4" md="4">
                                    <Form.Select
                                      value={this.state.selectedTable}
                                      onChange={this.handleTableSelect}
                                      isInvalid={
                                        !!this.state.errors.selectedTable
                                      }
                                    >
                                      <option value="">
                                        Choose a table...
                                      </option>
                                      {this.state.tables.map((table, index) => (
                                        <option key={index} value={table}>
                                          {table}
                                        </option>
                                      ))}
                                    </Form.Select>
                                  </Col>
                                </Row>
                              </Form.Group>
                            </Row>
                            <Row className="mb-3">
                              <Form.Group>
                                <Row>
                                  <Col lg="4" md="4">
                                    <Form.Label>Trigger Event</Form.Label>
                                  </Col>
                                  <Col lg="4" md="4">
                                    <Form.Select
                                      value={this.state.selectedTriggerEvent}
                                      onChange={(e) =>
                                        this.setState({
                                          selectedTriggerEvent: e.target.value,
                                        })
                                      }
                                      isInvalid={
                                        !!this.state.errors.selectedTriggerEvent
                                      }
                                    >
                                      <option value="">
                                        Choose trigger event...
                                      </option>
                                      {this.state.triggerEvents.map(
                                        (event, index) => (
                                          <option key={index} value={event}>
                                            {event.toUpperCase()}
                                          </option>
                                        )
                                      )}
                                    </Form.Select>
                                  </Col>
                                </Row>
                              </Form.Group>
                            </Row>
                            <Row>
                              <Form.Group
                                className="mb-3"
                                controlId="formBasicPassword"
                              >
                                <Row>
                                  <Col lg="4" md="4">
                                    <Form.Label>Input Parameters</Form.Label>
                                  </Col>
                                  <Col lg="4" md="4">
                                    <Form.Control
                                      name={"tableName"}
                                      value={DefaultData.inputparams}
                                      onChange={this.handleinputparamsChange}
                                      onBlur={this.handleinputSelect}
                                      required="required"
                                      type="text"
                                      placeholder="Enter Input Parameters"
                                      className="form-control"
                                    />
                                  </Col>
                                </Row>
                              </Form.Group>
                            </Row>
                            <Row>
                              <Form.Group
                                className="mb-3"
                                controlId="formBasicPassword"
                              >
                                <Row>
                                  <Col lg="4" md="4">
                                    <Form.Label>Output Parameters</Form.Label>
                                  </Col>
                                  <Col lg="4" md="4">
                                    <Form.Control
                                      name={"outputparams"}
                                      value={DefaultData.outputparams}
                                      onChange={this.handleoutputparamsChange}
                                      onBlur={this.handleoutputSelect}
                                      required="required"
                                      type="text"
                                      placeholder="Enter Output Parameters"
                                      className="form-control"
                                    />
                                  </Col>
                                </Row>
                              </Form.Group>
                            </Row>
                            <Row>
                              <Col lg="4" md="4">
                                <Form.Label style={{ paddingTop: "8px" }}>
                                  Version
                                </Form.Label>
                              </Col>
                              <Col lg="4" md="4">
                                <Form.Control
                                  type="text"
                                  onChange={this.handleversionChange}
                                  className="form-control"
                                  name="version"
                                  value={this.state.version}
                                  required="required"
                                  placeholder="Enter Version"
                                />
                              </Col>
                            </Row>
                            <br />
                            {/* <Row>
                              <Form.Group
                                className="mb-3"
                                controlId="formBasicPassword"
                              >
                                <Row>
                                  <Col lg="4" md="4">
                                    <Form.Label>Rule Execution Time</Form.Label>
                                  </Col>
                                  <Col lg="8" md="8">
                                    <Row className="d-flex">
                                      <Col>
                                        <Form.Control
                                          // // id="appt-time"
                                          // step="2"
                                          name="reTime"
                                          value={this.state.ruleData.reTime}
                                          onChange={this.inputChange}
                                          required="required"
                                          type="time"
                                          placeholder="Enter Time"
                                          className="form-control"
                                        />
                                      </Col>
                                      <Col>
                                        <Form.Control
                                          type="number"
                                          name="minutes"
                                          value={this.state.ruleData.minutes}
                                          onChange={this.handleDurationChange}
                                        />
                                      </Col>
                                      <Col>
                                        <Form.Control
                                          type="number"
                                          name="seconds"
                                          value={this.state.ruleData.seconds}
                                          onChange={this.handleDurationChange}
                                        />
                                      </Col>
                                    </Row>
                                  </Col>
                                  <div
                                    className="errorMsg text-center"
                                    style={{ color: "red" }}
                                  >
                                    {this.state.errors.rName}
                                    {this.state.errors.minutes}
                                    {this.state.errors.seconds}
                                  </div>
                                </Row>
                              </Form.Group>
                            </Row>
                            <Row>
                              <Form.Group
                                className="mb-3"
                                controlId="formBasicPassword"
                              >
                                <Row>
                                  <Col lg="4" md="4">
                                    <Form.Label>Rule Frequency</Form.Label>
                                  </Col>
                                  <Col lg="8" md="8">
                                    <Row className="d-flex">
                                      <Col lg="4" md="4" sm="4">
                                        <Form.Control
                                          name="rMonth"
                                          value={this.state.ruleData.rMonth}
                                          onChange={this.inputChange}
                                          required="required"
                                          type="month"
                                          placeholder="Enter Month"
                                          className="form-control"
                                        />
                                      </Col>
                                      <Col lg="4" md="4" sm="4">
                                        <Form.Control
                                          name="rDate"
                                          value={this.state.ruleData.rDate}
                                          onChange={this.inputChange}
                                          required="required"
                                          type="date"
                                          placeholder="Enter Date"
                                          className="form-control"
                                        />
                                      </Col>
                                      <Col lg="4" md="4" sm="4">
                                        <Form.Control
                                          //  id="appt-time"
                                          // step="2"
                                          name="rTime"
                                          value={this.state.ruleData.rTime}
                                          onChange={this.inputChange}
                                          required="required"
                                          type="time"
                                          placeholder="Enter Time"
                                          className="form-control"
                                        />
                                      </Col>
                                      <Col
                                        lg="3"
                                        md="3"
                                        sm="3"
                                        style={{ marginTop: "5px" }}
                                      >
                                        <Form.Control
                                          type="number"
                                          name="rMinutes"
                                          value={this.state.ruleData.rMinutes}
                                          onChange={this.handleDurationChange}
                                        />
                                      </Col>
                                      <Col
                                        lg="3"
                                        md="3"
                                        sm="3"
                                        style={{ marginTop: "5px" }}
                                      >
                                        <Form.Control
                                          type="number"
                                          name="rSeconds"
                                          value={this.state.ruleData.rSeconds}
                                          onChange={this.handleDurationChange}
                                        />
                                      </Col>
                                    </Row>
                                  </Col>
                                  <div
                                    className="errorMsg text-center"
                                    style={{ color: "red" }}
                                  >
                                    {this.state.errors.rMonth}
                                    {this.state.errors.rDate}
                                    {this.state.errors.rTime}
                                    {this.state.errors.rMinutes}
                                    {this.state.errors.rSeconds}
                                  </div>
                                </Row>
                              </Form.Group>
                            </Row> */}
                            {/* <Row>
                              <Form.Group
                                className="mb-3"
                                controlId="formBasicPassword"
                              >
                                <Row>
                                  <Col lg="4" md="4">
                                    <Form.Label>
                                      Re Apply Old Entries
                                    </Form.Label>
                                  </Col>
                                  <Col lg="4" md="4">
                                    <Form.Select
                                      name="rulegroup"
                                      value={this.state.ruleData.rulegroup}
                                      onChange={this.inputChange}
                                      required="required"
                                      //type="select"
                                      placeholder="Select Old Entries"
                                      className="form-control"
                                      aria-label="Default select example"
                                    >
                                      <option>Select Old Entries</option>
                                      <option value="True">True</option>
                                      <option value="False">False</option>
                                    </Form.Select>
                                  </Col>
                                  <div
                                    className="errorMsg text-center"
                                    style={{ color: "red" }}
                                  >
                                    {this.state.errors.rulegroup}
                                  </div>
                                </Row>
                              </Form.Group>
                            </Row> */}
                          </Form>
                        </Row>
                        <br />
                        <Row className="d-flex" style={{ marginTop: "20px" }}>
                          <h4>if</h4>
                          <Table
                            className="table table-bordered table-hover"
                            id="tab_logic"
                          >
                            <thead>
                              <tr>
                                <th className="text-center">S.NO</th>
                                <th className="text-center">Input Parameter</th>
                                <th className="text-center">Operators</th>
                                <th className="text-center">Value</th>
                                <th className="text-center">Operatorgates</th>
                                <th className="text-center">Actions</th>
                              </tr>
                            </thead>
                            <tbody>
                              {this.state.conditions.length > 0 ? (
                                this.state.conditions.map(
                                  (condition, index, idx) => (
                                    <tr key={index}>
                                      <td>{index + 1}</td>
                                      <td>
                                        {this.state.editingIndex === index ? (
                                          <select
                                            className="form-select"
                                            name="tableName"
                                            value={condition.tableName}
                                            onChange={(e) =>
                                              this.handleEditInputChangeParamz(
                                                index,
                                                "tableName",
                                                e.target.value
                                              )
                                            }
                                          >
                                            <option defaultValue>
                                              Select Table
                                            </option>
                                            {this.state.options.map(
                                              (api, index) => (
                                                <option key={index} value={api}>
                                                  {api}
                                                </option>
                                              )
                                            )}
                                          </select>
                                        ) : (
                                          condition.tableName
                                        )}
                                      </td>
                                      <td>
                                        {this.state.editingIndex === index ? (
                                          <select
                                            className="form-select"
                                            value={condition.cOperator}
                                            name="cOperator"
                                            onChange={(e) =>
                                              this.handleEditInputChangeParamz(
                                                index,
                                                "cOperator",
                                                e.target.value
                                              )
                                            }
                                          >
                                            <option defaultValue>
                                              Select Column
                                            </option>
                                            <option value="=">=</option>
                                            <option value="<">&lt;</option>
                                            <option value=">">&gt;</option>
                                            <option value="<=">&le;</option>
                                            <option value=">=">&ge;</option>
                                            <option value="Between">
                                              Between
                                            </option>
                                            <option value="Not Between">
                                              Not Between
                                            </option>
                                            <option value="Is Empty">
                                              Is Empty
                                            </option>
                                            <option value="Is Not Empty">
                                              Is Not Empty
                                            </option>
                                          </select>
                                        ) : (
                                          condition.cOperator
                                        )}
                                      </td>
                                      <td>
                                        {this.state.editingIndex === index ? (
                                          <Form.Control
                                            type="Text"
                                            name="cValue"
                                            placeholder="sample"
                                            value={condition.cValue}
                                            onChange={(e) =>
                                              this.handleEditInputChangeParamz(
                                                index,
                                                "cValue",
                                                e.target.value
                                              )
                                            }
                                          />
                                        ) : (
                                          condition.cValue
                                        )}
                                      </td>
                                      <td>
                                        {this.state.editingIndex === index ? (
                                          <select
                                            className="form-select"
                                            value={condition.cGate}
                                            name="cGate"
                                            onChange={(e) =>
                                              this.handleEditInputChangeParamz(
                                                index,
                                                "cGate",
                                                e.target.value
                                              )
                                            }
                                          >
                                            <option defaultValue>
                                              Select Column
                                            </option>
                                            <option value="And">And</option>
                                            <option value="Or">Or</option>
                                            <option value="END">END</option>
                                          </select>
                                        ) : (
                                          condition.cGate
                                        )}
                                      </td>
                                      <td>
                                        {this.state.editingIndex === index && ( // Extra "Add" button below the row being edited
                                          <Button
                                            type="button"
                                            className="bi bi-check2-circle"
                                            variant="success"
                                            onClick={this.updateSendParamz}
                                          ></Button>
                                        )}
                                        <Button
                                          className="bi bi-pen"
                                          onClick={() =>
                                            this.handleEditTableRowParamz(index)
                                          }
                                          variant="info"
                                        ></Button>
                                        {this.state.editingIndex !== index && (
                                          <Button
                                            variant="warning"
                                            className="bi bi-trash-fill"
                                            onClick={() =>
                                              this.handleRemoveSpecificRowS(
                                                index
                                              )
                                            }
                                          ></Button>
                                        )}
                                      </td>
                                    </tr>
                                  )
                                )
                              ) : (
                                <tr>
                                  <td colSpan="7"> No Records</td>
                                </tr>
                              )}
                              <tr>
                                <td>1</td>
                                <td>
                                  <select
                                    className="form-select"
                                    value={DefaultData.tableName}
                                    name="tableName"
                                    onChange={this.inputtableSChange}
                                  >
                                    <option defaultValue>Select</option>
                                    {this.state.options.map(
                                      (api, index, idx) => (
                                        <option key={index} value={api}>
                                          {api}
                                        </option>
                                      )
                                    )}
                                  </select>
                                  <div
                                    className="errorMsg"
                                    style={{ color: "red" }}
                                  >
                                    {this.state.errors.tableName}
                                  </div>
                                </td>
                                <td>
                                  <select
                                    className="form-select"
                                    aria-label="Default select example"
                                    value={DefaultData.cOperator}
                                    name="cOperator"
                                    onChange={this.handleColumnChange}
                                  >
                                    <option defaultValue>Select</option>
                                    <option value="=">=</option>
                                    <option value="<">&lt;</option>
                                    <option value=">">&gt;</option>
                                    <option value="<=">&le;</option>
                                    <option value=">=">&ge;</option>
                                    <option value="Between">Between</option>
                                    <option value="Not Between">
                                      Not Between
                                    </option>
                                    <option value="Is Empty">Is Empty</option>
                                    <option value="Is Not Empty">
                                      Is Not Empty
                                    </option>
                                  </select>
                                  <div
                                    className="errorMsg"
                                    style={{ color: "red" }}
                                  >
                                    {this.state.errors.cOperator}
                                  </div>
                                  {/* <p>Selected value: {this.state.COLUMN_NAME}</p> */}
                                </td>
                                <td>
                                  <>
                                    <Form.Control
                                      value={DefaultData.cValue}
                                      name="cValue"
                                      required="required"
                                      placeholder="Value."
                                      onChange={this.inputSChange}
                                    ></Form.Control>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {this.state.errors.cValue}
                                    </div>
                                  </>
                                </td>
                                <td>
                                  <select
                                    className="form-select"
                                    aria-label="Default select example"
                                    value={DefaultData.cGate}
                                    name="cGate"
                                    required="required"
                                    onChange={this.inputSChange}
                                  >
                                    <option defaultValue>SelectGates</option>
                                    <option value="And">And</option>
                                    <option value="Or">Or</option>
                                    <option value="END">END</option>
                                  </select>
                                  <div
                                    className="errorMsg"
                                    style={{ color: "red" }}
                                  >
                                    {this.state.errors.cGate}
                                  </div>
                                </td>
                                <td>
                                  <Button
                                    variant="success"
                                    style={{ marginTop: "3px" }}
                                    onClick={this.addSendRow}
                                  >
                                    Add
                                  </Button>
                                </td>
                              </tr>
                            </tbody>
                          </Table>
                        </Row>
                        <br />
                        <Row className="mt-3 d-flex">
                          <Row>
                            <Col lg="1">
                              <h4>Do</h4>
                            </Col>
                            <Col lg="1">
                              &nbsp;
                              <Button
                                className="bi bi-plus mt-3"
                                onClick={this.handleAddRowRules}
                              ></Button>
                            </Col>
                          </Row>
                          {this.state.rulescondition.map((row, index) => (
                            <>
                              <div
                                key={row.id || index}
                                style={{ display: "flex" }}
                              >
                                <div>
                                  <select
                                    style={{
                                      marginTop: "16px",
                                      width: "150px",
                                    }}
                                    className="form-select"
                                    aria-label="Default select example"
                                    value={this.state.rActions.rtType}
                                    name="rtType"
                                    required="required"
                                    onChange={(e) =>
                                      this.inputRChange(e, index)
                                    }
                                  >
                                    <option>Action Type</option>
                                    <option value="Createtablerow">
                                      Create Table Row
                                    </option>
                                    <option value="UpdateTable">
                                      Update Table
                                    </option>
                                    <option value="SendEmail">
                                      Send Email
                                    </option>
                                    <option value="SendSms">Send Sms</option>
                                    <option value="CallAPI">Call API</option>
                                    <option value="whatsapp">
                                      Send What'sapp Message
                                    </option>
                                  </select>
                                </div>
                                &nbsp;&nbsp;
                                <div>
                                  {row.visibletype === "SendEmail" && (
                                    <>
                                      <select
                                        style={{ width: "150px" }}
                                        className="form-select mt-3"
                                        value={row.rtEmailTemplates}
                                        name="rtEmailTemplates"
                                        required="required"
                                        aria-label="Default select example"
                                        onChange={(e) =>
                                          this.inputtableREmailselectChange(
                                            e,
                                            index
                                          )
                                        }
                                      >
                                        <option defaultValue>
                                          Select Email
                                        </option>
                                        {this.state.Emailtemplate.map(
                                          (api, index) => (
                                            <option
                                              key={api.emailtemplates_Id}
                                              value={api.name}
                                            >
                                              {api.name}
                                            </option>
                                          )
                                        )}
                                      </select>
                                    </>
                                  )}
                                  {row.visibletype === "SendSms" && (
                                    <select
                                      style={{ width: "150px" }}
                                      className="form-select mt-3"
                                      value={row.rtSmsTemplates || ""}
                                      name="rtSmsTemplates"
                                      required="required"
                                      aria-label="Default select example"
                                      onChange={(e) =>
                                        this.inputtableRSmsselectChange(
                                          e,
                                          index
                                        )
                                      }
                                    >
                                      <option defaultValue>
                                        Select SendSms
                                      </option>
                                      {this.state.Smstemplates.map(
                                        (api, index) => (
                                          <option
                                            key={api.smstemplates_Id}
                                            value={api.name}
                                          >
                                            {api.name}
                                          </option>
                                        )
                                      )}
                                    </select>
                                  )}
                                  {row.visibletype === "CallAPI" && (
                                    <select
                                      style={{ width: "150px" }}
                                      className="form-select mt-3"
                                      value={this.state.rActions.rtApiTemplate}
                                      name="rtApiTemplate"
                                      required="required"
                                      aria-label="Default select example"
                                      onChange={(e) =>
                                        this.inputtableRChange(e, index)
                                      }
                                    >
                                      <option defaultValue>
                                        Integration type
                                      </option>
                                      {this.state.integrationtype.map(
                                        (api, index) => (
                                          <option
                                            key={api}
                                            value={api.typeName}
                                          >
                                            {api.typeName}
                                          </option>
                                        )
                                      )}
                                    </select>
                                  )}
                                  {row.visibletype === "whatsapp" && (
                                    <select
                                      style={{ width: "150px" }}
                                      className="form-select mt-3"
                                      value={this.state.rActions.rtTemplate}
                                      name="rtTemplate"
                                      required="required"
                                      aria-label="Default select example"
                                      onChange={(e) =>
                                        this.inputtableRChange(e, index)
                                      }
                                    >
                                      <option defaultValue>
                                        {" "}
                                        select message
                                      </option>
                                      {this.state.templates.map(
                                        (api, index) => (
                                          <option key={api} value={api.tName}>
                                            {api.tName}
                                          </option>
                                        )
                                      )}
                                    </select>
                                  )}
                                  {row.visibletype === "Createtablerow" && (
                                    <select
                                      style={{ width: "150px" }}
                                      className="form-select mt-3"
                                      value={this.state.rActions.rtTableName}
                                      name="rtTableName"
                                      required="required"
                                      aria-label="Default select example"
                                      onChange={(e) =>
                                        this.inputtablecreateRChange(e, index)
                                      }
                                      disabled={
                                        this.state.disabledTables[index] ||
                                        false
                                      }
                                    >
                                      <option defaultValue>
                                        {" "}
                                        select message
                                      </option>
                                      {this.state.tables.map(
                                        (api, index, idx) => (
                                          <option value={api}>{api}</option>
                                        )
                                      )}
                                    </select>
                                  )}
                                </div>
                                &nbsp;&nbsp;
                                <div>
                                  {/* {row.visibletype === "Createtablerow" && (
                                    <select
                                      style={{ width: "150px" }}
                                      className="form-select mt-3"
                                      aria-label="Default select example"
                                      value={this.state.rActions.rtColumnName}
                                      name="rtColumnName"
                                      required="required"
                                      onChange={(e) =>
                                        this.inputRColumnChange(e, index)
                                      }
                                    >
                                      <option defaultValue hidden>
                                        Column Names
                                      </option>
                                      {this.state.rcolumns.map(
                                        (api, index, idx) => (
                                          <option value={api}>{api}</option>
                                        )
                                      )}
                                    </select>
                                  )} */}
                                  {row.visibletype === "CallAPI" && (
                                    <select
                                      style={{ width: "150px" }}
                                      className="form-select mt-3"
                                      value={this.state.rActions.rtApiName}
                                      name="rtApiName"
                                      required="required"
                                      aria-label="Default select example"
                                      onChange={(e) =>
                                        this.inputRColumnChange(e, index)
                                      }
                                    >
                                      <option defaultValue>select Api</option>
                                      {this.state.apis.map((api, index) => (
                                        <option key={api} value={api.aName}>
                                          {api.aName}
                                        </option>
                                      ))}
                                    </select>
                                  )}
                                </div>
                                &nbsp;&nbsp;
                                <div>
                                  {/* {row.visibletype === "Createtablerow" && (
                                    <CreatableSelect
                                      className="mt-3"
                                      isClearable
                                      options={[
                                        ...this.state.options,
                                        ...this.state.optionsoutput,
                                      ].map((api) => ({
                                        value: api,
                                        label: api,
                                      }))}
                                      value={
                                        this.state.rActions.rtValue
                                          ? {
                                              value:
                                                this.state.rActions.rtValue,
                                              label:
                                                this.state.rActions.rtValue,
                                            }
                                          : null
                                      }
                                      onChange={(selectedOption) =>
                                        this.inputRColumncreateChange(
                                          selectedOption
                                            ? selectedOption.value
                                            : ""
                                        )
                                      }
                                      placeholder="I/O Parameters"
                                    />
                                  )} */}
                                  {row.visibletype === "CallAPI" && (
                                    <CreatableSelect
                                      className="mt-3"
                                      isClearable
                                      options={[
                                        ...this.state.options,
                                        ...this.state.optionsoutput,
                                      ].map((api) => ({
                                        value: api,
                                        label: api,
                                      }))}
                                      value={
                                        this.state.rActions.rtApiReqId
                                          ? {
                                            value:
                                              this.state.rActions.rtApiReqId,
                                            label:
                                              this.state.rActions.rtApiReqId,
                                          }
                                          : null
                                      }
                                      onChange={(selectedOption) =>
                                        this.inputRColumnapiChange(
                                          selectedOption
                                            ? selectedOption.value
                                            : ""
                                        )
                                      }
                                      placeholder="I/O Parameters"
                                    />
                                  )}
                                </div>
                                &nbsp;&nbsp;
                                <div>
                                  {row.visibletype === "CallAPI" && (
                                    <>
                                      <Form.Control
                                        style={{ width: "150px" }}
                                        type="text"
                                        name={"rtApiValue"}
                                        value={this.state.rActions.rtApiValue}
                                        onChange={this.inputChangeupdate}
                                        required="required"
                                        placeholder="Enter Value"
                                        className="form-control mt-3"
                                      />
                                    </>
                                  )}
                                </div>
                                &nbsp;&nbsp;
                                <div>
                                  {row.visibletype === "SendEmail" && (
                                    <div style={{ display: "flex" }}>
                                      &nbsp;
                                      <Button
                                        variant="danger"
                                        className="mt-3 bi bi-trash"
                                        onClick={() =>
                                          this.handleDeleteRowRules(index)
                                        }
                                      ></Button>
                                    </div>
                                  )}
                                  {row.visibletype === "SendSms" && (
                                    <div style={{ display: "flex" }}>
                                      <Button
                                        variant="danger"
                                        className="mt-3 bi bi-trash"
                                        onClick={() =>
                                          this.handleDeleteRowRules(index)
                                        }
                                      ></Button>
                                    </div>
                                  )}
                                  {row.visibletype === "CallAPI" && (
                                    <div style={{ display: "flex" }}>
                                      <Button
                                        variant="success"
                                        className="mt-3 bi bi-plus"
                                        onClick={(e) =>
                                          this.addFormsubmitApidata(e, index)
                                        }
                                      ></Button>
                                      &nbsp;
                                      <Button
                                        variant="danger"
                                        className="mt-3 bi bi-trash"
                                        onClick={() =>
                                          this.handleDeleteRowRules(index)
                                        }
                                      ></Button>
                                    </div>
                                  )}
                                  {row.visibletype === "whatsapp" && (
                                    <div style={{ display: "flex" }}>
                                      <Button
                                        variant="success"
                                        className="mt-3 bi bi-plus"
                                        onClick={(e) =>
                                          this.addFormsubmitdata(e, index)
                                        }
                                      ></Button>
                                      &nbsp;
                                      <Button
                                        variant="danger"
                                        className="mt-3 bi bi-trash"
                                        onClick={() =>
                                          this.handleDeleteRowRules(index)
                                        }
                                      ></Button>
                                    </div>
                                  )}
                                </div>
                                &nbsp;&nbsp;
                                <div>
                                  {/* {row.visibletype === "Createtablerow" && (
                                    <div style={{ display: "flex" }}>
                                      <Button
                                        variant="success"
                                        className="mt-3 bi bi-plus"
                                        onClick={(e) =>
                                          this.addFormsubmitdata(e, index)
                                        }
                                      ></Button>
                                      &nbsp;
                                      <Button
                                        variant="danger"
                                        className="mt-3 bi bi-trash"
                                        onClick={() =>
                                          this.handleDeleteRowRules(index)
                                        }
                                      ></Button>
                                    </div>
                                  )} */}
                                </div>
                                &nbsp;&nbsp;
                              </div>
                              {row.visibletype === "UpdateTable" && (
                                <div
                                  style={{
                                    border: "2px solid white",
                                    padding: "10px",
                                  }}
                                  className="mt-2"
                                >
                                  <Row>
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    {row.visibletype === "UpdateTable" && (
                                      <select
                                        style={{ width: "210px" }}
                                        className="form-select mt-3"
                                        aria-label="Default select example"
                                        value={
                                          this.state.rActions.rtUpdateTableName
                                        }
                                        name="rtUpdateTableName"
                                        required="required"
                                        onChange={(e) =>
                                          this.inputtableRChange(e, index)
                                        }
                                      >
                                        <option defaultValue hidden>
                                          Table Name
                                        </option>
                                        {this.state.tables.map(
                                          (api, index, idx) => (
                                            <option value={api}>{api}</option>
                                          )
                                        )}
                                      </select>
                                    )}
                                  </Row>
                                  <Row>
                                    <div>
                                      {row.visibletype === "UpdateTable" && (
                                        <p
                                          className="mt-3"
                                          style={{ width: "125px" }}
                                        >
                                          Set
                                        </p>
                                      )}
                                    </div>
                                    <div style={{ display: "flex" }}>
                                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                      <div>
                                        {row.visibletype === "UpdateTable" && (
                                          <>
                                            {this.state.updateSetRows.map(
                                              (row, index) => (
                                                <div
                                                  key={row.id}
                                                  className="row mt-3"
                                                >
                                                  <select
                                                    className="form-select"
                                                    name={`rtUpdatesetcolumn${index > 0 ? index : ""
                                                      }`}
                                                    value={
                                                      row[
                                                      `rtUpdatesetcolumn${index > 0 ? index : ""
                                                      }`
                                                      ] || ""
                                                    }
                                                    onChange={(e) =>
                                                      this.inputsetRColumnChange(
                                                        e,
                                                        index
                                                      )
                                                    }
                                                  >
                                                    <option defaultValue hidden>
                                                      Column Names
                                                    </option>
                                                    {this.state.rcolumns.map(
                                                      (api) => (
                                                        <option
                                                          key={api}
                                                          value={api}
                                                        >
                                                          {api}
                                                        </option>
                                                      )
                                                    )}
                                                  </select>
                                                </div>
                                              )
                                            )}
                                          </>
                                        )}
                                      </div>
                                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                      <div>
                                        {row.visibletype === "UpdateTable" && (
                                          <>
                                            {this.state.updateSetRows.map(
                                              (row, index) => (
                                                <div
                                                  key={row.id}
                                                  className="row mt-3"
                                                >
                                                  <select
                                                    className="form-select"
                                                    name={`rtUpdateSetOperator${index > 0 ? index : ""
                                                      }`}
                                                    value={
                                                      row[
                                                      `rtUpdateSetOperator${index > 0 ? index : ""
                                                      }`
                                                      ] || ""
                                                    }
                                                    onChange={(e) =>
                                                      this.inputsetRoperatorChange(
                                                        e,
                                                        index
                                                      )
                                                    }
                                                  >
                                                    <option defaultValue hidden>
                                                      Operators
                                                    </option>
                                                    <option value="=">=</option>
                                                    <option value="<">
                                                      &lt;
                                                    </option>
                                                    <option value=">">
                                                      &gt;
                                                    </option>
                                                    <option value="<=">
                                                      &le;
                                                    </option>
                                                    <option value=">=">
                                                      &ge;
                                                    </option>
                                                    <option value="Between">
                                                      Between
                                                    </option>
                                                    <option value="Not Between">
                                                      Not Between
                                                    </option>
                                                    <option value="Is Empty">
                                                      Is Empty
                                                    </option>
                                                    <option value="Is Not Empty">
                                                      Is Not Empty
                                                    </option>
                                                  </select>
                                                </div>
                                              )
                                            )}
                                          </>
                                        )}
                                      </div>
                                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                      <div>
                                        {row.visibletype === "UpdateTable" && (
                                          <>
                                            {" "}
                                            {this.state.updateSetRows.map(
                                              (row, index) => (
                                                <div
                                                  key={row.id}
                                                  className="row mt-3"
                                                >
                                                  <CreatableSelect
                                                    className="ml-2"
                                                    isClearable
                                                    options={[
                                                      ...this.state.options,
                                                      ...this.state
                                                        .optionsoutput,
                                                    ].map((api) => ({
                                                      value: api,
                                                      label: api,
                                                    }))}
                                                    value={
                                                      row[
                                                        `rtUpdateValuetwo${index > 0 ? index : ""
                                                        }`
                                                      ]
                                                        ? {
                                                          value:
                                                            row[
                                                            `rtUpdateValuetwo${index > 0
                                                              ? index
                                                              : ""
                                                            }`
                                                            ],
                                                          label:
                                                            row[
                                                            `rtUpdateValuetwo${index > 0
                                                              ? index
                                                              : ""
                                                            }`
                                                            ],
                                                        }
                                                        : null
                                                    }
                                                    onChange={(
                                                      selectedOption
                                                    ) =>
                                                      this.inputsetRColumnupdateChange(
                                                        selectedOption
                                                          ? selectedOption.value
                                                          : "",
                                                        index
                                                      )
                                                    }
                                                    placeholder="I/O Parameters"
                                                  />
                                                </div>
                                              )
                                            )}
                                          </>
                                        )}
                                      </div>
                                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                      <div>
                                        {row.visibletype === "UpdateTable" && (
                                          <>
                                            {" "}
                                            {this.state.updateSetRows.map(
                                              (row, index) => (
                                                <div
                                                  key={row.id}
                                                  className="row mt-3 align-items-center"
                                                >
                                                  <div className="col-9">
                                                    <select
                                                      className="form-select"
                                                      name={`rtUpdateGate${index > 0 ? index : ""
                                                        }`}
                                                      value={
                                                        row[
                                                        `rtUpdateGate${index > 0
                                                          ? index
                                                          : ""
                                                        }`
                                                        ] || ""
                                                      } // Correct key access
                                                      onChange={(e) =>
                                                        this.inputsetRGateupdateChange(
                                                          e,
                                                          index
                                                        )
                                                      }
                                                    >
                                                      <option defaultValue>
                                                        SelectGates
                                                      </option>
                                                      <option value="And">
                                                        And
                                                      </option>
                                                      <option value="END">
                                                        END
                                                      </option>
                                                    </select>
                                                  </div>
                                                  <div className="col-3">
                                                    <button
                                                      className="btn btn-danger bi bi-trash"
                                                      onClick={() =>
                                                        this.deleteSetRow(index)
                                                      }
                                                    ></button>
                                                  </div>
                                                </div>
                                              )
                                            )}
                                          </>
                                        )}
                                      </div>
                                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                      <div>
                                        {" "}
                                        {row.visibletype === "UpdateTable" && (
                                          <div style={{ display: "flex" }}>
                                            &nbsp;
                                            <Button
                                              className="btn btn-primary mt-3 bi bi-plus"
                                              onClick={this.addSetRow}
                                            ></Button>
                                            &nbsp;&nbsp;&nbsp;
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  </Row>
                                  <Row>
                                    <div>
                                      {row.visibletype === "UpdateTable" && (
                                        <p
                                          className="mt-3"
                                          style={{ width: "125px" }}
                                        >
                                          Where
                                        </p>
                                      )}
                                    </div>
                                    <div style={{ display: "flex" }}>
                                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                      <div>
                                        {row.visibletype === "UpdateTable" && (
                                          <>
                                            {this.state.updateRows.map(
                                              (row, index) => (
                                                <div
                                                  key={row.id}
                                                  className="row mt-3"
                                                >
                                                  <select
                                                    // className="form-select"
                                                    // name={`rtUpdateColumnName${index}`}
                                                    // value={row.columnName}
                                                    // onChange={(e) =>
                                                    //   this.inputupdateRColumnChange(e, index)
                                                    // }
                                                    className="form-select"
                                                    name={`rtUpdateColumnName${index > 0 ? index : ""
                                                      }`}
                                                    value={
                                                      row[
                                                      `rtUpdateColumnName${index > 0 ? index : ""
                                                      }`
                                                      ] || ""
                                                    }
                                                    onChange={(e) =>
                                                      this.inputupdateRColumnChange(
                                                        e,
                                                        index
                                                      )
                                                    }
                                                  >
                                                    <option defaultValue hidden>
                                                      Column Names
                                                    </option>
                                                    {this.state.rcolumns.map(
                                                      (api) => (
                                                        <option
                                                          key={api}
                                                          value={api}
                                                        >
                                                          {api}
                                                        </option>
                                                      )
                                                    )}
                                                  </select>
                                                </div>
                                              )
                                            )}
                                          </>
                                        )}
                                      </div>
                                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                      <div>
                                        {row.visibletype === "UpdateTable" && (
                                          <>
                                            {this.state.updateRows.map(
                                              (row, index) => (
                                                <div
                                                  key={row.id}
                                                  className="row mt-3"
                                                >
                                                  <select
                                                    className="form-select"
                                                    name={`rtUpdateOperator${index > 0 ? index : ""
                                                      }`}
                                                    value={
                                                      row[
                                                      `rtUpdateOperator${index > 0 ? index : ""
                                                      }`
                                                      ] || ""
                                                    }
                                                    onChange={(e) =>
                                                      this.inputupdateRoperatorChange(
                                                        e,
                                                        index
                                                      )
                                                    }
                                                  >
                                                    <option defaultValue hidden>
                                                      Operators
                                                    </option>
                                                    <option value="=">=</option>
                                                    <option value="<">
                                                      &lt;
                                                    </option>
                                                    <option value=">">
                                                      &gt;
                                                    </option>
                                                    <option value="<=">
                                                      &le;
                                                    </option>
                                                    <option value=">=">
                                                      &ge;
                                                    </option>
                                                    <option value="Between">
                                                      Between
                                                    </option>
                                                    <option value="Not Between">
                                                      Not Between
                                                    </option>
                                                    <option value="Is Empty">
                                                      Is Empty
                                                    </option>
                                                    <option value="Is Not Empty">
                                                      Is Not Empty
                                                    </option>
                                                  </select>
                                                </div>
                                              )
                                            )}
                                          </>
                                        )}
                                      </div>
                                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                      <div>
                                        {row.visibletype === "UpdateTable" && (
                                          <>
                                            {this.state.updateRows.map(
                                              (row, index) => (
                                                <div
                                                  key={row.id}
                                                  className="row mt-3 align-items-center"
                                                >
                                                  {/* Column for Select Input */}
                                                  <div className="col-9">
                                                    <CreatableSelect
                                                      className="ml-2"
                                                      isClearable
                                                      options={[
                                                        ...this.state.options,
                                                        ...this.state
                                                          .optionsoutput,
                                                      ].map((api) => ({
                                                        value: api,
                                                        label: api,
                                                      }))}
                                                      value={
                                                        row[
                                                          `rtUpdateValue${index > 0
                                                            ? index
                                                            : ""
                                                          }`
                                                        ]
                                                          ? {
                                                            value:
                                                              row[
                                                              `rtUpdateValue${index > 0
                                                                ? index
                                                                : ""
                                                              }`
                                                              ],
                                                            label:
                                                              row[
                                                              `rtUpdateValue${index > 0
                                                                ? index
                                                                : ""
                                                              }`
                                                              ],
                                                          }
                                                          : null
                                                      }
                                                      onChange={(
                                                        selectedOption
                                                      ) =>
                                                        this.inputRColumnupdateChange(
                                                          selectedOption
                                                            ? selectedOption.value
                                                            : "",
                                                          index
                                                        )
                                                      }
                                                      placeholder="I/O Parameters"
                                                    />
                                                  </div>

                                                  {/* Column for Delete Button with small spacing */}
                                                  <div className="col-3">
                                                    <button
                                                      className="btn btn-danger bi bi-trash"
                                                      onClick={() =>
                                                        this.deleteRow(index)
                                                      }
                                                    ></button>
                                                  </div>
                                                </div>
                                              )
                                            )}
                                          </>
                                        )}
                                      </div>
                                      &nbsp;&nbsp;&nbsp;
                                      <div>
                                        {" "}
                                        {row.visibletype === "UpdateTable" && (
                                          <div style={{ display: "flex" }}>
                                            &nbsp;
                                            <Button
                                              className="btn btn-primary mt-3 bi bi-plus"
                                              onClick={this.addRow}
                                            ></Button>
                                            &nbsp;&nbsp;&nbsp;
                                            <Button
                                              variant="success"
                                              className="mt-3 bi bi-plus"
                                              onClick={(e) =>
                                                this.addUpdateFormsubmitdata(
                                                  e,
                                                  index
                                                )
                                              }
                                            >
                                              Add
                                            </Button>
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  </Row>
                                </div>
                              )}
                              <br />
                              <Row style={{ marginTop: "20px" }}>
                                {row.visibletype === "Createtablerow" && (
                                  <table className="table table-bordered table-hover">
                                    <thead>
                                      <tr>
                                        <th className="text-center">S.NO</th>
                                        <th className="text-center">
                                          Action Type
                                        </th>
                                        <th className="text-center">
                                          Table Names
                                        </th>
                                        <th className="text-center">
                                          Column Names
                                        </th>
                                        <th className="text-center">Value</th>
                                        <th className="text-center">Actions</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {row.actions && row.actions.length > 0 ? (
                                        row.actions.map(
                                          (action, actionIndex) => (
                                            <tr key={action.tableId}>
                                              <td>{actionIndex + 1}</td>
                                              <td>{row.rtType}</td>
                                              <td>{action.rtTableName}</td>
                                              <td>{action.rtColumnName}</td>
                                              <td>
                                                {/* Make the Value cell editable with CreatableSelect */}
                                                <CreatableSelect
                                                  className="w-100"
                                                  isClearable
                                                  options={[
                                                    ...this.state.options,
                                                    ...this.state.optionsoutput,
                                                  ].map((api) => ({
                                                    value: api,
                                                    label: api,
                                                  }))}
                                                  value={
                                                    action.rtValue
                                                      ? {
                                                        value: action.rtValue,
                                                        label: action.rtValue,
                                                      }
                                                      : null
                                                  }
                                                  // onChange={(selectedOption) =>
                                                  //   this.inputRColumncreateChange(
                                                  //     selectedOption ? selectedOption.value : "",
                                                  //     index,
                                                  //     actionIndex
                                                  //   )
                                                  // }
                                                  onChange={(
                                                    selectedOption
                                                  ) => {
                                                    // Create a copy of rulescondition to avoid modifying state directly
                                                    const updatedRulescondition =
                                                      [
                                                        ...this.state
                                                          .rulescondition,
                                                      ];

                                                    // Update just this specific action's rtValue
                                                    if (
                                                      updatedRulescondition[
                                                      index
                                                      ] &&
                                                      updatedRulescondition[
                                                        index
                                                      ].actions &&
                                                      updatedRulescondition[
                                                        index
                                                      ].actions[actionIndex]
                                                    ) {
                                                      updatedRulescondition[
                                                        index
                                                      ].actions[
                                                        actionIndex
                                                      ].rtValue = selectedOption
                                                          ? selectedOption.value
                                                          : "";

                                                      // Update state with modified copy
                                                      this.setState({
                                                        rulescondition:
                                                          updatedRulescondition,
                                                      });
                                                    }
                                                  }}
                                                  placeholder="I/O Parameters"
                                                />
                                              </td>
                                              <td>
                                                <Button
                                                  variant="danger"
                                                  className="bi bi-trash-fill"
                                                  onClick={() =>
                                                    this.handleRemoveSpecificcreatetableSAction(
                                                      index,
                                                      action.tableId
                                                    )
                                                  }
                                                ></Button>
                                              </td>
                                            </tr>
                                          )
                                        )
                                      ) : (
                                        <tr>
                                          <td colSpan="6">No Records</td>
                                        </tr>
                                      )}
                                    </tbody>
                                  </table>
                                )}
                                {row.visibletype === "SendEmail" && (
                                  <div>
                                    <div>
                                      <Row>
                                        <Col lg="4" md="4">
                                          <select
                                            className="form-select"
                                            value={
                                              this.state.rActions.tableName
                                            }
                                            name="tableName"
                                            onChange={(e) =>
                                              this.inputtableRChange(e, index)
                                            }
                                          >
                                            <option defaultValue>
                                              Select Table
                                            </option>
                                            {this.state.tables.map(
                                              (api, index, idx) => (
                                                <option key={index} value={api}>
                                                  {api}
                                                </option>
                                              )
                                            )}
                                          </select>
                                        </Col>
                                        {/* <Col>
                                          <select
                                            className="form-select"
                                            aria-label="Default select example"
                                            value={
                                              this.state.rActions.columnName
                                            }
                                            name="columnName"
                                            onChange={(e) =>
                                              this.inputsetRColumnChange(
                                                e,
                                                index
                                              )
                                            }
                                          >
                                            <option defaultValue>
                                              Select Column
                                            </option>
                                            {this.state.rcolumns.map((api) => (
                                              <option key={api} value={api}>
                                                {api}
                                              </option>
                                            ))}
                                          </select>
                                        </Col> */}
                                      </Row>
                                    </div>
                                    <br />
                                    {row.selectedVariables &&
                                      row.selectedVariables.length > 0 && (
                                        <table className="table table-bordered table-hover mt-3">
                                          <thead>
                                            <tr>
                                              <th>S.NO</th>
                                              <th>Email Parameters</th>
                                              <th>Rule Parameters</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {row.selectedVariables.map(
                                              (variable, idx) => (
                                                <tr key={idx}>
                                                  <td>{idx + 1}</td>
                                                  <td>{variable}</td>
                                                  <td>
                                                    <select
                                                      className="form-select"
                                                      name="rtemailParams"
                                                      value={
                                                        row.rtemailParams?.[
                                                        variable
                                                        ] || ""
                                                      }
                                                      required="required"
                                                      aria-label="Default select example"
                                                      onChange={(e) => {
                                                        this.inputtableRChangeEmail(
                                                          e,
                                                          index,
                                                          variable
                                                        );

                                                        this.setState(
                                                          (prev) => ({
                                                            showCustomEmailInput:
                                                            {
                                                              ...prev.showCustomEmailInput,
                                                              [index +
                                                                "_" +
                                                                variable]:
                                                                e.target
                                                                  .value ===
                                                                "__custom__",
                                                            },
                                                          })
                                                        );
                                                      }}
                                                    >
                                                      <option defaultValue>
                                                        Select Column
                                                      </option>
                                                      {(
                                                        this.state
                                                          .inputParamsArray ||
                                                        []
                                                      ).map((api, i) => (
                                                        <option
                                                          key={`input_${i}`}
                                                          value={api}
                                                        >
                                                          {api}
                                                        </option>
                                                      ))}
                                                      {/* Output Params — unchanged */}
                                                      {(
                                                        this.state
                                                          .outputParamsArray ||
                                                        []
                                                      ).map((api, i) => (
                                                        <option
                                                          key={`output_${i}`}
                                                          value={api}
                                                        >
                                                          {api}
                                                        </option>
                                                      ))}
                                                      {/* Table Columns — only here add tableName. */}
                                                      {(
                                                        (this.state.rActions
                                                          .tableName &&
                                                          this.state
                                                            .rcolumns) ||
                                                        []
                                                      ).map((api, i) => (
                                                        <option
                                                          key={`col_${i}`}
                                                          value={`${this.state.rActions.tableName}.${api}`}
                                                        >
                                                          {
                                                            this.state.rActions
                                                              .tableName
                                                          }
                                                          .{api}
                                                        </option>
                                                      ))}
                                                      {/* {[
                                                        ...this.state.options,
                                                        ...this.state
                                                          .optionsoutput,
                                                      ].map((api, index) => (
                                                        <option
                                                          key={index}
                                                          value={api}
                                                        >
                                                          {api}
                                                        </option>
                                                      ))} */}
                                                      <option value="__custom__">
                                                        Type Manually...
                                                      </option>
                                                    </select>
                                                    {this.state
                                                      .showCustomEmailInput[
                                                      index + "_" + variable
                                                    ] && (
                                                        <input
                                                          type="text"
                                                          className="form-control mt-2"
                                                          placeholder="Enter custom value"
                                                          onChange={(e) =>
                                                            this.inputtableRChangeEmailCustom(
                                                              e,
                                                              index,
                                                              variable
                                                            )
                                                          }
                                                        />
                                                      )}
                                                  </td>
                                                </tr>
                                              )
                                            )}
                                          </tbody>
                                        </table>
                                      )}
                                    <div>
                                      {(this.state.outputParamsArray || []).map(
                                        (param, i) => (
                                          <>
                                            <Row className="mb-2" key={i}>
                                              <Col>
                                                <select
                                                  className="form-select"
                                                  value={
                                                    this.state.whereState[i]
                                                      ?.columnNamewhere || ""
                                                  }
                                                  onChange={(e) =>
                                                    this.handleWhereChange(
                                                      i,
                                                      "columnNamewhere",
                                                      e.target.value
                                                    )
                                                  }
                                                  name="columnNamewhere"
                                                >
                                                  <option defaultValue>
                                                    Output Parameters
                                                  </option>
                                                  {(
                                                    this.state
                                                      .outputParamsArray || []
                                                  ).map((api, i) => (
                                                    <option
                                                      key={`output_${i}`}
                                                      value={api}
                                                    >
                                                      {api}
                                                    </option>
                                                  ))}
                                                </select>
                                              </Col>{" "}
                                              = &nbsp;
                                              <Col key={i}>
                                                <select
                                                  className="form-select"
                                                  // name="tableName"
                                                  // value={this.state.tableName}
                                                  // onChange={
                                                  //   this.inputtableSChangewhere
                                                  // }
                                                  name={`tableName_${i}`} // unique name per row
                                                  value={
                                                    this.state.sendingData[
                                                    `tableName_${i}`
                                                    ] || ""
                                                  }
                                                  onChange={(e) =>
                                                    this.inputtableSChangewhere(
                                                      e,
                                                      i
                                                    )
                                                  }
                                                >
                                                  <option defaultValue>
                                                    Select Table
                                                  </option>
                                                  {this.state.tables.map(
                                                    (api, index, idx) => (
                                                      <option
                                                        key={index}
                                                        value={api}
                                                      >
                                                        {api}
                                                      </option>
                                                    )
                                                  )}
                                                </select>
                                              </Col>
                                              <Col>
                                                <select
                                                  className="form-select"
                                                  // value={this.state.columnName}
                                                  // name="columnName"
                                                  value={
                                                    this.state.sendingData[
                                                    `columnName_${i}`
                                                    ] || ""
                                                  }
                                                  name={`columnName_${i}`}
                                                  onChange={
                                                    this.inputSChangewherecol
                                                  }
                                                >
                                                  <option defaultValue>
                                                    Select Column
                                                  </option>
                                                  {this.state.rcolumnsWhere.map(
                                                    (api, index, idx) => (
                                                      <option
                                                        key={index}
                                                        value={api}
                                                      >
                                                        {api}
                                                      </option>
                                                    )
                                                  )}
                                                </select>
                                              </Col>
                                            </Row>
                                            <h4>Where</h4>
                                            <Table
                                              className="table table-bordered table-hover"
                                              id="tab_logic"
                                            >
                                              <thead>
                                                <tr>
                                                  <th className="text-center">
                                                    S.NO
                                                  </th>
                                                  <th className="text-center">
                                                    Columns
                                                  </th>
                                                  <th className="text-center">
                                                    Operators
                                                  </th>
                                                  <th className="text-center">
                                                    Value
                                                  </th>
                                                  <th className="text-center">
                                                    Operatorgates
                                                  </th>
                                                  <th className="text-center">
                                                    Actions
                                                  </th>
                                                </tr>
                                              </thead>
                                              <tbody>
                                                {(
                                                  this.state.whereByIndex[i] ||
                                                  []
                                                ).length > 0 ? (
                                                  this.state.whereByIndex[
                                                    i
                                                  ].map(
                                                    (condition, rowIndex) => (
                                                      <tr key={rowIndex}>
                                                        <td>{rowIndex + 1}</td>

                                                        {/* Column Name */}
                                                        <td>
                                                          {this.state
                                                            .editingByIndex[
                                                            i
                                                          ] === rowIndex ? (
                                                            <select
                                                              className="form-select"
                                                              name="tableNameNew"
                                                              value={
                                                                condition.tableNameNew
                                                              }
                                                              onChange={(e) =>
                                                                this.handleEditInputChangeParamzNew(
                                                                  i,
                                                                  rowIndex,
                                                                  "tableNameNew",
                                                                  e.target.value
                                                                )
                                                              }
                                                            >
                                                              <option>
                                                                Select
                                                              </option>
                                                              {this.state.rcolumnsWhere.map(
                                                                (
                                                                  api,
                                                                  index,
                                                                  idx
                                                                ) => (
                                                                  <option
                                                                    key={index}
                                                                    value={api}
                                                                  >
                                                                    {api}
                                                                  </option>
                                                                )
                                                              )}
                                                            </select>
                                                          ) : (
                                                            condition.tableNameNew
                                                          )}
                                                        </td>

                                                        {/* Operator */}
                                                        <td>
                                                          {this.state
                                                            .editingByIndex[
                                                            i
                                                          ] === rowIndex ? (
                                                            <select
                                                              className="form-select"
                                                              name="cOperatorNew"
                                                              value={
                                                                condition.cOperatorNew
                                                              }
                                                              onChange={(e) =>
                                                                this.handleEditInputChangeParamzNew(
                                                                  i,
                                                                  rowIndex,
                                                                  "cOperatorNew",
                                                                  e.target.value
                                                                )
                                                              }
                                                            >
                                                              <option>
                                                                Select
                                                              </option>
                                                              <option value="=">
                                                                =
                                                              </option>
                                                              <option value="<">
                                                                &lt;
                                                              </option>
                                                              <option value=">">
                                                                &gt;
                                                              </option>
                                                              <option value="<=">
                                                                &le;
                                                              </option>
                                                              <option value=">=">
                                                                &ge;
                                                              </option>
                                                              <option value="Between">
                                                                Between
                                                              </option>
                                                              <option value="Not Between">
                                                                Not Between
                                                              </option>
                                                            </select>
                                                          ) : (
                                                            condition.cOperatorNew
                                                          )}
                                                        </td>

                                                        {/* Value */}
                                                        <td>
                                                          {this.state
                                                            .editingByIndex[
                                                            i
                                                          ] === rowIndex ? (
                                                            <select
                                                              className="form-select"
                                                              name="cValueNew"
                                                              value={
                                                                condition.cValueNew
                                                              }
                                                              onChange={(e) =>
                                                                this.handleEditInputChangeParamzNew(
                                                                  i,
                                                                  rowIndex,
                                                                  "cValueNew",
                                                                  e.target.value
                                                                )
                                                              }
                                                            >
                                                              <option>
                                                                Select
                                                              </option>
                                                              {(
                                                                this.state
                                                                  .inputParamsArray ||
                                                                []
                                                              ).map(
                                                                (api, i) => (
                                                                  <option
                                                                    key={`input_${i}`}
                                                                    value={api}
                                                                  >
                                                                    {api}
                                                                  </option>
                                                                )
                                                              )}
                                                              {/* Output Params — unchanged */}
                                                              {(
                                                                this.state
                                                                  .outputParamsArray ||
                                                                []
                                                              ).map(
                                                                (api, i) => (
                                                                  <option
                                                                    key={`output_${i}`}
                                                                    value={api}
                                                                  >
                                                                    {api}
                                                                  </option>
                                                                )
                                                              )}
                                                            </select>
                                                          ) : (
                                                            condition.cValueNew
                                                          )}
                                                        </td>

                                                        {/* Gate */}
                                                        <td>
                                                          {this.state
                                                            .editingByIndex[
                                                            i
                                                          ] === rowIndex ? (
                                                            <select
                                                              className="form-select"
                                                              name="cGateNew"
                                                              value={
                                                                condition.cGateNew
                                                              }
                                                              onChange={(e) =>
                                                                this.handleEditInputChangeParamzNew(
                                                                  i,
                                                                  rowIndex,
                                                                  "cGateNew",
                                                                  e.target.value
                                                                )
                                                              }
                                                            >
                                                              <option>
                                                                Select
                                                              </option>
                                                              <option value="And">
                                                                And
                                                              </option>
                                                              <option value="Or">
                                                                Or
                                                              </option>
                                                              <option value="END">
                                                                END
                                                              </option>
                                                            </select>
                                                          ) : (
                                                            condition.cGateNew
                                                          )}
                                                        </td>

                                                        {/* Actions */}
                                                        <td>
                                                          {this.state
                                                            .editingByIndex[
                                                            i
                                                          ] === rowIndex && (
                                                              <Button
                                                                variant="info"
                                                                className="bi bi-check2-circle"
                                                                onClick={(e) =>
                                                                  this.updateSendParamzNew(
                                                                    e,
                                                                    i
                                                                  )
                                                                }
                                                              ></Button>
                                                            )}

                                                          <Button
                                                            variant="info"
                                                            className="bi bi-pen"
                                                            onClick={() =>
                                                              this.handleEditTableRowParamzNew(
                                                                i,
                                                                rowIndex
                                                              )
                                                            }
                                                          ></Button>

                                                          <Button
                                                            variant="warning"
                                                            className="bi bi-trash-fill"
                                                            onClick={() => {
                                                              this.setState(
                                                                (prev) => {
                                                                  const currentWhere =
                                                                    [
                                                                      ...(prev
                                                                        .whereByIndex[
                                                                        i
                                                                      ] || []),
                                                                    ];
                                                                  currentWhere.splice(
                                                                    rowIndex,
                                                                    1
                                                                  );
                                                                  return {
                                                                    whereByIndex:
                                                                    {
                                                                      ...prev.whereByIndex,
                                                                      [i]: currentWhere,
                                                                    },
                                                                  };
                                                                }
                                                              );
                                                              toast.success(
                                                                "WHERE condition deleted"
                                                              );
                                                            }}
                                                          ></Button>
                                                        </td>
                                                      </tr>
                                                    )
                                                  )
                                                ) : (
                                                  <tr>
                                                    <td colSpan="6">
                                                      No Records
                                                    </td>
                                                  </tr>
                                                )}

                                                {/* ADD NEW ROW */}
                                                <tr>
                                                  <td>1</td>

                                                  <td>
                                                    <select
                                                      className="form-select"
                                                      name="tableNameNew"
                                                      value={
                                                        (
                                                          this.state
                                                            .inputByIndex[i] ||
                                                          {}
                                                        ).tableNameNew || ""
                                                      }
                                                      onChange={(e) =>
                                                        this.inputtableSChangeNew(
                                                          e,
                                                          i
                                                        )
                                                      }
                                                    >
                                                      <option>Select</option>
                                                      {this.state.rcolumnsWhere.map(
                                                        (api, index, idx) => (
                                                          <option
                                                            key={index}
                                                            value={api}
                                                          >
                                                            {api}
                                                          </option>
                                                        )
                                                      )}
                                                    </select>
                                                  </td>

                                                  <td>
                                                    <select
                                                      className="form-select"
                                                      name="cOperatorNew"
                                                      value={
                                                        (
                                                          this.state
                                                            .inputByIndex[i] ||
                                                          {}
                                                        ).cOperatorNew || ""
                                                      }
                                                      onChange={(e) =>
                                                        this.handleColumnChangeNew(
                                                          e,
                                                          i
                                                        )
                                                      }
                                                    >
                                                      <option>Select</option>
                                                      <option value="=">
                                                        =
                                                      </option>
                                                      <option value="<">
                                                        &lt;
                                                      </option>
                                                      <option value=">">
                                                        &gt;
                                                      </option>
                                                      <option value="Between">
                                                        Between
                                                      </option>
                                                    </select>
                                                  </td>

                                                  <td>
                                                    <select
                                                      className="form-select"
                                                      name="cValueNew"
                                                      value={
                                                        (
                                                          this.state
                                                            .inputByIndex[i] ||
                                                          {}
                                                        ).cValueNew || ""
                                                      }
                                                      onChange={(e) => {
                                                        this.inputSChangeNew(
                                                          e,
                                                          i
                                                        );
                                                        if (
                                                          e.target.value ===
                                                          "__custom__"
                                                        ) {
                                                          this.setState(
                                                            (prev) => ({
                                                              showCustomInput: {
                                                                ...prev.showCustomInput,
                                                                [i]: true,
                                                              },
                                                            })
                                                          );
                                                        } else {
                                                          this.setState(
                                                            (prev) => ({
                                                              showCustomInput: {
                                                                ...prev.showCustomInput,
                                                                [i]: false,
                                                              },
                                                            })
                                                          );
                                                        }
                                                      }}
                                                    >
                                                      <option value="">
                                                        Select
                                                      </option>

                                                      {(
                                                        this.state
                                                          .inputParamsArray ||
                                                        []
                                                      ).map((api, i) => (
                                                        <option
                                                          key={`input_${i}`}
                                                          value={api}
                                                        >
                                                          {api}
                                                        </option>
                                                      ))}

                                                      {(
                                                        this.state
                                                          .outputParamsArray ||
                                                        []
                                                      ).map((api, i) => (
                                                        <option
                                                          key={`output_${i}`}
                                                          value={api}
                                                        >
                                                          {api}
                                                        </option>
                                                      ))}
                                                      {this.state.rcolumnsWhere.map(
                                                        (api, index, idx) => (
                                                          <option
                                                            key={index}
                                                            value={api}
                                                          >
                                                            {api}
                                                          </option>
                                                        )
                                                      )}
                                                      {/* Custom text option */}
                                                      <option value="__custom__">
                                                        Type Manually...
                                                      </option>
                                                    </select>

                                                    {/* Show textbox only when custom option selected */}
                                                    {(this.state
                                                      .showCustomInput || {})[
                                                      i
                                                    ] && (
                                                        <input
                                                          type="text"
                                                          className="form-control mt-2"
                                                          name="cValueNew"
                                                          placeholder="Enter custom value"
                                                          onChange={(e) =>
                                                            this.inputSChangeNew(
                                                              e,
                                                              i
                                                            )
                                                          }
                                                        />
                                                      )}
                                                  </td>
                                                  <td>
                                                    <select
                                                      className="form-select"
                                                      name="cGateNew"
                                                      value={
                                                        (
                                                          this.state
                                                            .inputByIndex[i] ||
                                                          {}
                                                        ).cGateNew || ""
                                                      }
                                                      onChange={(e) =>
                                                        this.inputSChangeNew(
                                                          e,
                                                          i
                                                        )
                                                      }
                                                    >
                                                      <option>Select</option>
                                                      <option value="And">
                                                        And
                                                      </option>
                                                      <option value="Or">
                                                        Or
                                                      </option>
                                                      <option value="END">
                                                        END
                                                      </option>
                                                    </select>
                                                  </td>

                                                  <td>
                                                    <Button
                                                      variant="success"
                                                      style={{
                                                        marginTop: "0px",
                                                      }}
                                                      onClick={(e) =>
                                                        this.addSendRowNew(e, i)
                                                      }
                                                    >
                                                      Add
                                                    </Button>
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </Table>
                                            <hr />
                                          </>
                                        )
                                      )}
                                    </div>
                                    <div>
                                      <Button
                                        variant="success"
                                        className="mt-3"
                                        onClick={(e) =>
                                          this.addEmailFormsubmitdata(e, index)
                                        }
                                        style={{
                                          float: "right",
                                          marginBottom: "10px",
                                        }}
                                      >
                                        Sent Email
                                      </Button>
                                      &nbsp;&nbsp;&nbsp;
                                    </div>
                                  </div>
                                )}
                                {row.visibletype === "UpdateTable" && (
                                  <table className="table table-bordered table-hover">
                                    <thead>
                                      <tr>
                                        <th className="text-center">S.NO</th>
                                        <th className="text-center">
                                          Action Type
                                        </th>
                                        <th className="text-center">
                                          Table Name
                                        </th>
                                        <th className="text-center">
                                          Set Column
                                        </th>
                                        <th className="text-center">
                                          Operator
                                        </th>
                                        <th className="text-center">
                                          I/O params
                                        </th>
                                        <th className="text-center">Gate</th>
                                        <th className="text-center">
                                          Where column
                                        </th>
                                        <th className="text-center">
                                          I/P Params
                                        </th>
                                        <th className="text-center">
                                          Operators
                                        </th>
                                        <th className="text-center">Actions</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {row.updateactions &&
                                        row.updateactions.length > 0 ? (
                                        row.updateactions.map(
                                          (action, actionIndex) => (
                                            <tr key={action.tableId}>
                                              <td>{actionIndex + 1}</td>
                                              <td>{row.rtType}</td>
                                              <td>
                                                {action.rtUpdateTableName}
                                              </td>
                                              <td>
                                                {action.rtUpdatesetcolumn}
                                              </td>
                                              <td>
                                                {action.rtUpdateSetOperator}
                                              </td>
                                              <td>{action.rtUpdateGate}</td>
                                              <td>
                                                {action.rtUpdateColumnName}
                                              </td>
                                              <td>{action.rtUpdateValuetwo}</td>
                                              <td>{action.rtUpdateOperator}</td>
                                              <td>
                                                <Button
                                                  variant="danger"
                                                  className="bi bi-trash-fill"
                                                  onClick={() =>
                                                    this.handleUpdateRemoveSpecific(
                                                      index,
                                                      action.tableId
                                                    )
                                                  }
                                                ></Button>
                                              </td>
                                            </tr>
                                          )
                                        )
                                      ) : (
                                        <tr>
                                          <td colSpan="9"> No Records</td>
                                        </tr>
                                      )}
                                    </tbody>
                                  </table>
                                )}
                                {row.visibletype === "SendSms" && (
                                  <div>
                                    <div>
                                      <Row>
                                        <Col lg="4" md="4">
                                          <select
                                            className="form-select"
                                            value={
                                              this.state.rActions.rtsmsName
                                            }
                                            name="rtsmsName"
                                            onChange={this.inputtableRsmsChange}
                                          >
                                            <option defaultValue>Select</option>
                                            {this.state.tables.map(
                                              (api, index) => (
                                                <option key={index} value={api}>
                                                  {api}
                                                </option>
                                              )
                                            )}
                                          </select>
                                        </Col>
                                      </Row>
                                    </div>
                                    <br />
                                    {row.selectedSmsVariables &&
                                      row.selectedSmsVariables.length > 0 && (
                                        <table className="table table-bordered table-hover mt-3">
                                          <thead>
                                            <tr>
                                              <th>S.NO</th>
                                              <th>SMS Parameters</th>
                                              <th>Rule Parameters</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {row.selectedSmsVariables.map(
                                              (variable, idx) => (
                                                <tr key={idx}>
                                                  <td>{idx + 1}</td>
                                                  <td>{variable}</td>
                                                  <td>
                                                    <select
                                                      className="form-select"
                                                      name="rtsmsparams"
                                                      value={
                                                        row.rtsmsparams?.[
                                                        variable
                                                        ] || ""
                                                      }
                                                      required
                                                      aria-label="Default select example"
                                                      onChange={(e) => {
                                                        this.inputtableRChangeSms(
                                                          e,
                                                          index,
                                                          variable
                                                        );

                                                        this.setState(
                                                          (prev) => ({
                                                            showCustomSmsInput:
                                                            {
                                                              ...prev.showCustomSmsInput,
                                                              [index +
                                                                "_" +
                                                                variable]:
                                                                e.target
                                                                  .value ===
                                                                "__custom__",
                                                            },
                                                          })
                                                        );
                                                      }}
                                                    >
                                                      <option defaultValue>
                                                        Select Parameter
                                                      </option>
                                                      {(
                                                        this.state
                                                          .inputParamsArray ||
                                                        []
                                                      ).map((api, i) => (
                                                        <option
                                                          key={`input_${i}`}
                                                          value={api}
                                                        >
                                                          {api}
                                                        </option>
                                                      ))}
                                                      {(
                                                        this.state
                                                          .outputParamsArray ||
                                                        []
                                                      ).map((api, i) => (
                                                        <option
                                                          key={`output_${i}`}
                                                          value={api}
                                                        >
                                                          {api}
                                                        </option>
                                                      ))}
                                                      {(
                                                        (this.state.rActions
                                                          .rtsmsName &&
                                                          this.state
                                                            .rcolumns) ||
                                                        []
                                                      ).map((api, i) => (
                                                        <option
                                                          key={`col_${i}`}
                                                          value={`${this.state.rActions.rtsmsName}.${api}`}
                                                        >
                                                          {
                                                            this.state.rActions
                                                              .rtsmsName
                                                          }
                                                          .{api}
                                                        </option>
                                                      ))}
                                                      <option value="__custom__">
                                                        Type Manually...
                                                      </option>
                                                    </select>
                                                    {this.state
                                                      .showCustomSmsInput[
                                                      index + "_" + variable
                                                    ] && (
                                                        <input
                                                          type="text"
                                                          className="form-control mt-2"
                                                          placeholder="Enter custom value"
                                                          onChange={(e) =>
                                                            this.inputtableRChangeSmsCustom(
                                                              e,
                                                              index,
                                                              variable
                                                            )
                                                          }
                                                        />
                                                      )}
                                                  </td>
                                                </tr>
                                              )
                                            )}
                                          </tbody>
                                        </table>
                                      )}
                                    <div>
                                      {(this.state.outputParamsArray || []).map(
                                        (param, i) => (
                                          <>
                                            <Row className="mb-2">
                                              <Col>
                                                <select
                                                  className="form-select"
                                                  value={
                                                    this.state.whereStateSms[i]
                                                      ?.columnsmswhere || ""
                                                  }
                                                  name="columnsmswhere"
                                                  onChange={(e) =>
                                                    this.handleWhereChangeSms(
                                                      i,
                                                      "columnsmswhere",
                                                      e.target.value
                                                    )
                                                  }
                                                >
                                                  <option defaultValue>
                                                    Output Parameters
                                                  </option>
                                                  {(
                                                    this.state
                                                      .outputParamsArray || []
                                                  ).map((api, idx) => (
                                                    <option
                                                      key={`output_${idx}`}
                                                      value={api}
                                                    >
                                                      {api}
                                                    </option>
                                                  ))}
                                                </select>
                                              </Col>{" "}
                                              = &nbsp;
                                              <Col>
                                                <select
                                                  className="form-select"
                                                  name={`tableName_${i}`}
                                                  value={
                                                    this.state.whereStateSms[i]
                                                      ?.tableName || ""
                                                  }
                                                  onChange={(e) =>
                                                    this.handleWhereChangeSms(
                                                      i,
                                                      "tableName",
                                                      e.target.value
                                                    )
                                                  }
                                                >
                                                  <option defaultValue>
                                                    Select Table
                                                  </option>
                                                  {this.state.tables.map(
                                                    (api, index, idx) => (
                                                      <option
                                                        key={index}
                                                        value={api}
                                                      >
                                                        {api}
                                                      </option>
                                                    )
                                                  )}
                                                </select>
                                              </Col>
                                              <Col>
                                                <select
                                                  className="form-select"
                                                  value={
                                                    this.state.whereStateSms[i]
                                                      ?.columnName || ""
                                                  }
                                                  name={`columnName_${i}`}
                                                  onChange={(e) =>
                                                    this.handleWhereChangeSms(
                                                      i,
                                                      "columnName",
                                                      e.target.value
                                                    )
                                                  }
                                                >
                                                  <option defaultValue>
                                                    Select Column
                                                  </option>
                                                  {this.state.rcolumnsWhereone.map(
                                                    (api, index, idx) => (
                                                      <option
                                                        key={index}
                                                        value={api}
                                                      >
                                                        {api}
                                                      </option>
                                                    )
                                                  )}
                                                </select>
                                              </Col>
                                            </Row>
                                            <h4>Where</h4>
                                            <Table
                                              className="table table-bordered table-hover"
                                              id="tab_logic"
                                            >
                                              <thead>
                                                <tr>
                                                  <th className="text-center">
                                                    S.NO
                                                  </th>
                                                  <th className="text-center">
                                                    Columns
                                                  </th>
                                                  <th className="text-center">
                                                    Operators
                                                  </th>
                                                  <th className="text-center">
                                                    Value
                                                  </th>
                                                  <th className="text-center">
                                                    Operatorgates
                                                  </th>
                                                  <th className="text-center">
                                                    Actions
                                                  </th>
                                                </tr>
                                              </thead>
                                              <tbody>
                                                {(
                                                  this.state.whereByIndexSms[
                                                  i
                                                  ] || []
                                                ).length > 0 ? (
                                                  this.state.whereByIndexSms[
                                                    i
                                                  ].map(
                                                    (condition, rowIndex) => (
                                                      <tr key={rowIndex}>
                                                        <td>{rowIndex + 1}</td>

                                                        {/* Column Name */}
                                                        <td>
                                                          {this.state
                                                            .editingByIndexSms[
                                                            i
                                                          ] === rowIndex ? (
                                                            <select
                                                              className="form-select"
                                                              name="tableNameNewone"
                                                              value={
                                                                condition.tableNameNewone
                                                              }
                                                              onChange={(e) =>
                                                                this.handleEditInputChangeParamzNewsms(
                                                                  i,
                                                                  rowIndex,
                                                                  "tableNameNewone",
                                                                  e.target.value
                                                                )
                                                              }
                                                            >
                                                              <option>
                                                                Select
                                                              </option>
                                                              {this.state.rcolumnsWhereone.map(
                                                                (
                                                                  api,
                                                                  index,
                                                                  idx
                                                                ) => (
                                                                  <option
                                                                    key={index}
                                                                    value={api}
                                                                  >
                                                                    {api}
                                                                  </option>
                                                                )
                                                              )}
                                                            </select>
                                                          ) : (
                                                            condition.tableNameNewone
                                                          )}
                                                        </td>

                                                        {/* Operator */}
                                                        <td>
                                                          {this.state
                                                            .editingByIndexSms[
                                                            i
                                                          ] === rowIndex ? (
                                                            <select
                                                              className="form-select"
                                                              name="cOperatorNewone"
                                                              value={
                                                                condition.cOperatorNewone
                                                              }
                                                              onChange={(e) =>
                                                                this.handleEditInputChangeParamzNewsms(
                                                                  i,
                                                                  rowIndex,
                                                                  "cOperatorNewone",
                                                                  e.target.value
                                                                )
                                                              }
                                                            >
                                                              <option>
                                                                Select
                                                              </option>
                                                              <option value="=">
                                                                =
                                                              </option>
                                                              <option value="<">
                                                                &lt;
                                                              </option>
                                                              <option value=">">
                                                                &gt;
                                                              </option>
                                                              <option value="<=">
                                                                &le;
                                                              </option>
                                                              <option value=">=">
                                                                &ge;
                                                              </option>
                                                              <option value="Between">
                                                                Between
                                                              </option>
                                                              <option value="Not Between">
                                                                Not Between
                                                              </option>
                                                            </select>
                                                          ) : (
                                                            condition.cOperatorNewone
                                                          )}
                                                        </td>

                                                        {/* Value */}
                                                        <td>
                                                          {this.state
                                                            .editingByIndexSms[
                                                            i
                                                          ] === rowIndex ? (
                                                            <select
                                                              className="form-select"
                                                              name="cValueNewone"
                                                              value={
                                                                condition.cValueNewone
                                                              }
                                                              onChange={(e) =>
                                                                this.handleEditInputChangeParamzNewsms(
                                                                  i,
                                                                  rowIndex,
                                                                  "cValueNewone",
                                                                  e.target.value
                                                                )
                                                              }
                                                            >
                                                              <option>
                                                                Select
                                                              </option>
                                                              {(
                                                                this.state
                                                                  .inputParamsArray ||
                                                                []
                                                              ).map(
                                                                (api, i) => (
                                                                  <option
                                                                    key={`input_${i}`}
                                                                    value={api}
                                                                  >
                                                                    {api}
                                                                  </option>
                                                                )
                                                              )}
                                                              {/* Output Params — unchanged */}
                                                              {(
                                                                this.state
                                                                  .outputParamsArray ||
                                                                []
                                                              ).map(
                                                                (api, i) => (
                                                                  <option
                                                                    key={`output_${i}`}
                                                                    value={api}
                                                                  >
                                                                    {api}
                                                                  </option>
                                                                )
                                                              )}
                                                              {this.state.rcolumnsWhereone.map(
                                                                (
                                                                  api,
                                                                  index,
                                                                  idx
                                                                ) => (
                                                                  <option
                                                                    key={index}
                                                                    value={api}
                                                                  >
                                                                    {api}
                                                                  </option>
                                                                )
                                                              )}
                                                            </select>
                                                          ) : (
                                                            condition.cValueNewone
                                                          )}
                                                        </td>

                                                        {/* Gate */}
                                                        <td>
                                                          {this.state
                                                            .editingByIndexSms[
                                                            i
                                                          ] === rowIndex ? (
                                                            <select
                                                              className="form-select"
                                                              name="cGateNewone"
                                                              value={
                                                                condition.cGateNewone
                                                              }
                                                              onChange={(e) =>
                                                                this.handleEditInputChangeParamzNewsms(
                                                                  i,
                                                                  rowIndex,
                                                                  "cGateNewone",
                                                                  e.target.value
                                                                )
                                                              }
                                                            >
                                                              <option>
                                                                Select
                                                              </option>
                                                              <option value="And">
                                                                And
                                                              </option>
                                                              <option value="Or">
                                                                Or
                                                              </option>
                                                              <option value="END">
                                                                END
                                                              </option>
                                                            </select>
                                                          ) : (
                                                            condition.cGateNewone
                                                          )}
                                                        </td>

                                                        {/* Actions */}
                                                        <td>
                                                          {this.state
                                                            .editingByIndexSms[
                                                            i
                                                          ] === rowIndex && (
                                                              <Button
                                                                variant="info"
                                                                className="bi bi-check2-circle"
                                                                onClick={(e) =>
                                                                  this.updateSendParamzNewone(
                                                                    e,
                                                                    i
                                                                  )
                                                                }
                                                              ></Button>
                                                            )}

                                                          <Button
                                                            variant="info"
                                                            className="bi bi-pen"
                                                            onClick={() =>
                                                              this.handleEditTableRowParamzNewone(
                                                                i,
                                                                rowIndex
                                                              )
                                                            }
                                                          ></Button>

                                                          <Button
                                                            variant="warning"
                                                            className="bi bi-trash-fill"
                                                            onClick={() => {
                                                              this.setState(
                                                                (prev) => {
                                                                  const currentWhere =
                                                                    [
                                                                      ...(prev
                                                                        .whereByIndexSms[
                                                                        i
                                                                      ] || []),
                                                                    ];
                                                                  currentWhere.splice(
                                                                    rowIndex,
                                                                    1
                                                                  );
                                                                  return {
                                                                    whereByIndexSms:
                                                                    {
                                                                      ...prev.whereByIndexSms,
                                                                      [i]: currentWhere,
                                                                    },
                                                                  };
                                                                }
                                                              );
                                                              toast.success(
                                                                "WHERE condition deleted"
                                                              );
                                                            }}
                                                          ></Button>
                                                        </td>
                                                      </tr>
                                                    )
                                                  )
                                                ) : (
                                                  <tr>
                                                    <td colSpan="6">
                                                      No Records
                                                    </td>
                                                  </tr>
                                                )}

                                                {/* ADD NEW ROW */}
                                                <tr>
                                                  <td>1</td>

                                                  <td>
                                                    <select
                                                      className="form-select"
                                                      name="tableNameNewone"
                                                      value={
                                                        (
                                                          this.state
                                                            .inputByIndexSms[
                                                          i
                                                          ] || {}
                                                        ).tableNameNewone || ""
                                                      }
                                                      onChange={(e) =>
                                                        this.inputtableSChangeNewsms(
                                                          e,
                                                          i
                                                        )
                                                      }
                                                    >
                                                      <option>Select</option>
                                                      {this.state.rcolumnsWhereone.map(
                                                        (api, index, idx) => (
                                                          <option
                                                            key={index}
                                                            value={api}
                                                          >
                                                            {api}
                                                          </option>
                                                        )
                                                      )}
                                                    </select>
                                                  </td>

                                                  <td>
                                                    <select
                                                      className="form-select"
                                                      name="cOperatorNewone"
                                                      value={
                                                        (
                                                          this.state
                                                            .inputByIndexSms[
                                                          i
                                                          ] || {}
                                                        ).cOperatorNewone || ""
                                                      }
                                                      onChange={(e) =>
                                                        this.handleColumnChangeNewsms(
                                                          e,
                                                          i
                                                        )
                                                      }
                                                    >
                                                      <option>Select</option>
                                                      <option value="=">
                                                        =
                                                      </option>
                                                      <option value="<">
                                                        &lt;
                                                      </option>
                                                      <option value=">">
                                                        &gt;
                                                      </option>
                                                      <option value="Between">
                                                        Between
                                                      </option>
                                                    </select>
                                                  </td>

                                                  <td>
                                                    <select
                                                      className="form-select"
                                                      name="cValueNewone"
                                                      value={
                                                        (
                                                          this.state
                                                            .inputByIndexSms[
                                                          i
                                                          ] || {}
                                                        ).cValueNewone || ""
                                                      }
                                                      onChange={(e) => {
                                                        this.inputSChangeNewsms(
                                                          e,
                                                          i
                                                        );
                                                        if (
                                                          e.target.value ===
                                                          "__custom__"
                                                        ) {
                                                          this.setState(
                                                            (prev) => ({
                                                              showCustomInputSms:
                                                              {
                                                                ...prev.showCustomInputSms,
                                                                [i]: true,
                                                              },
                                                            })
                                                          );
                                                        } else {
                                                          this.setState(
                                                            (prev) => ({
                                                              showCustomInputSms:
                                                              {
                                                                ...prev.showCustomInputSms,
                                                                [i]: false,
                                                              },
                                                            })
                                                          );
                                                        }
                                                      }}
                                                    >
                                                      <option value="">
                                                        Select
                                                      </option>

                                                      {(
                                                        this.state
                                                          .inputParamsArray ||
                                                        []
                                                      ).map((api, i) => (
                                                        <option
                                                          key={`input_${i}`}
                                                          value={api}
                                                        >
                                                          {api}
                                                        </option>
                                                      ))}

                                                      {(
                                                        this.state
                                                          .outputParamsArray ||
                                                        []
                                                      ).map((api, i) => (
                                                        <option
                                                          key={`output_${i}`}
                                                          value={api}
                                                        >
                                                          {api}
                                                        </option>
                                                      ))}
                                                      {this.state.rcolumnsWhereone.map(
                                                        (api, index, idx) => (
                                                          <option
                                                            key={index}
                                                            value={api}
                                                          >
                                                            {api}
                                                          </option>
                                                        )
                                                      )}
                                                      {/* Custom text option */}
                                                      <option value="__custom__">
                                                        Type Manually...
                                                      </option>
                                                    </select>

                                                    {/* Show textbox only when custom option selected */}
                                                    {(this.state
                                                      .showCustomInputSms ||
                                                      {})[i] && (
                                                        <input
                                                          type="text"
                                                          className="form-control mt-2"
                                                          name="cValueNewone"
                                                          placeholder="Enter custom value"
                                                          onChange={(e) =>
                                                            this.inputSChangeNewsms(
                                                              e,
                                                              i
                                                            )
                                                          }
                                                        />
                                                      )}
                                                  </td>
                                                  <td>
                                                    <select
                                                      className="form-select"
                                                      name="cGateNewone"
                                                      value={
                                                        (
                                                          this.state
                                                            .inputByIndexSms[
                                                          i
                                                          ] || {}
                                                        ).cGateNewone || ""
                                                      }
                                                      onChange={(e) =>
                                                        this.inputSChangeNewsms(
                                                          e,
                                                          i
                                                        )
                                                      }
                                                    >
                                                      <option>Select</option>
                                                      <option value="And">
                                                        And
                                                      </option>
                                                      <option value="Or">
                                                        Or
                                                      </option>
                                                      <option value="END">
                                                        END
                                                      </option>
                                                    </select>
                                                  </td>

                                                  <td>
                                                    <Button
                                                      variant="success"
                                                      style={{
                                                        marginTop: "0px",
                                                      }}
                                                      onClick={(e) =>
                                                        this.addSendRowNewsms(
                                                          e,
                                                          i
                                                        )
                                                      }
                                                    >
                                                      Add
                                                    </Button>
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </Table>
                                            <hr />
                                          </>
                                        )
                                      )}
                                    </div>
                                    <Button
                                      variant="success"
                                      className="mt-3 bi bi-plus"
                                      onClick={(e) =>
                                        this.addSmsFormsubmitdata(e, index)
                                      }
                                      style={{
                                        float: "right",
                                        marginBottom: "10px",
                                      }}
                                    >
                                      Send Sms
                                    </Button>
                                  </div>
                                )}
                                {row.visibletype === "CallAPI" && (
                                  <table className="table table-bordered table-hover">
                                    <thead>
                                      <tr>
                                        <th className="text-center">S.NO</th>
                                        <th className="text-center">
                                          Action Type
                                        </th>
                                        <th className="text-center">
                                          Integration Type
                                        </th>
                                        <th className="text-center">
                                          Api Type
                                        </th>
                                        <th className="text-center">
                                          Request Id
                                        </th>
                                        <th className="text-center">Value</th>
                                        <th className="text-center">Actions</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {row.apiactions &&
                                        row.apiactions.length > 0 ? (
                                        row.apiactions.map(
                                          (action, actionIndex) => (
                                            <tr key={action.tableId}>
                                              <td>{actionIndex + 1}</td>
                                              <td>{row.rtType}</td>
                                              <td>{action.rtApiTemplate}</td>
                                              <td>{action.rtApiName}</td>
                                              <td>{action.rtApiReqId}</td>
                                              <td>{action.rtApiValue}</td>
                                              <td>
                                                <Button
                                                  variant="danger"
                                                  className="bi bi-trash-fill"
                                                  onClick={() =>
                                                    this.handleCallapiRemoveSpecific(
                                                      index,
                                                      action.tableId
                                                    )
                                                  }
                                                // idx={idx}
                                                ></Button>
                                              </td>
                                            </tr>
                                          )
                                        )
                                      ) : (
                                        <tr>
                                          <td colSpan="9"> No Records</td>
                                        </tr>
                                      )}
                                    </tbody>
                                  </table>
                                )}
                                {row.visibletype === "whatsapp" && (
                                  <div>
                                    <div>
                                      <Row>
                                        <Col lg="3">
                                          <select
                                            className="form-select"
                                            value={DefaultData.tableName}
                                            name="tableName"
                                            onChange={this.inputRColumnChange}
                                          >
                                            <option defaultValue>Select</option>
                                            {this.state.options.map(
                                              (api, index, idx) => (
                                                <option key={index} value={api}>
                                                  {api}
                                                </option>
                                              )
                                            )}
                                          </select>
                                        </Col>
                                      </Row>
                                    </div>
                                    <br />
                                    <table className="table table-bordered table-hover">
                                      <thead>
                                        <tr>
                                          <th className="text-center">S.NO</th>
                                          <th className="text-center">
                                            Whatsap paramsters
                                          </th>
                                          <th className="text-center">
                                            Rules Parameters
                                          </th>
                                          <th className="text-center">Text</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {this.state.whatsapactions.map(
                                          (action, index, idx) => (
                                            <tr key={index}>
                                              <td>{index + 1}</td>
                                              <td>{row.rtTemplate}</td>
                                              <td>
                                                <select
                                                  className="form-select"
                                                  value={row.rtTemplate}
                                                  name="rtTemplate"
                                                  required="required"
                                                  aria-label="Default select example"
                                                  onChange={(e) =>
                                                    this.inputtableRChange(
                                                      e,
                                                      index
                                                    )
                                                  }
                                                >
                                                  <option defaultValue>
                                                    Select Parameter
                                                  </option>
                                                  {[
                                                    ...this.state.options,
                                                    ...this.state.optionsoutput,
                                                  ].map((api, index) => (
                                                    <option
                                                      key={index}
                                                      value={api}
                                                    >
                                                      {api}
                                                    </option>
                                                  ))}
                                                </select>
                                              </td>
                                              <td>
                                                <Form.Control
                                                  name={"rvame"}
                                                  value={DefaultData.rVame}
                                                  onChange={this.inputChange}
                                                  required="required"
                                                  type="text"
                                                  placeholder="Enter Text"
                                                  className="form-control"
                                                />
                                              </td>
                                            </tr>
                                          )
                                        )}
                                      </tbody>
                                    </table>
                                  </div>
                                )}
                              </Row>
                              <hr />
                            </>
                          ))}
                        </Row>
                      </Row>
                      <Row>
                        <Col
                          className="d-flex justify-content-end"
                          style={{ marginRight: "50px" }}
                        >
                          <Button
                            className="button"
                            variant="success"
                            onClick={this.handleSubmitClick}
                            style={{
                              borderRadius: "0px",
                              marginTop: "20px",
                            }}
                          >
                            Save
                          </Button>
                        </Col>
                      </Row>
                    </Container>
                  </Offcanvas.Body>
                </Offcanvas>
              </Col>
            </Row>
          </div>
          <br />
          <div>
            {this.state.isEditing && (
              <Offcanvas
                show={this.state.isEditing}
                onHide={() => this.setState({ isEditing: false })}
                {...this.props}
                style={{ width: "1120px" }}
                placement="end"
                backdrop="true"
              >
                <Offcanvas.Header closeButton>
                  <Offcanvas.Title>New Rule page</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                  <Container style={{ overflowY: "auto", height: "auto" }}>
                    <Row className="divstyle">
                      <Row>
                        <Form>
                          <Row>
                            <Form.Group
                              className="mb-3"
                              controlId="formBasicPassword"
                            >
                              <Row>
                                <Col lg="4" md="4">
                                  <Form.Label>Rule Group</Form.Label>
                                </Col>
                                <Col lg="4" md="4">
                                  <Form.Select
                                    name="rulegroup"
                                    value={this.state.rulegroupId}
                                    onChange={this.handlerulegroupIdChange}
                                    required="required"
                                    //type="select"
                                    placeholder="Select Old Entries"
                                    className="form-control"
                                    aria-label="Default select example"
                                  >
                                    <option>Select Group</option>
                                    {this.state.rulegroup.map(
                                      (api, index, idx) => (
                                        <option
                                          key={index}
                                          value={api.rulegroups_Id}
                                        >
                                          {api.name}
                                        </option>
                                      )
                                    )}
                                  </Form.Select>
                                </Col>
                              </Row>
                            </Form.Group>
                          </Row>
                          <Row>
                            <Form.Group
                              className="mb-3"
                              controlId="formBasicPassword"
                            >
                              <Row>
                                <Col lg="4" md="4">
                                  <Form.Label>Rule Name</Form.Label>
                                </Col>
                                <Col lg="4" md="4">
                                  <Form.Control
                                    name={"name"}
                                    value={this.state.name}
                                    onChange={this.handlenameChange}
                                    required="required"
                                    type="text"
                                    placeholder="Enter Rule Name"
                                    className="form-control"
                                  />
                                </Col>
                              </Row>
                            </Form.Group>
                          </Row>
                          <Row>
                            <Form.Group
                              className="mb-3"
                              controlId="exampleForm.ControlTextarea1"
                            >
                              <Row>
                                <Col lg="4" md="4">
                                  <Form.Label>Rule description</Form.Label>
                                </Col>
                                <Col lg="4" md="4">
                                  <Form.Control
                                    as="textarea"
                                    rows={3}
                                    name={"description"}
                                    value={this.state.description}
                                    onChange={this.handledescriptionChange}
                                    required="required"
                                    placeholder="Enter Rule Description"
                                    className="form-control"
                                  />
                                </Col>
                              </Row>
                            </Form.Group>
                          </Row>
                          <Row className="mb-3">
                            <Form.Group>
                              <Row>
                                <Col lg="4" md="4">
                                  <Form.Label>Select Table</Form.Label>
                                </Col>
                                <Col lg="4" md="4">
                                  <Form.Select
                                    value={this.state.selectedTable}
                                    onChange={this.handleTableSelect}
                                    isInvalid={
                                      !!this.state.errors.selectedTable
                                    }
                                  >
                                    <option value="">Choose a table...</option>
                                    {this.state.tables.map((table, index) => (
                                      <option key={index} value={table}>
                                        {table}
                                      </option>
                                    ))}
                                  </Form.Select>
                                </Col>
                              </Row>
                            </Form.Group>
                          </Row>
                          <Row className="mb-3">
                            <Form.Group>
                              <Row>
                                <Col lg="4" md="4">
                                  <Form.Label>Trigger Event</Form.Label>
                                </Col>
                                <Col lg="4" md="4">
                                  <Form.Select
                                    value={this.state.selectedTriggerEvent}
                                    onChange={(e) =>
                                      this.setState({
                                        selectedTriggerEvent: e.target.value,
                                      })
                                    }
                                    isInvalid={
                                      !!this.state.errors.selectedTriggerEvent
                                    }
                                  >
                                    <option value="">
                                      Choose trigger event...
                                    </option>
                                    {this.state.triggerEvents.map(
                                      (event, index) => (
                                        <option key={index} value={event}>
                                          {event.toUpperCase()}
                                        </option>
                                      )
                                    )}
                                  </Form.Select>
                                </Col>
                              </Row>
                            </Form.Group>
                          </Row>
                          <Row>
                            <Form.Group
                              className="mb-3"
                              controlId="formBasicPassword"
                            >
                              <Row>
                                <Col lg="4" md="4">
                                  <Form.Label>Input Parameters</Form.Label>
                                </Col>
                                <Col lg="4" md="4">
                                  <Form.Control
                                    name={"ruleinputparameters"}
                                    value={this.state.ruleinputparameters}
                                    onChange={this.handleinputparamsChanges}
                                    onBlur={this.handleinputSelects}
                                    required="required"
                                    type="text"
                                    placeholder="Enter Input Parameters"
                                    className="form-control"
                                  />
                                </Col>
                              </Row>
                            </Form.Group>
                          </Row>
                          <Row>
                            <Form.Group
                              className="mb-3"
                              controlId="formBasicPassword"
                            >
                              <Row>
                                <Col lg="4" md="4">
                                  <Form.Label>Output Parameters</Form.Label>
                                </Col>
                                <Col lg="4" md="4">
                                  <Form.Control
                                    name={"ruleoutputparameters"}
                                    value={this.state.ruleoutputparameters}
                                    onChange={this.handleoutputparamsChanges}
                                    onBlur={this.handleoutputSelects}
                                    required="required"
                                    type="text"
                                    placeholder="Enter Output Parameters"
                                    className="form-control"
                                  />
                                </Col>
                              </Row>
                            </Form.Group>
                          </Row>
                          <Row>
                            <Col lg="4" md="4">
                              <Form.Label style={{ paddingTop: "8px" }}>
                                Version
                              </Form.Label>
                            </Col>
                            <Col lg="8" md="8">
                              <Form.Control
                                type="text"
                                onChange={this.handleversionChange}
                                className="form-control"
                                name="version"
                                value={this.state.version}
                                required="required"
                                placeholder="Enter Version"
                              />
                            </Col>
                          </Row>
                          <br />
                        </Form>
                      </Row>
                      <br />
                      <Row className="d-flex" style={{ marginTop: "20px" }}>
                        <h4>if</h4>
                        <Table
                          className="table table-bordered table-hover"
                          id="tab_logic"
                        >
                          <thead>
                            <tr>
                              <th className="text-center">S.NO</th>
                              <th className="text-center">Input Parameter</th>
                              <th className="text-center">Operators</th>
                              <th className="text-center">Value</th>
                              <th className="text-center">Operatorgates</th>
                              <th className="text-center">Actions</th>
                            </tr>
                          </thead>
                          <tbody>
                            {this.state.conditions.length > 0 ? (
                              this.state.conditions.map(
                                (condition, index, idx) => (
                                  <tr key={index}>
                                    <td>{index + 1}</td>
                                    <td>
                                      {this.state.editingIndex === index ? (
                                        <select
                                          className="form-select"
                                          name="ruleinputparameters"
                                          value={condition.ruleinputparameters}
                                          onChange={(e) =>
                                            this.handleEditInputChangeParamzs(
                                              index,
                                              "ruleinputparameters",
                                              e.target.value
                                            )
                                          }
                                        >
                                          <option defaultValue>
                                            Select Table
                                          </option>
                                          {this.state.options.map(
                                            (api, index, idx) => (
                                              <option key={index} value={api}>
                                                {api}
                                              </option>
                                            )
                                          )}
                                        </select>
                                      ) : (
                                        condition.tableName
                                      )}
                                    </td>
                                    <td>
                                      {this.state.editingIndex === index ? (
                                        <select
                                          className="form-select"
                                          value={condition.cOperator}
                                          name="cOperator"
                                          onChange={(e) =>
                                            this.handleEditInputChangeParamz(
                                              index,
                                              "cOperator",
                                              e.target.value
                                            )
                                          }
                                        >
                                          <option defaultValue>
                                            Select Column
                                          </option>
                                          <option value="=">=</option>
                                          <option value="<">&lt;</option>
                                          <option value=">">&gt;</option>
                                          <option value="<=">&le;</option>
                                          <option value=">=">&ge;</option>
                                          <option value="Between">
                                            Between
                                          </option>
                                          <option value="Not Between">
                                            Not Between
                                          </option>
                                          <option value="Is Empty">
                                            Is Empty
                                          </option>
                                          <option value="Is Not Empty">
                                            Is Not Empty
                                          </option>
                                        </select>
                                      ) : (
                                        condition.cOperator
                                      )}
                                    </td>
                                    <td>
                                      {this.state.editingIndex === index ? (
                                        <Form.Control
                                          type="Text"
                                          name="cValue"
                                          placeholder="sample"
                                          value={condition.cValue}
                                          onChange={(e) =>
                                            this.handleEditInputChangeParamz(
                                              index,
                                              "cValue",
                                              e.target.value
                                            )
                                          }
                                        />
                                      ) : (
                                        condition.cValue
                                      )}
                                    </td>
                                    <td>
                                      {this.state.editingIndex === index ? (
                                        <select
                                          className="form-select"
                                          value={condition.cGate}
                                          name="cGate"
                                          onChange={(e) =>
                                            this.handleEditInputChangeParamz(
                                              index,
                                              "cGate",
                                              e.target.value
                                            )
                                          }
                                        >
                                          <option defaultValue>
                                            Select Column
                                          </option>
                                          <option value="And">And</option>
                                          <option value="Or">Or</option>
                                          <option value="END">END</option>
                                        </select>
                                      ) : (
                                        condition.cGate
                                      )}
                                    </td>
                                    <td>
                                      {this.state.editingIndex === index && ( // Extra "Add" button below the row being edited
                                        <Button
                                          type="button"
                                          variant="success"
                                          onClick={this.updateSendParamz}
                                        >
                                          update
                                        </Button>
                                      )}
                                      <Button
                                        className="bi bi-pen"
                                        variant="info"
                                        onClick={() =>
                                          this.handleEditTableRowParamz(index)
                                        }
                                      ></Button>
                                      {this.state.editingIndex !== index && (
                                        <Button
                                          variant="warning"
                                          className="bi bi-trash-fill"
                                          onClick={() =>
                                            this.handleRemoveSpecificRowS(index)
                                          }
                                        ></Button>
                                      )}
                                    </td>
                                  </tr>
                                )
                              )
                            ) : (
                              <tr>
                                <td colSpan="7"> No Records</td>
                              </tr>
                            )}
                            <tr>
                              <td>1</td>
                              <td>
                                <select
                                  className="form-select"
                                  value={DefaultData.tableName}
                                  name="tableName"
                                  onChange={this.inputtableSChange}
                                >
                                  <option defaultValue>Select</option>
                                  {this.state.options.map((api, index, idx) => (
                                    <option key={index} value={api}>
                                      {api}
                                    </option>
                                  ))}
                                </select>
                                <div
                                  className="errorMsg"
                                  style={{ color: "red" }}
                                >
                                  {this.state.errors.tableName}
                                </div>
                              </td>
                              <td>
                                <select
                                  className="form-select"
                                  aria-label="Default select example"
                                  value={DefaultData.cOperator}
                                  name="cOperator"
                                  onChange={this.handleColumnChange}
                                >
                                  <option defaultValue>Select</option>
                                  <option value="=">=</option>
                                  <option value="<">&lt;</option>
                                  <option value=">">&gt;</option>
                                  <option value="<=">&le;</option>
                                  <option value=">=">&ge;</option>
                                  <option value="Between">Between</option>
                                  <option value="Not Between">
                                    Not Between
                                  </option>
                                  <option value="Is Empty">Is Empty</option>
                                  <option value="Is Not Empty">
                                    Is Not Empty
                                  </option>
                                </select>
                                <div
                                  className="errorMsg"
                                  style={{ color: "red" }}
                                >
                                  {this.state.errors.cOperator}
                                </div>
                                {/* <p>Selected value: {this.state.COLUMN_NAME}</p> */}
                              </td>
                              <td>
                                <>
                                  <Form.Control
                                    value={DefaultData.cValue}
                                    name="cValue"
                                    required="required"
                                    placeholder="Value."
                                    onChange={this.inputSChange}
                                  ></Form.Control>
                                  <div
                                    className="errorMsg"
                                    style={{ color: "red" }}
                                  >
                                    {this.state.errors.cValue}
                                  </div>
                                </>
                              </td>
                              <td>
                                <select
                                  className="form-select"
                                  aria-label="Default select example"
                                  value={DefaultData.cGate}
                                  name="cGate"
                                  required="required"
                                  onChange={this.inputSChange}
                                >
                                  <option defaultValue>SelectGates</option>
                                  <option value="And">And</option>
                                  <option value="Or">Or</option>
                                  <option value="END">END</option>
                                </select>
                                <div
                                  className="errorMsg"
                                  style={{ color: "red" }}
                                >
                                  {this.state.errors.cGate}
                                </div>
                              </td>
                              <td>
                                <Button
                                  variant="success"
                                  style={{ marginTop: "3px" }}
                                  onClick={this.addSendRow}
                                >
                                  Add
                                </Button>
                              </td>
                            </tr>
                          </tbody>
                        </Table>
                      </Row>
                      <br />
                      <Row className="mt-3 d-flex">
                        <Row>
                          <Col lg="1">
                            <h4>Do</h4>
                          </Col>
                          <Col lg="1">
                            &nbsp;
                            <Button
                              className="bi bi-plus mt-3"
                              onClick={this.handleAddRowRules}
                            ></Button>
                          </Col>
                        </Row>
                        {this.state.rulescondition.map((row, index) => (
                          <>
                            <div
                              key={row.id || index}
                              style={{ display: "flex" }}
                            >
                              <div>
                                <select
                                  style={{
                                    marginTop: "16px",
                                    width: "150px",
                                  }}
                                  className="form-select"
                                  aria-label="Default select example"
                                  value={this.state.rActions.rtType}
                                  name="rtType"
                                  required="required"
                                  onChange={(e) => this.inputRChange(e, index)}
                                >
                                  <option>Action Type</option>
                                  <option value="Createtablerow">
                                    Create Table Row
                                  </option>
                                  <option value="UpdateTable">
                                    Update Table
                                  </option>
                                  <option value="SendEmail">Send Email</option>
                                  <option value="SendSms">Send Sms</option>
                                  <option value="CallAPI">Call API</option>
                                  <option value="whatsapp">
                                    Send What'sapp Message
                                  </option>
                                </select>
                              </div>
                              &nbsp;&nbsp;
                              <div>
                                {row.visibletype === "SendEmail" && (
                                  <>
                                    <select
                                      style={{ width: "150px" }}
                                      className="form-select mt-3"
                                      value={row.rtEmailTemplates}
                                      name="rtEmailTemplates"
                                      required="required"
                                      aria-label="Default select example"
                                      onChange={(e) =>
                                        this.inputtableREmailselectChange(
                                          e,
                                          index
                                        )
                                      }
                                    >
                                      <option defaultValue>Select Email</option>
                                      {this.state.Emailtemplate.map(
                                        (api, index) => (
                                          <option
                                            key={api.emailtemplates_Id}
                                            value={api.name}
                                          >
                                            {api.name}
                                          </option>
                                        )
                                      )}
                                    </select>
                                  </>
                                )}
                                {row.visibletype === "SendSms" && (
                                  <select
                                    style={{ width: "150px" }}
                                    className="form-select mt-3"
                                    value={row.rtSmsTemplates || ""}
                                    name="rtSmsTemplates"
                                    required="required"
                                    aria-label="Default select example"
                                    onChange={(e) =>
                                      this.inputtableRSmsselectChange(e, index)
                                    }
                                  >
                                    <option defaultValue>Select SendSms</option>
                                    {this.state.Smstemplates.map(
                                      (api, index) => (
                                        <option
                                          key={api.smstemplates_Id}
                                          value={api.name}
                                        >
                                          {api.name}
                                        </option>
                                      )
                                    )}
                                  </select>
                                )}
                                {row.visibletype === "CallAPI" && (
                                  <select
                                    style={{ width: "150px" }}
                                    className="form-select mt-3"
                                    value={this.state.rActions.rtApiTemplate}
                                    name="rtApiTemplate"
                                    required="required"
                                    aria-label="Default select example"
                                    onChange={(e) =>
                                      this.inputtableRChange(e, index)
                                    }
                                  >
                                    <option defaultValue>
                                      Integration type
                                    </option>
                                    {this.state.integrationtype.map(
                                      (api, index) => (
                                        <option key={api} value={api.typeName}>
                                          {api.typeName}
                                        </option>
                                      )
                                    )}
                                  </select>
                                )}
                                {row.visibletype === "whatsapp" && (
                                  <select
                                    style={{ width: "150px" }}
                                    className="form-select mt-3"
                                    value={this.state.rActions.rtTemplate}
                                    name="rtTemplate"
                                    required="required"
                                    aria-label="Default select example"
                                    onChange={(e) =>
                                      this.inputtableRChange(e, index)
                                    }
                                  >
                                    <option defaultValue>
                                      {" "}
                                      select message
                                    </option>
                                    {this.state.templates.map((api, index) => (
                                      <option key={api} value={api.tName}>
                                        {api.tName}
                                      </option>
                                    ))}
                                  </select>
                                )}
                                {row.visibletype === "Createtablerow" && (
                                  <select
                                    style={{ width: "150px" }}
                                    className="form-select mt-3"
                                    value={this.state.rActions.rtTableName}
                                    name="rtTableName"
                                    required="required"
                                    aria-label="Default select example"
                                    onChange={(e) =>
                                      this.inputtablecreateRChange(e, index)
                                    }
                                    disabled={
                                      this.state.disabledTables[index] || false
                                    }
                                  >
                                    <option defaultValue>
                                      {" "}
                                      select message
                                    </option>
                                    {this.state.tables.map(
                                      (api, index, idx) => (
                                        <option value={api}>{api}</option>
                                      )
                                    )}
                                  </select>
                                )}
                              </div>
                              &nbsp;&nbsp;
                              <div>
                                {/* {row.visibletype === "Createtablerow" && (
                                    <select
                                      style={{ width: "150px" }}
                                      className="form-select mt-3"
                                      aria-label="Default select example"
                                      value={this.state.rActions.rtColumnName}
                                      name="rtColumnName"
                                      required="required"
                                      onChange={(e) =>
                                        this.inputRColumnChange(e, index)
                                      }
                                    >
                                      <option defaultValue hidden>
                                        Column Names
                                      </option>
                                      {this.state.rcolumns.map(
                                        (api, index, idx) => (
                                          <option value={api}>{api}</option>
                                        )
                                      )}
                                    </select>
                                  )} */}
                                {row.visibletype === "CallAPI" && (
                                  <select
                                    style={{ width: "150px" }}
                                    className="form-select mt-3"
                                    value={this.state.rActions.rtApiName}
                                    name="rtApiName"
                                    required="required"
                                    aria-label="Default select example"
                                    onChange={(e) =>
                                      this.inputRColumnChange(e, index)
                                    }
                                  >
                                    <option defaultValue>select Api</option>
                                    {this.state.apis.map((api, index) => (
                                      <option key={api} value={api.aName}>
                                        {api.aName}
                                      </option>
                                    ))}
                                  </select>
                                )}
                              </div>
                              &nbsp;&nbsp;
                              <div>
                                {/* {row.visibletype === "Createtablerow" && (
                                    <CreatableSelect
                                      className="mt-3"
                                      isClearable
                                      options={[
                                        ...this.state.options,
                                        ...this.state.optionsoutput,
                                      ].map((api) => ({
                                        value: api,
                                        label: api,
                                      }))}
                                      value={
                                        this.state.rActions.rtValue
                                          ? {
                                              value:
                                                this.state.rActions.rtValue,
                                              label:
                                                this.state.rActions.rtValue,
                                            }
                                          : null
                                      }
                                      onChange={(selectedOption) =>
                                        this.inputRColumncreateChange(
                                          selectedOption
                                            ? selectedOption.value
                                            : ""
                                        )
                                      }
                                      placeholder="I/O Parameters"
                                    />
                                  )} */}
                                {row.visibletype === "CallAPI" && (
                                  <CreatableSelect
                                    className="mt-3"
                                    isClearable
                                    options={[
                                      ...this.state.options,
                                      ...this.state.optionsoutput,
                                    ].map((api) => ({
                                      value: api,
                                      label: api,
                                    }))}
                                    value={
                                      this.state.rActions.rtApiReqId
                                        ? {
                                          value:
                                            this.state.rActions.rtApiReqId,
                                          label:
                                            this.state.rActions.rtApiReqId,
                                        }
                                        : null
                                    }
                                    onChange={(selectedOption) =>
                                      this.inputRColumnapiChange(
                                        selectedOption
                                          ? selectedOption.value
                                          : ""
                                      )
                                    }
                                    placeholder="I/O Parameters"
                                  />
                                )}
                              </div>
                              &nbsp;&nbsp;
                              <div>
                                {row.visibletype === "CallAPI" && (
                                  <>
                                    <Form.Control
                                      style={{ width: "150px" }}
                                      type="text"
                                      name={"rtApiValue"}
                                      value={this.state.rActions.rtApiValue}
                                      onChange={this.inputChangeupdate}
                                      required="required"
                                      placeholder="Enter Value"
                                      className="form-control mt-3"
                                    />
                                  </>
                                )}
                              </div>
                              &nbsp;&nbsp;
                              <div>
                                {row.visibletype === "SendEmail" && (
                                  <div style={{ display: "flex" }}>
                                    <Button
                                      variant="success"
                                      className="mt-3 bi bi-plus"
                                      onClick={(e) =>
                                        this.addEmailFormsubmitdata(e, index)
                                      }
                                    ></Button>
                                    &nbsp;
                                    <Button
                                      variant="danger"
                                      className="mt-3 bi bi-trash"
                                      onClick={() =>
                                        this.handleDeleteRowRules(index)
                                      }
                                    ></Button>
                                  </div>
                                )}
                                {row.visibletype === "SendSms" && (
                                  <div style={{ display: "flex" }}>
                                    <Button
                                      variant="success"
                                      className="mt-3 bi bi-plus"
                                      onClick={(e) =>
                                        this.addSmsFormsubmitdata(e, index)
                                      }
                                    ></Button>
                                    <Button
                                      variant="danger"
                                      className="mt-3 bi bi-trash"
                                      onClick={() =>
                                        this.handleDeleteRowRules(index)
                                      }
                                    ></Button>
                                  </div>
                                )}
                                {row.visibletype === "CallAPI" && (
                                  <div style={{ display: "flex" }}>
                                    <Button
                                      variant="success"
                                      className="mt-3 bi bi-plus"
                                      onClick={(e) =>
                                        this.addFormsubmitApidata(e, index)
                                      }
                                    ></Button>
                                    &nbsp;
                                    <Button
                                      variant="danger"
                                      className="mt-3 bi bi-trash"
                                      onClick={() =>
                                        this.handleDeleteRowRules(index)
                                      }
                                    ></Button>
                                  </div>
                                )}
                                {row.visibletype === "whatsapp" && (
                                  <div style={{ display: "flex" }}>
                                    <Button
                                      variant="success"
                                      className="mt-3 bi bi-plus"
                                      onClick={(e) =>
                                        this.addFormsubmitdata(e, index)
                                      }
                                    ></Button>
                                    &nbsp;
                                    <Button
                                      variant="danger"
                                      className="mt-3 bi bi-trash"
                                      onClick={() =>
                                        this.handleDeleteRowRules(index)
                                      }
                                    ></Button>
                                  </div>
                                )}
                              </div>
                              &nbsp;&nbsp;
                              <div>
                                {/* {row.visibletype === "Createtablerow" && (
                                    <div style={{ display: "flex" }}>
                                      <Button
                                        variant="success"
                                        className="mt-3 bi bi-plus"
                                        onClick={(e) =>
                                          this.addFormsubmitdata(e, index)
                                        }
                                      ></Button>
                                      &nbsp;
                                      <Button
                                        variant="danger"
                                        className="mt-3 bi bi-trash"
                                        onClick={() =>
                                          this.handleDeleteRowRules(index)
                                        }
                                      ></Button>
                                    </div>
                                  )} */}
                              </div>
                              &nbsp;&nbsp;
                            </div>
                            {row.visibletype === "UpdateTable" && (
                              <div
                                style={{
                                  border: "2px solid white",
                                  padding: "10px",
                                }}
                                className="mt-2"
                              >
                                <Row>
                                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                  {row.visibletype === "UpdateTable" && (
                                    <select
                                      style={{ width: "210px" }}
                                      className="form-select mt-3"
                                      aria-label="Default select example"
                                      value={
                                        this.state.rActions.rtUpdateTableName
                                      }
                                      name="rtUpdateTableName"
                                      required="required"
                                      onChange={(e) =>
                                        this.inputtableRChange(e, index)
                                      }
                                    >
                                      <option defaultValue hidden>
                                        Table Name
                                      </option>
                                      {this.state.tables.map(
                                        (api, index, idx) => (
                                          <option value={api}>{api}</option>
                                        )
                                      )}
                                    </select>
                                  )}
                                </Row>
                                <Row>
                                  <div>
                                    {row.visibletype === "UpdateTable" && (
                                      <p
                                        className="mt-3"
                                        style={{ width: "125px" }}
                                      >
                                        Set
                                      </p>
                                    )}
                                  </div>
                                  <div style={{ display: "flex" }}>
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    <div>
                                      {row.visibletype === "UpdateTable" && (
                                        <>
                                          {this.state.updateSetRows.map(
                                            (row, index) => (
                                              <div
                                                key={row.id}
                                                className="row mt-3"
                                              >
                                                <select
                                                  className="form-select"
                                                  name={`rtUpdatesetcolumn${index > 0 ? index : ""
                                                    }`}
                                                  value={
                                                    row[
                                                    `rtUpdatesetcolumn${index > 0 ? index : ""
                                                    }`
                                                    ] || ""
                                                  }
                                                  onChange={(e) =>
                                                    this.inputsetRColumnChange(
                                                      e,
                                                      index
                                                    )
                                                  }
                                                >
                                                  <option defaultValue hidden>
                                                    Column Names
                                                  </option>
                                                  {this.state.rcolumns.map(
                                                    (api) => (
                                                      <option
                                                        key={api}
                                                        value={api}
                                                      >
                                                        {api}
                                                      </option>
                                                    )
                                                  )}
                                                </select>
                                              </div>
                                            )
                                          )}
                                        </>
                                      )}
                                    </div>
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    <div>
                                      {row.visibletype === "UpdateTable" && (
                                        <>
                                          {this.state.updateSetRows.map(
                                            (row, index) => (
                                              <div
                                                key={row.id}
                                                className="row mt-3"
                                              >
                                                <select
                                                  className="form-select"
                                                  name={`rtUpdateSetOperator${index > 0 ? index : ""
                                                    }`}
                                                  value={
                                                    row[
                                                    `rtUpdateSetOperator${index > 0 ? index : ""
                                                    }`
                                                    ] || ""
                                                  }
                                                  onChange={(e) =>
                                                    this.inputsetRoperatorChange(
                                                      e,
                                                      index
                                                    )
                                                  }
                                                >
                                                  <option defaultValue hidden>
                                                    Operators
                                                  </option>
                                                  <option value="=">=</option>
                                                  <option value="<">
                                                    &lt;
                                                  </option>
                                                  <option value=">">
                                                    &gt;
                                                  </option>
                                                  <option value="<=">
                                                    &le;
                                                  </option>
                                                  <option value=">=">
                                                    &ge;
                                                  </option>
                                                  <option value="Between">
                                                    Between
                                                  </option>
                                                  <option value="Not Between">
                                                    Not Between
                                                  </option>
                                                  <option value="Is Empty">
                                                    Is Empty
                                                  </option>
                                                  <option value="Is Not Empty">
                                                    Is Not Empty
                                                  </option>
                                                </select>
                                              </div>
                                            )
                                          )}
                                        </>
                                      )}
                                    </div>
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    <div>
                                      {row.visibletype === "UpdateTable" && (
                                        <>
                                          {" "}
                                          {this.state.updateSetRows.map(
                                            (row, index) => (
                                              <div
                                                key={row.id}
                                                className="row mt-3"
                                              >
                                                <CreatableSelect
                                                  className="ml-2"
                                                  isClearable
                                                  options={[
                                                    ...this.state.options,
                                                    ...this.state.optionsoutput,
                                                  ].map((api) => ({
                                                    value: api,
                                                    label: api,
                                                  }))}
                                                  value={
                                                    row[
                                                      `rtUpdateValuetwo${index > 0 ? index : ""
                                                      }`
                                                    ]
                                                      ? {
                                                        value:
                                                          row[
                                                          `rtUpdateValuetwo${index > 0
                                                            ? index
                                                            : ""
                                                          }`
                                                          ],
                                                        label:
                                                          row[
                                                          `rtUpdateValuetwo${index > 0
                                                            ? index
                                                            : ""
                                                          }`
                                                          ],
                                                      }
                                                      : null
                                                  }
                                                  onChange={(selectedOption) =>
                                                    this.inputsetRColumnupdateChange(
                                                      selectedOption
                                                        ? selectedOption.value
                                                        : "",
                                                      index
                                                    )
                                                  }
                                                  placeholder="I/O Parameters"
                                                />
                                              </div>
                                            )
                                          )}
                                        </>
                                      )}
                                    </div>
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    <div>
                                      {row.visibletype === "UpdateTable" && (
                                        <>
                                          {" "}
                                          {this.state.updateSetRows.map(
                                            (row, index) => (
                                              <div
                                                key={row.id}
                                                className="row mt-3 align-items-center"
                                              >
                                                <div className="col-9">
                                                  <select
                                                    className="form-select"
                                                    name={`rtUpdateGate${index > 0 ? index : ""
                                                      }`}
                                                    value={
                                                      row[
                                                      `rtUpdateGate${index > 0 ? index : ""
                                                      }`
                                                      ] || ""
                                                    } // Correct key access
                                                    onChange={(e) =>
                                                      this.inputsetRGateupdateChange(
                                                        e,
                                                        index
                                                      )
                                                    }
                                                  >
                                                    <option defaultValue>
                                                      SelectGates
                                                    </option>
                                                    <option value="And">
                                                      And
                                                    </option>
                                                    <option value="END">
                                                      END
                                                    </option>
                                                  </select>
                                                </div>
                                                <div className="col-3">
                                                  <button
                                                    className="btn btn-danger bi bi-trash"
                                                    onClick={() =>
                                                      this.deleteSetRow(index)
                                                    }
                                                  ></button>
                                                </div>
                                              </div>
                                            )
                                          )}
                                        </>
                                      )}
                                    </div>
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    <div>
                                      {" "}
                                      {row.visibletype === "UpdateTable" && (
                                        <div style={{ display: "flex" }}>
                                          &nbsp;
                                          <Button
                                            className="btn btn-primary mt-3 bi bi-plus"
                                            onClick={this.addSetRow}
                                          ></Button>
                                          &nbsp;&nbsp;&nbsp;
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                </Row>
                                <Row>
                                  <div>
                                    {row.visibletype === "UpdateTable" && (
                                      <p
                                        className="mt-3"
                                        style={{ width: "125px" }}
                                      >
                                        Where
                                      </p>
                                    )}
                                  </div>
                                  <div style={{ display: "flex" }}>
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    <div>
                                      {row.visibletype === "UpdateTable" && (
                                        <>
                                          {this.state.updateRows.map(
                                            (row, index) => (
                                              <div
                                                key={row.id}
                                                className="row mt-3"
                                              >
                                                <select
                                                  // className="form-select"
                                                  // name={`rtUpdateColumnName${index}`}
                                                  // value={row.columnName}
                                                  // onChange={(e) =>
                                                  //   this.inputupdateRColumnChange(e, index)
                                                  // }
                                                  className="form-select"
                                                  name={`rtUpdateColumnName${index > 0 ? index : ""
                                                    }`}
                                                  value={
                                                    row[
                                                    `rtUpdateColumnName${index > 0 ? index : ""
                                                    }`
                                                    ] || ""
                                                  }
                                                  onChange={(e) =>
                                                    this.inputupdateRColumnChange(
                                                      e,
                                                      index
                                                    )
                                                  }
                                                >
                                                  <option defaultValue hidden>
                                                    Column Names
                                                  </option>
                                                  {this.state.rcolumns.map(
                                                    (api) => (
                                                      <option
                                                        key={api}
                                                        value={api}
                                                      >
                                                        {api}
                                                      </option>
                                                    )
                                                  )}
                                                </select>
                                              </div>
                                            )
                                          )}
                                        </>
                                      )}
                                    </div>
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    <div>
                                      {row.visibletype === "UpdateTable" && (
                                        <>
                                          {this.state.updateRows.map(
                                            (row, index) => (
                                              <div
                                                key={row.id}
                                                className="row mt-3"
                                              >
                                                <select
                                                  className="form-select"
                                                  name={`rtUpdateOperator${index > 0 ? index : ""
                                                    }`}
                                                  value={
                                                    row[
                                                    `rtUpdateOperator${index > 0 ? index : ""
                                                    }`
                                                    ] || ""
                                                  }
                                                  onChange={(e) =>
                                                    this.inputupdateRoperatorChange(
                                                      e,
                                                      index
                                                    )
                                                  }
                                                >
                                                  <option defaultValue hidden>
                                                    Operators
                                                  </option>
                                                  <option value="=">=</option>
                                                  <option value="<">
                                                    &lt;
                                                  </option>
                                                  <option value=">">
                                                    &gt;
                                                  </option>
                                                  <option value="<=">
                                                    &le;
                                                  </option>
                                                  <option value=">=">
                                                    &ge;
                                                  </option>
                                                  <option value="Between">
                                                    Between
                                                  </option>
                                                  <option value="Not Between">
                                                    Not Between
                                                  </option>
                                                  <option value="Is Empty">
                                                    Is Empty
                                                  </option>
                                                  <option value="Is Not Empty">
                                                    Is Not Empty
                                                  </option>
                                                </select>
                                              </div>
                                            )
                                          )}
                                        </>
                                      )}
                                    </div>
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    <div>
                                      {row.visibletype === "UpdateTable" && (
                                        <>
                                          {this.state.updateRows.map(
                                            (row, index) => (
                                              <div
                                                key={row.id}
                                                className="row mt-3 align-items-center"
                                              >
                                                {/* Column for Select Input */}
                                                <div className="col-9">
                                                  <CreatableSelect
                                                    className="ml-2"
                                                    isClearable
                                                    options={[
                                                      ...this.state.options,
                                                      ...this.state
                                                        .optionsoutput,
                                                    ].map((api) => ({
                                                      value: api,
                                                      label: api,
                                                    }))}
                                                    value={
                                                      row[
                                                        `rtUpdateValue${index > 0 ? index : ""
                                                        }`
                                                      ]
                                                        ? {
                                                          value:
                                                            row[
                                                            `rtUpdateValue${index > 0
                                                              ? index
                                                              : ""
                                                            }`
                                                            ],
                                                          label:
                                                            row[
                                                            `rtUpdateValue${index > 0
                                                              ? index
                                                              : ""
                                                            }`
                                                            ],
                                                        }
                                                        : null
                                                    }
                                                    onChange={(
                                                      selectedOption
                                                    ) =>
                                                      this.inputRColumnupdateChange(
                                                        selectedOption
                                                          ? selectedOption.value
                                                          : "",
                                                        index
                                                      )
                                                    }
                                                    placeholder="I/O Parameters"
                                                  />
                                                </div>

                                                {/* Column for Delete Button with small spacing */}
                                                <div className="col-3">
                                                  <button
                                                    className="btn btn-danger bi bi-trash"
                                                    onClick={() =>
                                                      this.deleteRow(index)
                                                    }
                                                  ></button>
                                                </div>
                                              </div>
                                            )
                                          )}
                                        </>
                                      )}
                                    </div>
                                    &nbsp;&nbsp;&nbsp;
                                    <div>
                                      {" "}
                                      {row.visibletype === "UpdateTable" && (
                                        <div style={{ display: "flex" }}>
                                          &nbsp;
                                          <Button
                                            className="btn btn-primary mt-3 bi bi-plus"
                                            onClick={this.addRow}
                                          ></Button>
                                          &nbsp;&nbsp;&nbsp;
                                          <Button
                                            variant="success"
                                            className="mt-3 bi bi-plus"
                                            onClick={(e) =>
                                              this.addUpdateFormsubmitdata(
                                                e,
                                                index
                                              )
                                            }
                                          >
                                            Add
                                          </Button>
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                </Row>
                              </div>
                            )}
                            <br />
                            <Row style={{ marginTop: "20px" }}>
                              {row.visibletype === "Createtablerow" && (
                                <table className="table table-bordered table-hover">
                                  <thead>
                                    <tr>
                                      <th className="text-center">S.NO</th>
                                      <th className="text-center">
                                        Action Type
                                      </th>
                                      <th className="text-center">
                                        Table Names
                                      </th>
                                      <th className="text-center">
                                        Column Names
                                      </th>
                                      <th className="text-center">Value</th>
                                      <th className="text-center">Actions</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {row.actions && row.actions.length > 0 ? (
                                      row.actions.map((action, actionIndex) => (
                                        <tr key={action.tableId}>
                                          <td>{actionIndex + 1}</td>
                                          <td>{row.rtType}</td>
                                          <td>{action.rtTableName}</td>
                                          <td>{action.rtColumnName}</td>
                                          <td>
                                            {/* Make the Value cell editable with CreatableSelect */}
                                            <CreatableSelect
                                              className="w-100"
                                              isClearable
                                              options={[
                                                ...this.state.options,
                                                ...this.state.optionsoutput,
                                              ].map((api) => ({
                                                value: api,
                                                label: api,
                                              }))}
                                              value={
                                                action.rtValue
                                                  ? {
                                                    value: action.rtValue,
                                                    label: action.rtValue,
                                                  }
                                                  : null
                                              }
                                              // onChange={(selectedOption) =>
                                              //   this.inputRColumncreateChange(
                                              //     selectedOption ? selectedOption.value : "",
                                              //     index,
                                              //     actionIndex
                                              //   )
                                              // }
                                              onChange={(selectedOption) => {
                                                // Create a copy of rulescondition to avoid modifying state directly
                                                const updatedRulescondition = [
                                                  ...this.state.rulescondition,
                                                ];

                                                // Update just this specific action's rtValue
                                                if (
                                                  updatedRulescondition[
                                                  index
                                                  ] &&
                                                  updatedRulescondition[index]
                                                    .actions &&
                                                  updatedRulescondition[index]
                                                    .actions[actionIndex]
                                                ) {
                                                  updatedRulescondition[
                                                    index
                                                  ].actions[
                                                    actionIndex
                                                  ].rtValue = selectedOption
                                                      ? selectedOption.value
                                                      : "";

                                                  // Update state with modified copy
                                                  this.setState({
                                                    rulescondition:
                                                      updatedRulescondition,
                                                  });
                                                }
                                              }}
                                              placeholder="I/O Parameters"
                                            />
                                          </td>
                                          <td>
                                            <Button
                                              variant="danger"
                                              className="bi bi-trash-fill"
                                              onClick={() =>
                                                this.handleRemoveSpecificcreatetableSAction(
                                                  index,
                                                  action.tableId
                                                )
                                              }
                                            ></Button>
                                          </td>
                                        </tr>
                                      ))
                                    ) : (
                                      <tr>
                                        <td colSpan="6">No Records</td>
                                      </tr>
                                    )}
                                  </tbody>
                                </table>
                              )}
                              {row.visibletype === "SendEmail" && (
                                <div>
                                  <br />
                                  {row.selectedVariables &&
                                    row.selectedVariables.length > 0 && (
                                      <table className="table table-bordered table-hover mt-3">
                                        <thead>
                                          <tr>
                                            <th>S.NO</th>
                                            <th>Email Parameters</th>
                                            <th>Rule Parameters</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {row.selectedVariables.map(
                                            (variable, idx) => (
                                              <tr key={idx}>
                                                <td>{idx + 1}</td>
                                                <td>{variable}</td>
                                                <td>
                                                  <select
                                                    className="form-select"
                                                    name="rtemailParams"
                                                    value={
                                                      row.rtemailParams?.[
                                                      variable
                                                      ] || ""
                                                    }
                                                    required="required"
                                                    aria-label="Default select example"
                                                    onChange={(e) =>
                                                      this.inputtableRChangeEmail(
                                                        e,
                                                        index,
                                                        variable
                                                      )
                                                    }
                                                  >
                                                    <option defaultValue>
                                                      Select Parameter
                                                    </option>
                                                    {[
                                                      ...this.state.options,
                                                      ...this.state
                                                        .optionsoutput,
                                                    ].map((api, index) => (
                                                      <option
                                                        key={index}
                                                        value={api}
                                                      >
                                                        {api}
                                                      </option>
                                                    ))}
                                                  </select>
                                                </td>
                                              </tr>
                                            )
                                          )}
                                        </tbody>
                                      </table>
                                    )}
                                </div>
                              )}
                              {row.visibletype === "UpdateTable" && (
                                <table className="table table-bordered table-hover">
                                  <thead>
                                    <tr>
                                      <th className="text-center">S.NO</th>
                                      <th className="text-center">
                                        Action Type
                                      </th>
                                      <th className="text-center">
                                        Table Name
                                      </th>
                                      <th className="text-center">
                                        Set Column
                                      </th>
                                      <th className="text-center">Operator</th>
                                      <th className="text-center">
                                        I/O params
                                      </th>
                                      <th className="text-center">Gate</th>
                                      <th className="text-center">
                                        Where column
                                      </th>
                                      <th className="text-center">
                                        I/P Params
                                      </th>
                                      <th className="text-center">Operators</th>
                                      <th className="text-center">Actions</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {row.updateactions &&
                                      row.updateactions.length > 0 ? (
                                      row.updateactions.map(
                                        (action, actionIndex) => (
                                          <tr key={action.tableId}>
                                            <td>{actionIndex + 1}</td>
                                            <td>{row.rtType}</td>
                                            <td>{action.rtUpdateTableName}</td>
                                            <td>{action.rtUpdatesetcolumn}</td>
                                            <td>
                                              {action.rtUpdateSetOperator}
                                            </td>
                                            <td>{action.rtUpdateGate}</td>
                                            <td>{action.rtUpdateColumnName}</td>
                                            <td>{action.rtUpdateValuetwo}</td>
                                            <td>{action.rtUpdateOperator}</td>
                                            <td>
                                              <Button
                                                variant="danger"
                                                className="bi bi-trash-fill"
                                                onClick={() =>
                                                  this.handleUpdateRemoveSpecific(
                                                    index,
                                                    action.tableId
                                                  )
                                                }
                                              ></Button>
                                            </td>
                                          </tr>
                                        )
                                      )
                                    ) : (
                                      <tr>
                                        <td colSpan="9"> No Records</td>
                                      </tr>
                                    )}
                                  </tbody>
                                </table>
                              )}
                              {row.visibletype === "SendSms" && (
                                <div>
                                  <div>
                                    <Row>
                                      <Col lg="4" md="4">
                                        <select
                                          className="form-select"
                                          value={this.state.rActions.rtsmsName}
                                          name="rtsmsName"
                                          onChange={this.inputRColumnChange}
                                        >
                                          <option defaultValue>Select</option>
                                          {this.state.tables.map(
                                            (api, index, idx) => (
                                              <option key={index} value={api}>
                                                {api}
                                              </option>
                                            )
                                          )}
                                        </select>
                                      </Col>
                                    </Row>
                                  </div>
                                  <br />
                                  {row.selectedSmsVariables &&
                                    row.selectedSmsVariables.length > 0 && (
                                      <table className="table table-bordered table-hover mt-3">
                                        <thead>
                                          <tr>
                                            <th>S.NO</th>
                                            <th>SMS Parameters</th>
                                            <th>Rule Parameters</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {row.selectedSmsVariables.map(
                                            (variable, idx) => (
                                              <tr key={idx}>
                                                <td>{idx + 1}</td>
                                                <td>{variable}</td>
                                                <td>
                                                  <select
                                                    className="form-select"
                                                    name="rtsmsparams"
                                                    value={
                                                      row.rtsmsparams?.[
                                                      variable
                                                      ] || ""
                                                    }
                                                    required
                                                    aria-label="Default select example"
                                                    onChange={(e) =>
                                                      this.inputtableRChangeSms(
                                                        e,
                                                        index,
                                                        variable
                                                      )
                                                    }
                                                  >
                                                    <option defaultValue>
                                                      Select Parameter
                                                    </option>
                                                    {[
                                                      ...this.state.options,
                                                      ...this.state
                                                        .optionsoutput,
                                                    ].map((api, index) => (
                                                      <option
                                                        key={index}
                                                        value={api}
                                                      >
                                                        {api}
                                                      </option>
                                                    ))}
                                                  </select>
                                                </td>
                                              </tr>
                                            )
                                          )}
                                        </tbody>
                                      </table>
                                    )}
                                </div>
                              )}
                              {row.visibletype === "CallAPI" && (
                                <table className="table table-bordered table-hover">
                                  <thead>
                                    <tr>
                                      <th className="text-center">S.NO</th>
                                      <th className="text-center">
                                        Action Type
                                      </th>
                                      <th className="text-center">
                                        Integration Type
                                      </th>
                                      <th className="text-center">Api Type</th>
                                      <th className="text-center">
                                        Request Id
                                      </th>
                                      <th className="text-center">Value</th>
                                      <th className="text-center">Actions</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {row.apiactions &&
                                      row.apiactions.length > 0 ? (
                                      row.apiactions.map(
                                        (action, actionIndex) => (
                                          <tr key={action.tableId}>
                                            <td>{actionIndex + 1}</td>
                                            <td>{row.rtType}</td>
                                            <td>{action.rtApiTemplate}</td>
                                            <td>{action.rtApiName}</td>
                                            <td>{action.rtApiReqId}</td>
                                            <td>{action.rtApiValue}</td>
                                            <td>
                                              <Button
                                                variant="danger"
                                                className="bi bi-trash-fill"
                                                onClick={() =>
                                                  this.handleCallapiRemoveSpecific(
                                                    index,
                                                    action.tableId
                                                  )
                                                }
                                              // idx={idx}
                                              ></Button>
                                            </td>
                                          </tr>
                                        )
                                      )
                                    ) : (
                                      <tr>
                                        <td colSpan="9"> No Records</td>
                                      </tr>
                                    )}
                                  </tbody>
                                </table>
                              )}
                              {row.visibletype === "whatsapp" && (
                                <div>
                                  <div>
                                    <Row>
                                      <Col lg="3">
                                        <select
                                          className="form-select"
                                          value={DefaultData.tableName}
                                          name="tableName"
                                          onChange={this.inputRColumnChange}
                                        >
                                          <option defaultValue>Select</option>
                                          {this.state.options.map(
                                            (api, index, idx) => (
                                              <option key={index} value={api}>
                                                {api}
                                              </option>
                                            )
                                          )}
                                        </select>
                                      </Col>
                                    </Row>
                                  </div>
                                  <br />
                                  <table className="table table-bordered table-hover">
                                    <thead>
                                      <tr>
                                        <th className="text-center">S.NO</th>
                                        <th className="text-center">
                                          Whatsap paramsters
                                        </th>
                                        <th className="text-center">
                                          Rules Parameters
                                        </th>
                                        <th className="text-center">Text</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {this.state.whatsapactions.map(
                                        (action, index, idx) => (
                                          <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>{row.rtTemplate}</td>
                                            <td>
                                              <select
                                                className="form-select"
                                                value={row.rtTemplate}
                                                name="rtTemplate"
                                                required="required"
                                                aria-label="Default select example"
                                                onChange={(e) =>
                                                  this.inputtableRChange(
                                                    e,
                                                    index
                                                  )
                                                }
                                              >
                                                <option defaultValue>
                                                  Select Parameter
                                                </option>
                                                {[
                                                  ...this.state.options,
                                                  ...this.state.optionsoutput,
                                                ].map((api, index) => (
                                                  <option
                                                    key={index}
                                                    value={api}
                                                  >
                                                    {api}
                                                  </option>
                                                ))}
                                              </select>
                                            </td>
                                            <td>
                                              <Form.Control
                                                name={"rvame"}
                                                value={DefaultData.rVame}
                                                onChange={this.inputChange}
                                                required="required"
                                                type="text"
                                                placeholder="Enter Text"
                                                className="form-control"
                                              />
                                            </td>
                                          </tr>
                                        )
                                      )}
                                    </tbody>
                                  </table>
                                </div>
                              )}
                            </Row>
                            <hr />
                          </>
                        ))}
                      </Row>
                    </Row>
                    <Row>
                      <Col
                        className="d-flex justify-content-end"
                        style={{ marginRight: "50px" }}
                      >
                        <Button
                          className="button"
                          variant="success"
                          onClick={this.RulesdefupdateHandler}
                          style={{
                            borderRadius: "0px",
                            marginTop: "20px",
                          }}
                        >
                          Update
                        </Button>
                      </Col>
                    </Row>
                  </Container>
                </Offcanvas.Body>
              </Offcanvas>
            )}
          </div>
          <br />
          <div style={{ marginRight: "5px" }}>
            {/* searchbar,pagination,filter */}
            <input
              style={{ float: "left", marginBottom: "10px" }}
              type="text"
              onChange={this.handleFilter}
              placeholder="Search..."
            />
            <DataTable
              data={paginatedData}
              columns={this.state.tableClms}
              pagination
              paginationServer
              paginationTotalRows={
                this.state.filteredData
                  ? this.state.filteredData.length
                  : this.state.rules.length
              }
              onChangeRowsPerPage={this.handlePerRowsChange}
              onChangePage={this.handlePageChange}
              paginationRowsPerPageOptions={[100, 200, 300, 400, 500, 600, 700, 800, 900, 1000]}
              paginationPerPage={100}
              keyField="id"
              paginationRowsPerPageOptions={[
                10, 20, 30, 50, 60, 70, 80, 90, 100,
              ]}
              className="table table-striped table-bordered dataTable no-footer employeesTableIcons"
            />
          </div>
        </div>
      </div>
    );
  }
}
